import { FaBacteria } from "react-icons/fa6";
import { CiMedicalCross, CiMedicalMask } from "react-icons/ci";
import { LuSunMedium } from "react-icons/lu";

const CategoriesData = [
    {
        id: 1,
        Category: "Psychology",
        cover: require("../../Assets/CategoryPage/Sports-psychology.jpg"),
        banners: require("../../Assets/CategoryPage/Sports-psychology.jpg"),
        link: "pukhya/psychology",
        subcategories: [


            {
                id: 1,
                subcategory: "Thought Technology ",
                title: "– Global Leader in Biofeedback & Psychophysiological Instruments",
                subtitle: "✅ Clinical & Therapeutic Applications",
                subdesc: "Thought Technology’s equipment is widely used in clinical assessments and therapeutic treatments for:",


                bulletPoints17st: [
                    "Stress-related disorders",
                    "Anxiety and pain management ",
                    "Pelvic floor dysfunction and incontinence therapy",
                    "Muscle rehabilitation with sEMG-triggered stimulation",

                ],
                subpragraph: "These tools are vital for healthcare professionals who require accurate, non-invasive monitoring of neuromuscular and autonomic functions.",
                headingth: "🧪Science & Research Applications",
                subtitleth: "Beyond medical use, Thought Technology’s Science Division supports applications in:",
                bulletPoints23th: ["Ergonomics & Human Factors Research", "Sports Science & Athletic Training", "Educational & Cognitive Research"],
                pragraphth1: "Their high-precision systems are ideal wherever sensitive psychophysiological monitoring and biofeedback are essential.",
                subtitleth2: "🔍 Commonly Measured Signals Include:",
                bulletPoints23th1: ["Surface Electromyography (sEMG)", "Electroencephalography (EEG)", "Electrocardiography (EKG)", "Skin Conductance (GSR)", "Temperature", "Blood Volume Pulse (BVP)", "Respiration", "Inclination, Pressure, and Bend Sensors"],
                description: "Thought Technology Ltd. is the world’s leading manufacturer of biofeedback and psychophysiological monitoring instruments. Trusted by professionals worldwide, their advanced systems monitor, record, analyze, and provide real-time feedback on a wide range of physiological and mechanical signals — using intuitive visual and auditory outputs.",
                cover: require("../../Assets/Products/Psychology/thoughttecm.png"),
                brand: require("../../Assets/Products/Psychology/thoughttec-brand.png"),
                backcolor: "#2E8E91",

                Products: [
                    {
                        id: 1,
                        title: "Biofeedback",
                        title2: "Biofeedback Expert System",
                        titleb: "Experience the Most Comprehensive Physiological Monitoring and Biofeedback System",
                        cover: require("../../Assets/Products/Psychology/Bio_Experts.jpg"),
                        description: "Gain unparalleled insights into your clients’ stress and relaxation responses with our advanced physiological monitoring and multimedia biofeedback system. The ProComp Infiniti stands out as the most versatile and complete solution, ideal for clinical, research, and institutional settings.",
                        headingb: "Unlock a Broad Spectrum of Physiological Data",
                        pragraphb1: "The ProComp Infiniti allows for classic biofeedback with up to 8 channels of real-time physiological data, including:",
                        bulletPointsb: ["Skin conductance (galvanic response)", "Peripheral temperature", "Heart rate variability (HRV)", "Respiration rate and waveform", "Muscle tension (EMG)"],
                        pragraphb2: "Enhance your neurofeedback capabilities with 1 or 2 channels of neurofeedback and passive infrared (pIR) sensors for frontal lobe activation monitoring—making this package the most adaptable on the market.",
                        description2: "",
                        headingb2: "The Complete System",
                        pragraphb3: "This top-tier biofeedback solution combines the robust ProComp Infiniti 8-channel encoder with a comprehensive array of sensors, powered by BioGraph Infiniti and the 360 Suite. A smart choice for universities, hospitals, and private clinics seeking an extensive range of psychophysiological tools.",

                        headingb3: "ProComp Infiniti 8-Channel Encoder",
                        pragraphb4: "The T7500M ProComp Infiniti is a versatile, multi-modality encoder that connects effortlessly to your Windows PC via USB. Designed to support real-time, computerized biofeedback and data collection, it also features options for data storage via Compact Flash card or wireless telemetry for flexible recording.",
                        headingb4: "Key Features:",
                        bulletPointsb1: ["Supports full-range physiological signals including EEG, EMG, EKG, skin conductance, temperature, BVP, and more.", "Two channels deliver ultra-high fidelity signals (2048 samples/sec) for detailed RAW data.", "Six remaining channels operate at 256 samples/sec, compatible with various sensors.", "Internal calibration ensures top-quality signals without downtime."],
                        headingb5: "Sensors & Accessories",
                        headingb6: "Skin Conductance Sensor (SA9309M)",
                        pragraphb5: "Measures galvanic skin response at fingers or toes. Pack includes two finger bands.",
                        headingb7: "Temperature Sensor (SA9310M)",
                        pragraphb7: "Monitors skin surface temperature between 10°C–45°C (50°F–115°F) with easy clip-on self-adhesive band.",
                        headingb8: "Respiration Sensor (SA9311M)",
                        pragraphb8: "Captures respiration rate, waveform, and amplitude with a durable, user-friendly girth sensor. Wear thoracically or abdominally, over clothing.",
                        headingb9: "Blood Volume Pulse (BVP) & EKG Sensors",
                        bulletPointsb2: ["BVP Sensor (T9306M): PPG sensor for heart rate, amplitude, waveform, and HRV feedback.", "EKG Sensor: Measures electrical activity of the heart for detailed cardiac data."],

                        headingb10: "EMG MyoScan Sensor (T9503M)",
                        pragraphb10: "Pre-amplified surface EMG sensor for muscle tension analysis, compatible with multiple electrode types.",

                        headingb11: "EEG Sensors (T9503Z)",
                        pragraphb11: "Pre-amplified EEG sensors with impedance checking, ensuring consistent, high-quality setups every time.",

                        headingb12: "pIR Headgear (T2600)",
                        pragraphb12: "Lightweight, ergonomic headgear equipped with dual passive infrared sensors for stable, reliable frontal lobe activity monitoring.",
                        headingb13: "Your Practice with Cutting-Edge Biofeedback Technology",
                        pragraphb13: "Whether you're conducting clinical therapy, research, or training, the ProComp Infiniti system provides the tools and flexibility you need to achieve detailed physiological insights and effective biofeedback sessions.",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=EWDSJMBS_yo", "https://www.youtube.com/watch?app=desktop&v=YcDC_4vn3OQ"
                        ],
                        companyLink1: "https://thoughttechnology.com/biofeedback-expert-system-360/",
                        buttons1: "VISIT THE COMPANY WEBSITE ",


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/biofeedbackfet.jpg"),
                                linkname: "Thought tec",
                                link: "https://thoughttechnology.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/biofedback h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/biofedback h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "Neurofeedback Expert System",
                        title2: "Advanced Neurofeedback and Brainwave Training Systems",
                        cover: require("../../Assets/Products/Psychology/Neuro_Expert.jpg"),
                        description: "Our neurofeedback systems, like ProComp Infiniti and EEGer, offer powerful tools for monitoring and training brainwaves. They help clinicians improve self-regulation in conditions such as ADHD, anxiety, and PTSD by teaching clients to modify their brain activity using real-time feedback.",
                        description2: "",
                        headingn1: "ProComp Infiniti",
                        // pragraphb1: "The ProComp Infiniti allows for classic biofeedback with up to 8 channels of real-time physiological data, including:",
                        bulletPointsn1: ["Features: 8-channel encoder with EEG, pIR HEG, and physiological sensors (heart rate, skin conductance, etc.).", "Connectivity: Connects to a PC for real-time data and biofeedback training.", "Includes: BioGraph Infiniti Software and the 360 Suite, combining physiological, HRV, and neurofeedback protocols.", "Respiration rate and waveform", "Muscle tension (EMG)"],

                        headingn2: "Sensors & Accessories",

                        bulletPointsn2: ["Skin Conductance : Measures galvanic response (fingers/toes).", "Temperature: Skin surface temperature (10°C–45°C).", "Respiration: Thoracic or abdominal breathing monitor.", "Heart Rate/EKG: Blood volume pulse (BVP) and EKG sensors.", "EMG: Muscle tension monitoring.", "EEG: High-quality sensors with impedance checking.", "pIR Headgear: Provides stable, accurate frontal lobe activity measurement."],
                        headingn3: "Applications",
                        pragraphn3: "Ideal for universities, hospitals, and clinics, these systems enable comprehensive psychophysiological assessments and training to optimize health and well-being.",
                        videoLinks1: [
                            "https://youtu.be/keMbk7uPPA0"
                        ],
                        companyLink1: "https://thoughttechnology.com/neurofeedback-expert-system/",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/biofeedbackfet.jpg"),
                                linkname: "Thought tec",
                                link: "https://thoughttechnology.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/nero h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/nero h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "HRV Expert System",
                        title2: "Heart Rate Variability (HRV): A Bridge Between Body and Mind",
                        cover: require("../../Assets/Products/Psychology/HRV_Suites.jpg"),
                        description: "HRV is a vital biomarker that reflects the balance of your autonomic nervous system (ANS) and overall health. It serves as a powerful tool in both biofeedback and neurofeedback applications, helping individuals manage stress, improve emotional regulation, and boost resilience.",
                        description2: "",
                        headingn1: "Why HRV Matters",
                        // pragraphb1: "The ProComp Infiniti allows for classic biofeedback with up to 8 channels of real-time physiological data, including:",
                        bulletPointsn1: ["Indicator of Health: High HRV signifies a well-regulated stress response and resilience, while low HRV is linked to chronic stress, burnout, and health risks.", "Biofeedback & Neurofeedback: HRV training teaches control over physiological responses like relaxation, stress reduction, and emotional balance. In neurofeedback, HRV complements brainwave training by enhancing focus, decision-making, and resilience."],

                        headingn2: "Key Benefits",

                        bulletPointsn2: ["Real-Time Feedback: Instant data allows users to adjust breathing, mindfulness, or relaxation techniques for optimal results.", "Health Improvements: Supports cardiovascular health, lowers blood pressure, boosts immune function, and enhances athletic recovery and endurance.", "Mental Performance: Strong HRV correlates with improved prefrontal cortex activity, improving planning, decision-making, and emotional regulation."],
                        headingn3: "Clinical Applications",
                        pragraphn3: "HRV is central to treating PTSD, ADHD, insomnia, and chronic fatigue by restoring autonomic balance and promoting mental clarity.Harness the power of HRV to optimize both your physical health and mental well-being.",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=HVkDv8guVik"
                        ],
                        companyLink1: "https://thoughttechnology.com/hrv-expert-system/",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/HRV_Suite fet.jpg"),
                                linkname: "Thought tec",
                                link: "https://thoughttechnology.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/HRV_Suite h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/bannerss.jpg"),
                            },
                        ],
                    },
                    {
                        id: 5,
                        title: "Peak Performance Expert Package",
                        cover: require("../../Assets/Products/Psychology/PeakPerformance.jpg"),
                        description: "Designed for advanced practitioners, our Peak Performance Package offers comprehensive software and hardware to train athletes’ psychophysiology and bridge mind and body for peak performance.",
                        description2: "",
                        headingn1: "What's Included:",
                        // pragraphb1: "The ProComp Infiniti allows for classic biofeedback with up to 8 channels of real-time physiological data, including:",
                        bulletPointsn1: ["ProComp Infiniti Encoder: An 8-channel, multi-modality device for real-time biofeedback and data logging via USB, with optional long-range telemetry.", "BioGraph Infiniti Software: The core platform for capturing, analyzing, and visualizing physiological data."],

                        headingn2pe: "Specialized Suites:",

                        bulletPointsn2pe: ["Peak Performance Suite: Tools to enhance decision-making, consistency, and micro-adjustments.", "Reaction Time Suite: Connects reaction data with EEG, EMG, and physiological responses for precise performance analysis.", "CardioPro Infiniti Module: Advanced HRV analysis for optimizing cardiovascular and autonomic function."],

                        headingn2p: "Sensors & Accessories:",

                        bulletPointsn2p: ["Skin conductance, temperature, respiration, BVP/EKG, EMG, EEG sensors.", "Electrodes for sensitive and extended placement.", "Additional tools like EMG headbands, wireless transmission options, and synchronization devices."],

                        videoLinks1: [
                            "https://www.youtube.com/watch?v=uZL6uQG-t4w"
                        ],
                        companyLink1: "https://thoughttechnology.com/peak-performance-expert-system/",
                        buttons1: "VISIT THE COMPANY WEBSITE ",


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/Peak Performance fet.png"),
                                linkname: "Thought tec",
                                link: "https://thoughttechnology.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/peakbanners2.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/peakbanners.jpg"),
                            },
                        ],
                    },
                    {
                        id: 6,
                        title: "HEG Neuro",
                        title01: "Background on HEG Training",
                        cover: require("../../Assets/Products/Psychology/Products/section-image-HEG-neuro.jpg"),
                        description: "HEG (Hemo-Encephalography) uses red/infrared light to measure blood flow in the forehead, indicating oxygen supply and brain activity. When a brain area activates, blood flow increases to deliver energy and nutrients, enhancing performance. ",
                        description2: "HEG biofeedback trains clients to consciously control this blood flow, improving attention, focus, and impulse control—especially effective for kids and adults with ADHD or ADD.",
                        description3: "Unique in its simplicity, HEG sensors are quick to apply and free of EEG disturbances, making sessions faster and easier. Beyond ADHD, HEG benefits headache relief, depression, and boosting mental performance, concentration, and mood in everyday life.",
                        description4: "Manufactured by MediTECH, the HEG Neurobalance system improves focus, relaxation, and cognitive function by training brain blood flow and energy use through real-time biofeedback.",
                        headingb: "Key Highlights:",
                        bulletPointsb: ["HEG Technology : Monitors brain blood flow, oxygen, and nutrients to enhance brain performance.", "Biofeedback Training : Uses visual and auditory cues to help users regulate brain activity."],
                        stpragraph: "Applications: ",
                        stpragh: "Boosts focus, reduces stress, supports learning, and can be combined with balance training.",
                        headingb3: "Integration & Use",
                        pragraphb4: "Compatible with MediTECH’sBioGraph Infiniti and Body & Mind apps, and suitable for professionals conducting comprehensive neurofeedback assessments.",

                        stpragraph1: "Combined Training:",
                        stpragh2: ["The Body & Mind app allows for the integration of HEG and TPS feedback, providing a comprehensive approach to focus training.", "This combined approach can be particularly beneficial for individuals seeking to manage stress while enhancing their ability to concentrate. "],

                        headingb5: "Want targeted focus training?",
                        headingb6: "Focus Training with HEG and TPS",
                        pragraphb5: "Enhance attention and relaxation using neurofeedback and biofeedback. HEG (Hemoencephalography) with NIRS monitors blood flow in the forehead to improve concentration and calmness. TPS (Triple Physiological Sensor) measures heart rate variability, skin conductance, and temperature to help manage stress and boost focus. The Body & Mind app allows for combined or separate training sessions with both HEG and TPS, tailoring your focus enhancement experience.",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=_iPDIV4QyMA"
                        ],
                        companyLink1: "https://www.meditech.de/en_US/focus?srsltid=AfmBOooC7kHHqQ-nIztknbjv7yWz7PTf6npeIwyWM8Oqnd8tAVAIIX-G",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/Neuro balance system fet.jpg"),
                                linkname: "Thought tec",
                                link: "https://thoughttechnology.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/hur h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/hur h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 4,
                        title: "MediBalance Pro",
                        title0: "Balance & Vertigo Solutions with MediBalance Pro | Analysis. Training. Evaluation.All in one system.",
                        cover: require("../../Assets/Products/Psychology/Products/bodyandmindrealaxsys.jpg"),
                        description: "Many people take their sense of balance for granted, but up to 36% of women and 22% of men experience dizziness and vertigo, especially over age 80—where it is the leading impair­ment. Medical consultations often confirm vertigo but may not offer a targeted solution beyond common diagnoses like BPPV.",
                        description2: "Our MediBalance Pro system precisely measures and analyzes posture and balance, evaluating the vestibular, visual, and somatosensory systems. A simple 4- to 12-step protocol helps identify how these systems influence stability and fall risk.",
                        description3: "Based on this assessment, tailored training programs can help your clients improve posture, body awareness, and regain confidence in their balance, reducing fall risk and enhancing quality of life.",
                        stpragraph: "MediBalance PRO Sports Edition ",
                        stpragh: "The MediBalance Pro Sport Edition offers precise balance and coordination testing, providing detailed analysis of peak performance and stability under various conditions. It also includes targeted training to enhance these skills.",
                        stpragh3: "The system records measurement data during sessions and displays results graphically and statistically. It evaluates coordination with open and closed eyes for objective assessment.",
                        stpragh4: "With six interactive screens, the training improves balance, body awareness, and motor coordination. All data and results are stored for easy evaluation and client progress tracking.",

                        videoLinks1: [
                            "https://www.youtube.com/watch?v=uOObkl0Lrr0", "https://www.youtube.com/watch?v=_F7OV82TVdk"
                        ],
                        companyLink1: "https://www.meditech.de/en_US/medibalancepro?srsltid=AfmBOor3OiGwqO3JHllFo8FXwsoieL3g-8lCo2ycJNY6GeeXAF_f-xIe",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/bodyandmindrealaxsys fet.jpg"),
                                linkname: "Thought tec",
                                link: "https://thoughttechnology.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/hur h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/meditations.jpg"),
                            },
                        ],
                    },

                ]
            },
            {
                id: 2,
                subcategory: "Neurotracker X",
                title: "",
                subtitle: "",
                subdesc: "NeuroTracker really is for everyone! It has been shown to improve many high level cognitive functions, which means it can become a crucial habit for all.It has been proven to enhance various high-level cognitive functions, making it a valuable habit for everyone.",
                description: "NeuroTrackerX is a patented system rooted in 20 years of neuroscience research, utilizing 3D multiple object tracking (MOT) to boost brain efficiency. It aims to enhance situational awareness, attention, executive function, and cognitive stamina.",
                cover: require("../../Assets/Products/Psychology/Products/NeuroTracker.jpg"),
                brand: require("../../Assets/Products/Psychology/neurtrakerlogo.png"),
                backcolor: "#5948be",

                subtitle17svt: "How it Works",
                bulletPoints17st: [
                    "Presents users with dynamic targets moving in 3D space.",
                    "Adapts in real-time, increasing in speed and complexity based on your progress.",
                    "Short sessions, typically around 6 minutes.",
                    "Compatible across platforms—computers, tablets, TVs—with options for 2D or immersive 3D experiences using Anaglyph glasses or Active 3D setups.",

                ],
                Products: [
                    {
                        id: 2,
                        title: "NeuroTracker ",
                        title2: "Science-Backed Cognitive Enhancement",
                        cover: require("../../Assets/Products/Psychology/Products/NCogniSens h2.png"),
                        description: "NeuroTracker is a cutting-edge brain training system leveraging 3D multi-object tracking (MOT) to boost attention, focus, and decision-making. Developed by neuroscientists at Université de Montréal, it’s trusted by athletes, military personnel, students, and healthcare providers.",
                        description2: "",
                        stpragra3: "Key Benefits:",
                        stpragras3: ["Personalized, adaptive difficulty", "Short sessions (just 6 minutes) with results after 15 sessions", "Scientifically validated to improve attention, memory, and processing speed"],
                        stpragra4: "Applications:",
                        stpragras4: ["Athletes: Enhance situational awareness, reaction time, and decision-making for sports success", "Military: Strengthen decision-making under pressure and resilience in high-stress settings", "Students: Improve attention and academic performance, including support for ADHD", "Seniors: Help delay cognitive decline and reduce fall risks", "Rehabilitation: Support recovery from concussion, mTBI, and cognitive impairments"],

                        stpragra5: "Scientific Validation:",
                        stpragras5: ["Over 120 peer-reviewed studies confirm its effectiveness", "Promotes real-world improvements in activities like driving and sports", "Boosts neuroplasticity for greater brain adaptability"],

                        // headingb5: "Want targeted focus training?",
                        headingb3: "Why Choose NeuroTracker?",
                        pragraphb4: "It combines scientific rigor with real-world results, making it the top choice for serious cognitive development.",


                        headingb6: "Which Brain Training Tool Is Right for You?",
                        pragraphb5: "For scientifically backed cognitive training with measurable real-world results, NeuroTracker stands out as the top choice. Whether you're an athlete, student, senior, or professional, it delivers significant improvements in focus, memory, and decision-making. If you’re looking for a fun, gamified experience, Lumosity and Elevate are excellent options for casual training and skill development. For older adults or those in recovery, BrainHQ and NeuroTracker offer clinically validated exercises to support brain health.",

                        videoLinks1: [
                            "https://www.youtube.com/watch?v=5MZgaaVZjDE", "https://youtu.be/GXv8Z61V6V4"
                        ],
                        companyLink1: "https://www.neurotrackerx.com/",
                        buttons1: "VISIT THE COMPANY WEBSITE ",



                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/NeuroTrackerx.png"),
                                linkname: "neurotrackerx",
                                link: "https://www.neurotrackerx.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/NCogniSens 3D h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/NeuroTracker.jpg"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 3,
                subcategory: "RehaCom",
                title: "Which English training modules does RehaCom offer?",
                subtitle: "",
                subdesc: "",
                subtitle1rha: "Attention & Concentration Modules",
                bulletPoints1rha: [
                    "Focus & Concentration: Enhances sustained attention and ability to focus on tasks.",
                    "Selective Attention: Trains the ability to concentrate on relevant stimuli while ignoring distractions",
                    "Divided Attention: Improves multitasking ability by managing multiple streams of information simultaneously.",
                ],
                subtitle2rha: "Memory Modules",
                bulletPoints2rha: [
                    "Working Memory: Strengthens the capacity to temporarily hold and manipulate information.",
                    "Learning & Recall: Develops skills related to the acquisition and retrieval of new information.",
                    "Visual Memory: Improves the ability to remember visual stimuli, patterns, and images.",
                ],
                subtitle3rha: "Reaction & Processing Speed Modules",
                bulletPoints3rha: [
                    "Reaction Time: Enhances quickness of responses to visual or auditory stimuli.",
                    "Processing Speed: Focuses on increasing the speed at which the brain processes information.",

                ],

                subtitle4rha: "Executive Function & Problem Solving",
                bulletPoints4rha: [
                    "Planning & Organization: Helps in developing strategies for planning and executing tasks.",
                    "Problem Solving: Reinforces logical thinking and decision-making skills.", "Mental Flexibility: Promotes adaptability in changing situations."

                ],


                subtitle5rha: "Perception & Visual-Spatial Skills",
                bulletPoints5rha: [
                    "Visual Perception: Improves discrimination of visual stimuli.",
                    "Spatial Awareness: Develops skills to perceive and think about spatial relationships.",
                    "Visual Scanning: Enhances the ability to systematically scan visual fields"
                ],

                subtitle6rha: "Language & Communication (if available)",
                bulletPoints6rha: [
                    "Verbal Fluency: Supports language production and word retrieval.",
                    "Auditory Processing: Improves understanding and processing of spoken language.",

                ],

                subtitle7rha: "Additional Modules",
                bulletPoints7rha: [
                    "Dual Tasking: Combines attention, memory, and reaction tasks to simulate real-life multitasking.",
                    "Alertness & Vigilance: Focuses on maintaining alertness over extended periods.",

                ],



                description: "Here is a detailed list of some of the key RehaCom training modules available in English, covering various cognitive functions:",
                cover: require("../../Assets/Products/Psychology/Products/rahhomebanner.jpg"),
                brand: require("../../Assets/Products/Psychology/hasomedlogo.png"),
                backcolor: "#00002d",


                Products: [
                    {
                        id: 1,
                        title: "RehaCom",
                        title2: "Advanced Software for Cognitive Rehabilitation",
                        cover: require("../../Assets/Products/Psychology/Products/rah-sections.jpg"),
                        description: "RehaCom is a comprehensive, science-based software system designed to support computer-assisted cognitive rehabilitation. It assists therapists in restoring and improving various cognitive functions affected by brain injuries, including attention, concentration, memory, perception, and daily activities.",
                        description2: "",
                        headingb: "How It Works",
                        pragraphb1: "Through targeted tasks, RehaCom activates brain processes to restore vital cognitive functions. Effective training helps users better handle everyday challenges. The program can be used even in the early stages of injury and remains relevant throughout recovery. Modules are selected based on cognitive assessments or screening results.",

                        headingb2: "Multilingual & Adaptive",
                        pragraphb3: "With around 30 modules available in English and 27 other native languages, patients can train in their preferred language. The software is auto-adaptive, adjusting difficulty in real-time based on performance, ensuring continuous progress and minimizing frustration. For extended care, patients can be supervised remotely via internet-enabled training at home.",
                        stpragrarss: "Key Benefits",
                        stpragrar: "For Clinicians:",
                        stpragrars3: ["Scientifically Validated: Developed over 20 years by neuropsychologists.", "Multilingual: Available in 27 languages at no extra cost.", "Comprehensive: Covers all stages of rehabilitation, from early intervention to ongoing recovery.", "Targeted: Modules address specific deficits such as attention, memory, reaction time, and executive functions.", "Auto-Adaptive: Ensures steady progression tailored to individual performance.", "Screening & Monitoring: Includes tools for impairment detection, progress tracking, and detailed reporting.", "Remote Supervision: Enables supervised therapy over the internet, maximizing efficiency "],
                        stpragrar4: "For Patients:",
                        stpragrars4: ["Improved Cognitive Function: Noticeable gains in areas of weakness with consistent use.", "Personalized & Accessible: Works in multiple languages and accommodates visual and cognitive deficits, even using familiar stimuli like family images.", "Flexible & Remote: Continue therapy at home under remote supervision, reinforcing recovery outside sessions.", "Boredom & Frustration Resistance: The adaptive system maintains optimal challenge levels, supporting motivation and engagement."],


                        videoLinks1: [
                            "https://youtu.be/w5KAmxkjz-U"
                        ],
                        companyLink1: "https://hasomed.de/en/products/rehacom/",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/RehaCom fet.png"),
                                linkname: "Hasomed",
                                link: "https://hasomed.de/en/products/rehacom/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/Rheacom h1.png"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/rah-baner.jpg"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 5,
                subcategory: "NeuroCare Group",
                title: "A Cutting-Edge Solution Driving Excellence in Mental Health and Cognitive Performance",
                subtitle: "Best outcomes for patients",
                subtitle01: "Neurocare's First-Generation Digital Therapy Platform (DTP 1.0)",
                subdesc: "Neurocare’s DTP 1.0 is actively utilized across our network of clinics and partnerships, built on over 20 years of scientific research and development. This platform integrates multidimensional and biomarker-based diagnostics, online cognitive training, and standardized protocols for neuromodulation techniques like TMS, Neurofeedback, and tDCS.",
                subdesc1: "Discover Our Neuromodulation Solutions for Clinical Practice, Including TMS, tDCS, Neurofeedback, Biofeedback, and Advanced Assessment Tools.",
                subdesc106: "By embedding these features into our Standard Operating Procedures (SOPs), the platform ensures a structured and evidence-based approach to clinical delivery, providing ongoing supervision and support for clinicians, patients, and their families.",
                subdesc107: "Additionally, these protocols are seamlessly integrated with local electronic health records, enhancing efficiency and accessibility. Neurocare’s Learning Management System (LMS) further accelerates growth by offering online training, making advanced knowledge in digital therapeutics and neuromodulation available to clinicians worldwide.",


                cover: require("../../Assets/Products/Psychology/neurocare.webp"),
                brand: require("../../Assets/Products/Psychology/neurocarelogo.png"),
                backcolor: "#00002d",
                Products: [
                    {
                        id: 1,
                        title: "Transcranial Magnetic Stimulation (TMS)",
                        title2: "",
                        cover: require("../../Assets/Products/Psychology/Products/tms section.jpg"),
                        description: "",
                        description2: "",

                        // pragraphb1: "The ProComp Infiniti allows for classic biofeedback with up to 8 channels of real-time physiological data, including:",
                        bulletPointsntms: ["Clinical TMS Devices: Designed for everyday clinical use, including the Apollo TMS system made in Germany, and versatile PowerMAG TMS systems suitable for continuous treatment.", "Research Systems: Innovative monophasic, biphasic, and controllable pulse TMS systems tailored for neuroscientific studies.", "Neuronavigation Solutions: Precision 3D neuronavigation with View! to enhance the accuracy of TMS therapy and research.", "Treatment Chairs & Accessories: Ergonomic chairs like the Greiner portable treatment chair, optimized for patient comfort during sessions."],

                        headingn2tms: "Areas of application for NEURO PRAX® TMS/tES :",

                        bulletPointsn2tms: ["Recording and analysis of cortical and sub-cortical TMS-EEG activity", "Recording and analysis of cortical and sub-cortical TMS-EEG activity Investigation of functional connectivity between areas of the brain", "EEG-triggered TMS/tES stimulation", "Quantitative EEG analysis and cognitive evoked potentials before, during and after treatment with transcranial stimulation (tDCS-EEG, tACS-EEG, tRNS-EEG)", "Investigations into the safety of transcranial stimulation", "MEP-threshold detection and MEP-brain mapping", "NEURO PRAX® TMS has exclusively a direct data transfer option to BRAINSIGHT®® for displaying artifact corrected TMS-EEG data during TMS navigation", "Neuro- and biofeedback"],
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=gIxlocHwSpA"
                        ],
                        companyLink1: "https://www.neurocaregroup.com/technology/tms-systems",
                        buttons1: "VISIT THE COMPANY WEBSITE ",


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/tmsfet.webp"),
                                linkname: "Neurocaregroup",
                                link: "https://www.neurocaregroup.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/tms h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/tms h2.webp"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "DC-STIMULATOR PLUS (tDCS) ",
                        title2: "",
                        title01: "ofessional Training for Transcranial Stimulation",
                        cover: require("../../Assets/Products/Psychology/Products/tds section.jpg"),
                        description: "Made in Germany, our advanced transcranial stimulation devices—such as the DC-STIMULATOR and DC-STIMULATOR MOBILE—offer safe and effective cranial electrotherapy through weak direct current (tDCS). These non-invasive tools modulate neuronal activity by either inhibiting or activating cortical regions, depending on the stimulation parameters.",
                        description2: "",

                        headingntms: "Key Features:",

                        bulletPointsntms: ["tDCS Therapy: Utilized for reducing depressive symptoms and supporting neurorehabilitation.", "Research-Grade Devices: Including the DC-STIMULATOR PLUS, MR, and MC models, capable of bipolar stimulation with alternating current (tACS) and noise current (tRNS). The DC-STIMULATOR MR is MRI-compatible, and the MC supports up to 16 independent channels for complex experiments.", "Safety & Monitoring: Equipped with multiple hardware and software safeguards, automatic shut-down features, and constant monitoring to ensure patient safety."],
                        headingn2tms: "Clinical & Research Applications :",

                        bulletPointsn2tmss: ["DC-STIMULATOR MOBILE : A portable device ideal for home use or clinical settings, delivering reliable tDCS therapy.", "DC-STIMULATOR : A trusted, German-made device for precise unipolar stimulation in clinical practice."],
                        pragraph1tms: "Explore our expert training offerings and high-quality accessories to enhance your neurostimulation practice or research today.",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=81DiVAuKmYk"
                        ],
                        companyLink1: "https://www.neurocaregroup.com/technology/tdcs-and-tes-devices#research",
                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/tdcs fet.webp"),
                                linkname: "Neurocaregroup",
                                link: "https://www.neurocaregroup.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/tds h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/tds h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "QEEG Systems ",
                        title2: "DC-EEG Biofeedback System",
                        cover: require("../../Assets/Products/Psychology/Products/qrcc section.jpg"),
                        description: "The THERA PRAX® Q-EEG is a sophisticated biofeedback system designed to help patients learn to self-regulate their brain activity through EEG biofeedback. Primarily, it supports EEG biofeedback utilizing the slow cortical potentials (SCP) protocol for treating children with attention deficit/hyperactivity disorder (ADHD).",
                        description2: "In addition to biofeedback, the THERA PRAX® Q-EEG can reliably record multi-channel EEG, ECG, and EMG signals, as well as peripheral biosignals, to analyze psychophysiological responses during relaxation or stress. To monitor therapy progress on an individual basis, cognitive evoked potentials can also be recorded.",
                        description4: "Collaborating closely with leading scientific institutions in the field of biofeedback, our devices incorporate the latest medical research findings.",
                        headingn2tms: "Features of the THERA PRAX® Q-EEG :",

                        bulletPointsn2tms: ["22-channel full-band Q-EEG and DC-EEG biofeedback system.", "Feedback of slow cortical potentials (SCP) through DC-EEG.", "Generation of Q-EEG data, spectral analysis, with an interface compatible with “NeuroGuide” software.", "EEG biofeedback across various frequency bands (alpha, theta, beta, delta, SMR, and desired bands) and ratios (e.g., beta/theta).", "Customizable frequency bands, algorithms, and combinations such as ratios, correlations, coherence, and bicoherence.", "Flexible feedback options, including unipolar, bipolar, source, and multi-channel feedback.", "Integration of biofeedback for EMG, ECG, and heart rate (HR).", "Audio-visual feedback with engaging animations.", "Patient database that tracks medication, examinations, and provides comprehensive documentation.", "Analysis of single sessions and comparison across multiple sessions.", "Suitable for polygraphy and polysomnography applications."],
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=3OVtRCKegfQ"
                        ],
                        companyLink1: "https://www.neurocaregroup.com/technology/eeg-and-qeeg-systems#research",
                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        mainhigh: [

                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/egg fet.webp"),
                                linkname: "Neurocaregroup",
                                link: "https://www.neurocaregroup.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/eeg fet.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/qeeg h2.webp"),
                            },
                        ],
                    },
                    {
                        id: 4,
                        title: "ActTrustActigraph ",
                        title2: "ActTrust Actigraphy and sleep profile analysis in therapy ",
                        cover: require("../../Assets/Products/Psychology/Products/ActTigraphy.webp"),
                        description: "With advanced light sensor technology, this device is intended for daily clinical use on loan to clients to assess sleep hygiene, exposure to blue light and sleep routines.",
                        description2: "ActTrust uses a harder plastic and is, therefore, less prone to scratches and surface damage. Therefore, use ActTrust for children or people you expect to expose the device to mechanical stress.",
                        description4: "ActTrust has a longer battery life and therefore longer charging cycles. It is suitable if the device is away from your practice/institution for a longer period of time.",
                        headingn2tms: "ActTrust 2",
                        bulletPointsn2tmss: ["Precision actigraphy with time display", "Our newest actigraph. It combines all functions of the ActTrust, but also features a time display and additional sensors", "Like the ActTrust1,  theActTrust 2 provides sensors for light intensity and RGB-IR light"],


                        headingAct: "Features of ActTrust",
                        bulletPointsAct: ["Light sensor: Red / Green / Blue, measures ambient light intensity and intensity of each spectrum independently", "Accelerometer: 2 axes, resolution 12 bit, 25 Hz", "Measurement intervals of 1- 86.400 seconds", "Event marker for custom analytics", "Temperature sensors for body temperature and ambient temperature", "Records and stores data continously for up to three months", "Robust, splash-proof casing", "Data transfer via USB docking station", "Software compatible with Windows and Mac OS"],

                        pragHeadingact: "software for Actigraphy analysis",
                        pragraphAct: "ActStudio is innovative analysis software for ActTrust and ActTrust2. The software ActStudio is included with all ActTrust devices. The connection to your computer is established via the docking station ActDock.",
                        headingAct1: "Features of the software include: ",
                        bulletPointsAct1: ["1.	detailed analysis of important sleep parameters: time taken to fall asleep (sleep onset latency - SOL), wake after sleep onset (WASO), sleep efficiency and number of awakenings.", "2.	graphical representations of various chronobiological functions and environment factors,", "3.	automatic reports for clinical and scientifice use"],
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=E6YjxWlo3GQ", "https://www.youtube.com/watch?v=eZlEOfTdL4M"
                        ],
                        companyLink1: "www.neurocaregroup.com/acttrust-actigraphy",
                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        mainhigh: [


                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/ActTigraphy fet1.webp"),
                                linkname: "Neurocaregroup",
                                link: "https://www.neurocaregroup.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/antibanner h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/antibanner h2.jpg"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 6,
                subcategory: "Ergoneers",
                title: "Observe. Simulate. Analyse. Design. Controle. Automate. Improve",
                subtitle: "",


                description: "Ergoneers serves a diverse array of industries, including automotive, consumer goods, healthcare, and academia, by delivering advanced solutions for understanding human behavior. Their expertise supports innovation, safety, and product development, from refining vehicle interfaces to enhancing workplace ergonomics.",

                subdesc: "Driven by a commitment to research excellence, Ergoneers empowers clients worldwide with cutting-edge tools and tailored solutions that uncover actionable insights, improve product usability, and optimize ergonomic designs. Their dedicated team ensures seamless integration of these tools, making them a trusted partner in human-centered innovation.",

                thirdParagraph: "By focusing on quality, innovation, and user needs, Ergoneers leads the field of human factors research, driving advancements that benefit industries, enhance safety, and elevate everyday experiences.",
                bulletPoints: [
                    "Comprehensive Platform: Porphea.X offers a 360-degree solution for data collection and analysis in user and behavior studies.",
                    "Multimodal Data Measurement: Supports the measurement of eye-tracking, video, audio, physiology, and CAN-bus data.",
                    "Integrated Software Modules: Features specialized modules for seamless data collection and analysis across multiple domains.",
                    "Versatile Applications: Ideal for a wide range of research and user behavior studies, providing actionable insights."
                ],



                cover: require("../../Assets/Products/Psychology/Products/ergoneer_banner.jpg"),
                brand: require("../../Assets/Brands/Ergoneerslogo.png"),
                backcolor: "#b57347",
                Products: [

                    {
                        id: 1,
                        title: "Ergoneers Dikablis Glasses X",
                        title2: "Advanced Eye-Tracking Technology with d-lab",
                        cover: require("../../Assets/Products/Psychology/Products/ergonner section.jpg"),

                        brand: require("../../Assets/Products/Psychology/ergo.png"),


                        description: "The Dikablis GlassesX deliver highly accurate binocular eye tracking with standardized metric calculations. Designed for comfort, they provide a snug fit, even for users wearing prescription glasses. Ideal for studying human behavior in dynamic environments, they offer unparalleled versatility and precision.",
                        description2: "Powered by the D-Lab measurement and analysis platform, the Dikablis GlassesX enable synchronous collection and analysis of gaze data from multiple sources.",

                        description3: "",
                        description4: "",
                        description5: "",
                        description6: "",


                        subtitle2: "Key features include:",
                        bulletPoints2: [
                            "Futuristic Design: Sleek, modern aesthetics paired with ergonomic comfort.",
                            "Wide Customization Options: Adjustable settings to meet diverse research needs.",
                            "Raw Data Access: Full transmission of raw eye-tracking data for in-depth analysis.",
                            "High Precision: Exceptional accuracy in eye tracking for reliable insights."
                        ],
                        title3: "",
                        description31: "The Dikablis Glasses 3 are an indispensable tool for eye-tracking studies in research and development, offering comprehensive solutions for behavioral analysis.",
                        description32: "",


                        videoLinks1: [
                            "https://www.youtube.com/watch?v=WdXSZEitrug"
                        ],
                        companyLink1: "https://ergoneers.com/product-name/dikablis-glasses/",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        title5: "Dikablis Glasses X: Flexible Eye-Tracking Solutions with Wired and Wireless Options",
                        description51: "Each Dikablis Glasses 3 package includes essential components: a head unit with a standard lens, four interchangeable nose pieces, an eBox, USB and HDMI cables, power supplies, a USB stick with manuals and documentation, and a microfiber cleaning cloth.",
                        description52: "For tailored research needs, two variants are available:",
                        subtitle6: "Dikablis GlassesX Cable",

                        bulletPoints6: [
                            "Connect directly to the recording computer for uninterrupted data collection.",
                            "Enables live observation of data during the study.",
                            "Ideal for controlled environments requiring a stable setup.",
                        ],


                        subtitle7: "Dikablis GlassesX Wireless",
                        bulletPoints7: [
                            "Features a wBox for data storage and real-time WLAN transmission to a computer.",
                            "Includes a battery-powered wireless router for unrestricted mobility during studies. ",
                            "Suitable for dynamic environments, allowing research to be conducted freely without power supply constraints.",
                            "Live observation remains possible for real-time insights.",
                        ],



                        title9: "Note :",
                        description71: "",
                        description72: "",
                        description81: "Both options provide advanced eye-tracking solutions, ensuring flexibility and reliability for various research settings.",


                        description86: "Dikablis GlassesX come with a free copy of our comprehensive software package D-LAB Eye Tracking Head Mounted lite and D-LAB Audio lite. This software makes our high-end eye tracker a plug & play solution and enables researchers to plan, measure and analyze their studies in an effective and easy way. D-LAB can easily be upgraded for automatic eye tracking analysis or to record and analyze other sensors like physio devices, car data or external cameras synchronously with the eye tracking data.",






                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/eye_tracking_dlab fet.jpg"),
                                linkname: "Ergoneers",
                                link: "https://ergoneers.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/ergoneer_banner h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/ergoneer_banner h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "Prophea.X",
                        title2: "The most versatile software ecosphere for holistic, human-centered situation analysis.", cover: require("../../Assets/Products/Psychology/Products/Proflexjpg.jpg"),
                        // brand: require("../../Assets/Products/Psychology/Products/Ergoneers_Prophea_logo.jpg"),
                        description: "At the heart of Ergoneers’ offerings is Prophea.X, a robust, modular software platform designed for the comprehensive analysis of behavioral data. Prophea.X supports multi-sensor synchronization, allowing users to integrate data from eye tracking, EEG, motion tracking, and other sensors to get a complete picture of human interactions, responses, and physical activity in various environments.",


                        description3: "",
                        description4: "",
                        description5: "",
                        description6: "",
                        videoLinks1: [
                            "https://ergoneers.com/behavior-analysis-equipment-solutions/", "https://www.youtube.com/watch?v=0k-Ra4HvZxo"
                        ],
                        companyLink1: "https://ergoneers.com/behavior-analysis-equipment-solutions/",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        description21: "",
                        description22: "",
                        bulletPoints2: [
                            "Comprehensive Platform: Porphea.X offers a 360-degree solution for data collection and analysis in user and behavior studies.",
                            "Multimodal Data Measurement: Supports the measurement of eye-tracking, video, audio, physiology, and CAN-bus data.",
                            "Integrated Software Modules: Features specialized modules for seamless data collection and analysis across multiple domains.",
                            "Versatile Applications: Ideal for a wide range of research and user behavior studies, providing actionable insights."
                        ],

                        description31: "",
                        description32: "",

                        title4: "Propheadata engine Lite",
                        description41: "",
                        description42: "",


                        title5: " ",
                        subtitle5px: "All analysis modules within the Prophea.X ecosphere are delivered with Propheadata engine Lite.",
                        description51: "It enables three input channels for synchronous recording: One sensor, specific for your analysis module, one USB- or webcam, and one microphone.The Propheadata engine includes, by default, seven analysis-specific sensor inputs. Unlocking the full power of Prophea.X, Advanced Multi Sensor Packages are available in two options:",
                        description52: "",


                        title6: "Propheadata engine extended",
                        description61: "It is connectable with up to 20 sensor inputs.",
                        description62: "",

                        title7: "Propheadata engine unlimited",
                        description71: "For larger sensor-input requirements, is individually licensed up to an unlimited amount of input streams. ",
                        description72: "",
                        subtitle7: "Application Area:",
                        bulletPoints7: [
                            "Behavioral Research",
                            "Human Interaction Analysis",
                            "Multisensory Data Integration",
                            "Environmental Response Studies"
                        ],
                        title8: "",
                        description81: "",
                        description82: "",






                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/Prophea_X_fet.png"),
                                linkname: "Ergoneers",
                                link: "https://ergoneers.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/banner-propheax.jpg"),
                            },

                        ],
                    },


                ]
            },
            {
                // id: 18,
                // subcategory: "Sports vision training",
                // title: "We help people measure and analyze motion",
                // subtitle: "Applications for motion capture technology",
                // subdesc: "Our technology is used by researchers, biomechanists, physicians and engineers from all over the world. However, anyone that is interested in getting objective information about how things move can benefit from our technology. For example, our motion capture systems can be used to find and prevent injuries, improve performance in biomechanics and help engineers build better products and increase production efficiency.",
                // description: "World leader in human measurement in complex and real environments for over 30 years, TEA innovates for the well-being of humans with agile solutions and services.",
                // cover: require("../../Assets/Products/Psychology/svt.gif"),
                // brand: require("../../Assets/Products/Psychology/svtlogo.png"),
                // backcolor: "#6393be",
                id: 18,
                subcategory: "SVT™ Hardware",
                title: "",
                subtitle: "",
                subdesc: "",
                subdescsvt: "Sports Vision has pioneered the creation and worldwide adoption of the Sports Vision Trainer (SVT™), a cutting-edge scientific tool designed to evaluate and enhance critical athletic abilities. The SVT™ focuses on improving eye-hand coordination and decision-making skills, essential for peak performance in sports. By combining advanced technology with targeted training protocols, it serves as both an assessment and development tool, empowering athletes to react faster, make precise decisions, and optimize their overall visual-motor performance.",
                description: "",
                cover: require("../../Assets/Products/Psychology/svt.gif"),
                brand: require("../../Assets/Products/Psychology/svtlogo.png"),
                backcolor: "#6393be",
                descriptionsvt: "SVT™ Is a truly portable system developed for teams and practitioners who want to use the SVT™ in different field locations without the need for AC mains power.",
                heading01: "Sports Vision - Innovation through R&D",
                pragraphp01: "Sports Vision has seen the development and global commercialization of the Sports Vision Trainer (SVT™).This scientific instrument is used to assess and train eye hand coordination and decision-making skills.",

                subtitle17svt: "SVT™ Professional software features:",
                bulletPoints17st: [
                    "Run two SVT panels simultaneously linked side by side on the same PC.",
                    "Spatial Heat Map of reaction times.",
                    "Reaction Time vs. Time Chart.",
                    "Reaction Time Distribution (consistency) curve.",
                    "Test Result Progression (multiple test results pooled).",
                    "Reaction Time Distribution 3D waterfall plot (multiple test results pooled).", "Progress summary of all selected test results.", "Printing of graphical analysis and reports."
                ],

                Products: [
                    {
                        id: 1,
                        title: "32 light Sports Vision Trainer ",
                        cover: require("../../Assets/Products/Psychology/Products/svt32.jpg"),
                        description: "The 32 sensor pad SVT™ Is a truly portable system developed for teams and practitioners who want to use the SVT™ in different field locations without the need for AC mains power. Depending on the application, It can be used in landscape or portrait orientations. The unit has stabilising feet for easy setup and use, so there is no need for brackets. The dimensions are 135 cm in width by 60 cm in height, thickness with feet attached is 19 cm.",
                        description2: "After several years or research on how to analyse SVT data and get meaningful information at a single glance, we came up with the SVT Professional software. Compatible with existing SVT datasets, the Professional series of software allows you to graphically visualise, track and compare test results with ease. Leveraging the power of DSP (Digital Signal Processing), SVT Professional can visually show trends in data by pooling information from test results in spatial, frequency and time domains. SVT Professional has all of the features of the standard software and can unlock a wealth of information contained in your existing SVT database.",
                        bulletPoints32stv: [
                            "Purpose of Vision Training: Involves targeted exercises designed to improve neural pathways in the brainstem and cortex.",
                            "Neural Restructuring: Repeated practice reshapes neural networks, enhancing the brain's efficiency in processing visual tasks.",
                            "Visual Perceptual Efficiency: Focuses on maximizing the accuracy and speed of visual perception during tasks.",
                            "Improved Visual-Motor Integration: Enhances coordination between visual input and motor output for better performance in sports.",
                            "Progressive Development: Achieved through consistent and structured training over time.",
                        ],
                        subtitle32svts: "Application of 32 Light Sports Vision Training:",
                        bulletPoints32stvs: [
                            "Reaction Time: Improves speed in responding to visual stimuli.",
                            "Hand-Eye Coordination: Enhances precision in movement synchronization.",
                            "Peripheral Awareness: Boosts the ability to detect objects in the surrounding field of vision.",

                            "Focus and Accuracy: Sharpens visual attention and target precision.",

                        ],

                        companyLink1: "https://www.sportsvision.com.au/products.html",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=kWxu2AhYoZo"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/svtfet.png"),
                                linkname: "SVT",
                                link: "https://www.sportsvision.com.au/index.html",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/svt.gif"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/svt.gif"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "SVT™ 64 Lights ",
                        cover: require("../../Assets/Products/Psychology/Products/svt64.png"),
                        description: "Sports Vision has pioneered the creation and worldwide adoption of the Sports Vision Trainer (SVT™), a cutting-edge scientific tool designed to evaluate and enhance critical athletic abilities. The SVT™ focuses on improving eye-hand coordination and decision-making skills, essential for peak performance in sports. By combining advanced technology with targeted training protocols, it serves as both an assessment and development tool, empowering athletes to react faster, make precise decisions, and optimize their overall visual-motor performance.",
                        description2: "",
                        subtitles64s: "64 light Sports Vision Trainer Application",
                        bulletPoints64s: [
                            "Sports Performance Enhancement: Improves reaction time, hand-eye coordination, peripheral vision, and decision-making for athletes across various sports.",
                            "Rehabilitation and Therapy: Aids in recovery from visual or neurological impairments by training visual-motor integration and cognitive response.",
                            "Military and Tactical Training: Enhances situational awareness, reaction speed, and precision under high-pressure scenarios.",
                            "Research and Development: Supports studies in vision science, cognitive performance, and neuromotor functions for innovation in sports and medical fields.",
                        ],
                        subtitle64svts: "SVT™ professional software",
                        bulletPoints64stvs: [
                            "Advanced Analysis: SVT™ Professional software is designed after years of research to provide meaningful insights at a glance.",
                            "Seamless Compatibility: Fully compatible with existing SVT datasets for effortless integration.",
                            "Graphical Visualization: Easily track, compare, and analyze test results with intuitive graphical tools.",
                            "DSP-Powered Insights: Utilizes Digital Signal Processing to reveal trends across spatial, frequency, and time domains.",
                            , "Enhanced Features: Includes all standard software capabilities while unlocking deeper insights from your SVT database."
                        ],

                        companyLink1: "https://www.sportsvision.com.au/products.html",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=kWxu2AhYoZo"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE",


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/svtfet.png"),
                                linkname: "SVT",
                                link: "https://www.sportsvision.com.au/index.html",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/svt.gif"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/svt.gif"),
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "80 light Sports Vision Trainer ",
                        cover: require("../../Assets/Products/Psychology/Products/svt80.jpg"),
                        description: "The 80-sensor pad SVT™ is a wall mounted non-portable system, dimensions are 1.25 metres by 1.25 metres and weight is 15 kg.",
                        subtitle84features: "Key Features of SVT™ System",
                        description2: "",

                        subtitle84features: "Key Features of SVT™ System",
                        bulletPoints84features: [
                            "Dual Panel Functionality: Operate two SVT panels side by side on a single PC for enhanced analysis.",
                            "Spatial Heat Mapping: Visualize reaction times with heat maps for detailed spatial performance insights.",
                            "Reaction Time Analytics: Access charts showing reaction time trends over a session.",
                            "Consistency Analysis: Evaluate performance stability using reaction time distribution curves.",
                            "Test Progression Tracking: Pool multiple test results to monitor improvement over time.",
                            "3D Waterfall Visualization: Analyze reaction time distribution across multiple tests with a 3D plot.",
                            "Comprehensive Progress Reports: Summarize and compare results across selected tests for overall performance evaluation.",
                            "Printable Reports: Generate graphical analyses and detailed reports for review and documentation."
                        ],
                        subtitle84applicationAreas: "Application Areas of 80 light Sports Vision Trainer",
                        bulletPoints84applicationAreas: [
                            "Sports Performance Enhancement",
                            "Rehabilitation and Therapy",
                            "Military and Tactical Training",
                            "Research and Development"
                        ],

                        companyLink1: "https://www.sportsvision.com.au/products.html",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=kWxu2AhYoZo"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE",


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/biofeedbackfet.jpg"),
                                linkname: "Thought tec",
                                link: "https://thoughttechnology.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/miqus.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/miqus.jpg"),
                            },
                        ],
                    },
                ]
            },
            // {
            //     id: 19,
            //     subcategory: "HeadApp",
            //     title: "— Innovative Cognitive Rehabilitation Training",
            //     subtitle: "A Product by Neurozip",
            //     pragHead: "Empowering clinicians and transforming patient recovery with personalized, computer-assisted cognitive therapy.",

            //     subHead1: "Unlock the Potential of Cognitive Rehabilitation",
            //     pragHead1: "HeadApp is a state-of-the-art platform designed to facilitate cognitive recovery across a wide range of applications including neurology, psychology, neurodevelopmental disorders, and psychiatric care. Built with advanced technology, HeadApp provides tailored training and assessment that help restore cognitive functions such as memory, attention, perception, and judgment.",
            //     subtitle1rha: "Why Choose HeadApp?",
            //     bulletPoints1rha: [
            //         "Personalized Treatment Plans: Customize therapy sessions based on individual patient needs and progress.",
            //         "User-Friendly Interface: Easy to operate for both clinicians and patients, ensuring seamless integration into your practice.",
            //         "Remote & Telerehabilitation Capabilities: Extend your reach beyond the clinic—conduct therapy sessions remotely with unwavering quality.",
            //         "Evidence-Based & Engaging: Use scientifically backed exercises that motivate and engage patients for better outcomes.",
            //         "Comprehensive Monitoring: Track progress in real-time and adjust therapies accordingly for optimal results.",

            //     ],





            //     subtitle17svt: "Application Areas",
            //     bulletPoints17st: [
            //         "Brain injury recovery",
            //         "Neurodevelopmental disorder management",
            //         "Psychiatric rehabilitation",
            //         "Cognitive enhancement programs", "Clinical research and assessments"
            //     ],

            //     pragHead2: "Discover how HeadApp can elevate your practice and empower your patients to achieve better cognitive health.",
            //     pragHead3: "Get started today!",
            //     pragHead4: "Contact us for a demo or more information.",
            //     Linkssss: "http://www.headapp.in",
            //     //description: "World leader in human measurement in complex and real environments for over 30 years, TEA innovates for the well-being of humans with agile solutions and services.",
            //     cover: require("../../Assets/Products/Psychology/Products/Heade banner.jpg"),
            //     brand: require("../../Assets/Products/Psychology/neurozip brand.png"),
            //     backcolor: "#203965",
            //     Products: [
            //         {
            //             id: 2,
            //             title: "HEADAPP In",
            //             title2: "Computer-Aided Cognitive Rehabilitation | Empowering Recovery & Enhancing Lives",
            //             cover: require("../../Assets/Products/Psychology/Products/heads sections.jpg"),
            //             description: "Cognitive rehabilitation is a targeted therapy designed to restore and improve impaired cognitive functions such as memory, attention, perception, and judgment. The goal? To help individuals regain their independence and resume daily activities with confidence. HeadApp offers a personalized, computer-assisted platform tailored specifically to support patients with brain injuries, neurodevelopmental disorders, and psychiatric conditions—delivering integrated mental and cognitive health solutions.",
            //             description2: "",

            //             subtitle32svts: "Key Benefits of Cognitive Rehabilitation with HeadApp",
            //             bulletPoints32stvs: [
            //                 "Rebuild Cognitive Skills: Focused on restoring memory, concentration, perception, and judgment.",
            //                 "Improve Daily Functioning: Enhances the ability to process and interpret information effectively.",
            //                 "Support Relationships & Community: Helps maintain personal and professional connections.",

            //                 "Customized Solutions: Tailored screening and training designed for individual needs.",
            //                 , "Inclusive Care: Targeted at patients with acquired brain injuries or neurodevelopmental and psychiatric disorders."
            //             ],

            //             headingn2pe: "Benefits for Clinicians",

            //             bulletPointsn2pe: ["Broaden Reach : Deliver care to patients across regions effortlessly.", "Optimize Workflow : Reduce idle time and travel with remote sessions.", "Track Progress: Immediate and detailed feedback on patient performance.", "Personalized Therapy: Adjust treatments dynamically to maximize outcomes."],

            //             headingn2p: "Benefits for Patients",

            //             bulletPointsn2p: ["Seamless Continuity: Ongoing care without interruptions.", "Convenience: Access therapy from home, anytime.", "Motivation & Engagement: Create a comfortable environment for therapy.", "Mobility-Friendly: Ideal for those facing travel or mobility challenges.", "Consistent Progress: Encourages adherence and steady improvement."],
            //             title5: "Experience It Today",
            //             description51: "Discover how HeadApp simplifies cognitive rehabilitation. Try it out and experience a user-friendly platform that adapts to your needs.",
            //             title6: "Ready to elevate your practice or recovery journey?",
            //             description62: "Contact us now or sign up for a demo!",
            //             companyLink1: "https://neurozip.com/",
            //             videoLinks1: [
            //                 "https://www.youtube.com/watch?v=nt6ednRLMlU", "https://www.youtube.com/watch?v=onWy43_ruQA", "https://www.youtube.com/watch?v=2TNIw8a1W1U"
            //             ],

            //             buttons1: "VISIT THE COMPANY WEBSITE",

            //             mainhigh: [
            //                 {
            //                     id: 1,
            //                     logo: <CiMedicalCross />,
            //                     title: "heading first"
            //                 },
            //                 {
            //                     id: 2,
            //                     logo: <LuSunMedium />,
            //                     title: "heading second",
            //                 },
            //                 {
            //                     id: 3,
            //                     logo: <CiMedicalMask />,
            //                     title: "heading third",
            //                 },
            //                 {
            //                     id: 4,
            //                     logo: <FaBacteria />,
            //                     title: "heading fourth",
            //                 },
            //             ],
            //             mainfet: [
            //                 {
            //                     id: 1,
            //                     desc: "this is first features"
            //                 },
            //                 {
            //                     id: 2,
            //                     desc: "this is second features"
            //                 },
            //                 {
            //                     id: 3,
            //                     desc: "this is third features"
            //                 },
            //                 {
            //                     id: 4,
            //                     desc: "this is fourth features"
            //                 },
            //                 {
            //                     id: 4,
            //                     desc: "this is fifth features"
            //                 },
            //                 {
            //                     id: 4,
            //                     desc: "this is sixth features"
            //                 },
            //             ],
            //             feature: [
            //                 {
            //                     id: 1,
            //                     title: "this is title",
            //                     desc: "this is description",
            //                     cover: require("../../Assets/Products/Psychology/Products/neurozip fet.jpeg"),
            //                     linkname: "neurozip",
            //                     link: "https://neurozip.com/",
            //                 }
            //             ],
            //             highlights: [
            //                 {
            //                     id: 1,
            //                     cover: require("../../Assets/Products/Psychology/Products/head h1 (1).jpg"),
            //                 },
            //                 {
            //                     id: 2,
            //                     cover: require("../../Assets/Products/Psychology/Products/head h1 (2).jpg"),
            //                 },
            //             ],
            //         },
            //     ]
            // },

        ],

    },
    {
        id: 2,
        Category: "Biomechanics",
        cover: require("../../Assets/CategoryPage/Sports Biomechanics.jpg"),
        link: "pukhya/biomechanics",
        subcategories: [
            {
                id: 8,
                subcategory: "Qualisys",
                title: "The Motion capture system",
                subtitle: "",
                subdesc: "The Arqus camera family includes models with protected housing that’s specifically built to withstand any type of weather it may encounter. Designed to be natively waterproof and dustproof, and with an extended temperature range, the camera will operate where you need it to.",
                description: "",
                sixthParagraph: "Synchronized videos make it possible to do:",
                bulletPoints6: [
                    "Data quality check",
                    "Multi-day evaluations",
                    "Multi-vet evaluations",
                    "Communication/documentation of cases – in addition to 3D data"
                ],
                brand: require("../../Assets/Brands/Qualisys-Logo.jpg"),

                seventhParagraph: "Motion Capture advantages compared with IMU systems:",

                bulletPoints7: [
                    " Highest precision/accuracy",
                    "Unlimited number of markers can be added",
                    "No charging of the system needed",
                    "Synchronized videos"
                ],


                subject01: "Clinical - QHorse, lameness analysis",
                subjectdescriptions: "The system provides the best accuracy and precision on the market. It enables you to capture movement that might be close to impossible to detect with the naked eye.",
                subjectdescriptions01: "The interface is designed to show asymmetries in various ways, ranging from an accessible overview to in-depth stride-by-stride information. It is a complete state-of-the-art tool for objective lameness assessment with quick and easy comparisons of measurements, video recordings, and a report function."
                ,
                subject02: "Gait Analysis for Research and Clinical Applications",
                subjectdescriptions02: "Qualisys provides motion capture solutions designed for both research and clinical gait analysis. Selecting the right system depends on the specific needs of your application, whether it’s clinical diagnostics or advanced research studies.",


                subject03: "Qualisys Clinical System (QCS): ",
                subjectdescriptions03: "Ideal for clinical tasks such as diagnosis, treatment evaluation, and patient monitoring.",


                subject04: "Gait Analysis Module:",


                subjectdescriptions04: "Best suited for researchers conducting in-depth gait studies.Each Gait Analysis module is equipped with everything needed for a seamless gait analysis experience, including customizable marker sets, event modes, hardware integrations, and capture options. Our software is adaptable to your unique protocols and comes with detailed documentation and guides to help you get started quickly.",


                cover: require("../../Assets/Products/Biomechanics/q banner.jpg"),

                backcolor: "#a73b2c",
                Products: [
                    {
                        id: 1,
                        title: "Miqus Mocap Camera—Capture More with Less",
                        title2: "",
                        cover: require("../../Assets/Products/Ergonomics/Products/meques 1.jpg"),
                        description: "Motion capture cameras for small and large projects",
                        subtitle21: "",
                        subtitle021: "Compact and Budget-Friendly Motion Capture Cameras ",
                        description2: "The Miqus motion capture camera is our most compact and polished design to date. Its lightweight and streamlined body packs all the essential features needed to power your next motion capture project efficiently and affordably.",

                        description3: "Just like all Qualisys mocap cameras, the Miqus cameras are designed to capture accurate mocap data with very low latency. This makes the Miqus suitable for a wide range of applications. From small 3-camera educational systems up to large projects with +100 cameras.",

                        title2: "",
                        description21: "The Miqus is available in three models: Miqus M1 (1 MP), Miqus M3 (2 MP) and Miqus M5 (4 MP).",
                        description22: "",
                        subtitle2: "Key features",
                        bulletPoints2: [
                            " High-speed motion capture",
                            "Resolution: 1, 2 & 4 megapixels",
                            "Wide field of view",
                            "Low latency for real-time applications",
                            "Fast setup with combined Power & Ethernet",
                            "Daisy-chaining (no switches required)",
                            "Silent operation",
                            "In-camera marker masking",

                        ],
                        title3: "",
                        description31: "",
                        description32: "",
                        subtitle3: "Applications",
                        bulletPoints3: [
                            "Human Biomechanics",
                            "Sports Research",
                            "Equine Lameness",
                            "Sound & Motion",
                            "Animal Biomechanics",
                            "MRI",
                            "Swimming",
                            "Automotive",
                            "OEM",
                            "Robotics & UAV",
                            "Marine Vessels & Structures",
                            "Wind Power",
                            "Virtual Reality (VR)",
                            "Animation & VFX",

                        ],

                        companyLink1: "https://www.qualisys.com/cameras/miqus/",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=vJpjEqXyec0&list=PLayfN54QgJo0nJxVEtkrEItdRvcRou61I&index=5"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        title4: "",
                        description41: "",
                        description42: "",





                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/miqusfet.jpg"),
                                linkname: "Qualisys",
                                link: "https://www.qualisys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/m-head banners.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/my clips.jpg"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "Arqus",
                        title2A: "The industry’s highest Extreme performance.",
                        cover: require("../../Assets/Products/Biomechanics/Products/arque section.jpg"),
                        description: "",

                        bulletPointsA: ["Arqus motion capture camera is driven by 24 high power LEDs and is 50% more powerful than previous models.", "With it, the Arqus can detect passive markers as far as 50 m (165 ft)2.", "With great power comes great distances.", "Our most powerful strobe yet."],
                        description: "The World's Motion Capture Technology Partner",

                        companyLink1: "https://www.qualisys.com/cameras/arqus/",
                        videoLinks1: [
                            "https://youtu.be/FA3WWZV8h4U", "https://youtu.be/sw_EQ8l6vME?list=PLayfN54QgJo0nJxVEtkrEItdRvcRou61I", "https://youtu.be/lE1auuqQpZA?list=PLayfN54QgJo0nJxVEtkrEItdRvcRou61I"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        description3: "",


                        description4: "",

                        subtitle51: "--Our most powerful strobe yet.",
                        description5: "",


                        subtitle61: "",
                        description6: "",


                        title2: "",
                        description21: "The platform provides superior resolution, maxed out frame rates and anything in-between. More importantly, Arqus advanced marker detection algorithms provide exceptional accuracy.",
                        description22: "",
                        subtitle2: "Motion Capture advantages compared with IMU systems:",
                        bulletPoints2: [
                            "Highest precision/accuracy",
                            "Unlimited number of markers can be added",
                            "No charging of the system needed",
                            "Synchronized videos"
                        ],
                        title3: "",
                        description31: "",
                        description32: "",
                        subtitle3: "Applications",
                        bulletPoints3: [
                            "Online Reporting",
                            "Baseball Analysis",
                            "Cycling Analysis",
                            "Functional Assessment",
                            "Gait Analysis",
                            "Golf Analysis",
                            "Running Analysis"
                        ],


                        title4: "",
                        description41: "",
                        description42: "",











                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/Arqus fet.jpg"),
                                linkname: "Qualisys",
                                link: "https://www.qualisys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/Arque  (1).jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/Arque  (2).jpg"),
                            },

                        ],
                    },
                    {
                        id: 3,
                        title: "Miqus Hybrid",

                        cover: require("../../Assets/Products/Ergonomics/Products/mq hibride.jpg"),
                        description: "This dual-mode camera streams full HD color video at 85 frames per second or marker data at 340 frames per second. Transitioning between marker-based capture and markerlesscolor video capture is effortless—just a single click in Qualisys Track Manager (QTM).",
                        description2: "",

                        title2: "The Miqus Hybrid offers seamless switching between marker-based and markerless motioncapture.",
                        description21: "The Miqus Hybrid system is ideal for researchers exploring markerless motion capture algorithms. It serves as both a ground truth system and a research accelerator with synchronized and calibrated cameras ready for immediate use.",
                        description22: "Capture marker-based motion data in one session, then seamlessly switch to markerless motion capture using the same software, cameras, and coordinate system for effortless comparisons. For added flexibility, you can opt for dedicated marker-based cameras alongside Miqus Video cameras. These integrate seamlessly within the same system, enabling simultaneous capture of both marker-based and markerless data.",
                        subtitle2: "Key Features of Miqus Hybrid System",
                        title2m: "A Versatile Solution for Markerless Research.",
                        bulletPoints2: [
                            "Dual Mode Operation: Supports both marker-based and markerless motion capture using the same camera system",
                            "High-Speed Performance: Streams full HD color video at 85 fps or marker data at 340 fps.",
                            "Future-Proof Investment: Combines proven marker-based technology with the flexibility of markerless motion capture.",
                            "Seamless Integration: Easily switch between tracking modes with Qualisys Track Manager (QTM).",



                            "Markerless tracking",

                        ],
                        companyLink1: "https://www.qualisys.com/features/markerless-motion-capture/",
                        videoLinks1: [
                            "https://youtu.be/3i9Ju2gjavE",
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        subtitle2m: "Advanced Video Capabilities",
                        bulletPointsm: ["Miqus Video offers HD color video streaming up to 480 fps and a resolution of 2.8MP, ideal for markerless capture.", "Development and testing of markerless motion capture algorithms for natural interface design."],
                        subtitle3m: "Animation and Game Development",
                        bulletPoints1m: ["Dual-purpose motion capture for creating realistic character movements and visual effects."],

                        title3: "",
                        description31: "",
                        description32: "",





                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/Miqus_hybrid fet.png"),
                                linkname: "Qualisys",
                                link: "https://www.qualisys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/marq hybride.jpg"),
                            },

                        ],
                    },
                    {
                        id: 4,
                        title: "Miqus Video ",
                        title2C: "Designed for professionals.",
                        cover: require("../../Assets/Products/Ergonomics/Products/m videos.jpg"),
                        description: "The Miqus Video Plus is equipped with an advanced image sensor that delivers exceptional color video quality and high-resolution captures. With built-in strobe lighting featuring white high-power LEDs, automatic synchronization with other Miqus and Arqus cameras, and onboard compression using MJPEG, the Miqus Video Plus simplifies the capture process while maximizing performance.",
                        subtitle21: "",
                        description2: "",

                        title2: "",
                        description21: "",
                        description22: "",
                        subtitle2: "Speed and performance redefined, Unmatched quality and resolution.",

                        title3: "",
                        description31: "Equipped with the latest image sensor technology, the Miqus Video Plus delivers exceptional image quality even under low-light conditions. It boasts a 30% higher resolution than standard Full HD cameras, providing full resolution at 2.8 megapixels (MP), for crystal-clear clarity with every captured motion.",
                        description32: "",
                        subtitle3: "Key Features",
                        bulletPoints3: [
                            "High-quality color video",
                            "Full resolution at 2.8 MP, 1920 x 1440",
                            "Streams full HD at 120 fps",
                            "Streams 720p at 480 fps",
                            "Synchronized 3D data overlay",
                            "Daisy chained connection",
                            "Standalone operation or seamlessly integrate with any Qualisys mocap system"

                        ],

                        companyLink1: "https://www.qualisys.com/cameras/miqus-video/",
                        videoLinks1: [
                            "https://youtu.be/vJpjEqXyec0?list=PLayfN54QgJo0nJxVEtkrEItdRvcRou61I", "https://www.qualisys.com/my/qacademy/#!/tutorials/how-to-use-qualisys-video-cameras-with-qtm"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        title4: "",
                        description41: "",
                        description42: "",




                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/miqus-video fet.jpg"),
                                linkname: "Qualisys",
                                link: "https://www.qualisys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/m video (1).jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/m video (2).jpg"),
                            },

                        ],
                    },
                ]
            },
            {
                id: 9,
                subcategory: "Delsys",
                title: "",
                subtitle: "Delsys – Complete Solutions for Human Movement",
                subdesc: "With Delsys, gain accurate, real-time insights into human movement—empowering innovation in health, science, and education.",
                description: "Delsys offers advanced wireless EMG-based systems designed to monitor and analyze human movement with precision. Widely used in research, clinical, and educational environments, Delsys products provide complete solutions for studying muscle activation, motor control, rehabilitation, and performance analysis.",
                cover: require("../../Assets/Products/Biomechanics/Delsys-banner.png"),
                brand: require("../../Assets/Products/Biomechanics/Delsyslogo.png"),
                backcolor: "#0a0a0a",

                subtitle102: "Key Applications:",
                bulletPoints102: [
                    "Endurance Sports.",
                    "Strength & Conditioning.",
                    "Physical Therapy.",
                    "Moxy Training Centers.",
                    "Storage Case: Durable and portable for safe storage and transport.",
                ],

                subtitle192: "Featured Products:",
                bulletPoints192: [
                    "Trigno Wireless EMG System :- High-fidelity EMG with motion tracking (IMU).",
                    "Trigno Avanti Sensors :- Compact, dual-function sensors for EMG + movement.",
                    "Trigno Quattro & Mini Sensors :- Multi-channel and pediatric-friendly EMG sensors",
                    "EMGworks® Software Suite :- Advanced data acquisition and analysis tools",
                    "Storage Case :- Durable and portable for safe storage and transport.",
                ],


                Products: [
                    {
                        id: 1,
                        title: "Trigno Mobile System",

                        title2: "KIT FOR RESEACH TRAINING AND CLINICAL SYSTEM",
                        title04: "On-the-go tools for clinical and teaching applications.",
                        cover: require("../../Assets/Products/Biomechanics/Products/Section Image.jpg"),
                        description: "Unlock comprehensive insights into muscle activity and movement with Delsys Mobile EMG Systems. Designed for research, clinical, and educational use, these kits provide synchronized EMG and motion capture data for rehabilitation, performance analysis, and teaching",
                        description2: "",


                        subtitle182: "Each kit features advanced Delsys sensors, including:",
                        bulletPoints182: [
                            "Trigno Avanti Sensors :– wireless EMG sensors with integrated inertial measurement (IMU) for motion tracking.",
                            "Trigno Galileo Sensors :– high-fidelity EMG sensors for deep muscle analysis.",
                            "Trigno Quattro Sensors :– multi-channel EMG sensors for detailed muscle mapping.",
                            "Trigno Mini Sensors :– compact EMG units ideal for small muscle groups or pediatric applications.",
                        ],
                        subtitle1802: "Trigno Mobile System Features:",
                        bulletPoints1802: [
                            "Compatible with various Trigno sensors",
                            "Bluetooth Connectivity",
                            "Data collection with Mobile EMG Suite",
                            ,
                        ],
                        subtitle1803: "Application areas: ",
                        bulletPoints1803: [
                            "Trigno Mobile for Grip Strength",
                            "For education",
                            "For balance training",
                            "For muscular Imbalance",
                            "For physical therepy",
                            "For sports"
                            ,
                        ],

                        companyLink1: "https://delsys.com/products/#system",
                        videoLinks1: ["https://www.youtube.com/watch?v=ojLik28e_kE", "https://www.youtube.com/watch?v=m63UtuoZwYQ", "https://www.youtube.com/watch?v=JA5sjNgcumU", "https://www.youtube.com/watch?v=F7PM5C-M6OA"],
                        buttons1: "VISIT THE COMPANY WEBSITE",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel EMG fet.png"),
                                linkname: "Delsys",
                                link: "https://delsys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 1,
                        title: "Trigno Centro EMG System:",
                        title2: "Complete Solutions for Human Movement",
                        title05: "Built on the past, informed by the present, designed for the future.",
                        cover: require("../../Assets/Products/Biomechanics/Products/Trigno-Centro.jpg"),
                        description: "Human movement is complex. Trigno Centro dynamically unravels this complexity.Discover the intricacies and co-ordination of motor control.Designed for unrivaled research quality in human movement, engineering, and neurophysiology applications.Crafted to deliver unmatched precision for research in human movement, engineering, and neurophysiology, the only boundary for your discoveries is your imagination.",
                        description2: "",
                        companyLink1: "https://delsys.com/product/trigno-centro/",
                        videoLinks1: ["https://www.youtube.com/watch?v=coe-QmJ4dqk", "https://www.youtube.com/watch?v=VpyQrVVdIÈ"],
                        buttons1: "VISIT THE COMPANY WEBSITE",

                        subtitle182t: "Trigno System Features:",
                        bulletPoints182t: [
                            "Compatible with all Trigno sensors and PC software",
                            "Support 2- 32 sensors",
                            "Communicate via RF protocol",
                            "Integrate with Trigger Module, analog outputs, API,  SDK, and third-party software plugins",
                        ],
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel EMG fet.png"),
                                linkname: "Delsys",
                                link: "https://delsys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/trigo centero h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/trigo centero h2.jpg"),
                            },
                        ],

                    },
                    {
                        id: 1,
                        title: "Trigno Lite System",
                        title2: "EMG + Movement Made Simple",
                        cover: require("../../Assets/Products/Biomechanics/Products/4-channel-emg-system.jpg"),
                        description: "TheTrigno Lite System combines research-grade EMG and movement sensors with the simplicity of a laptop or tablet, offering point-of-care results with minimal setup. Ideal for clinical, educational, and field-based research, it delivers high-quality physiological and biomechanical data in real time.",

                        description2: "",



                        subtitle172: "Key Applications:",
                        bulletPoints172: [
                            "Human Movement Analysis",
                            "Physical Rehabilitation & Therapy",
                            "Sports Performance & Ergonomics",
                            "Classroom Demonstrations & Student Projects",

                        ],

                        subtitle193: "Featured Products:",
                        bulletPoints193: [

                            "Wireless Trigno Sensors for EMG + IMU data",
                            "Easy data acquisition via USB receiver",
                            "Real-time visualization and storage with Trigno Discover software",
                            "Proprietary RF protocol ensures precise synchronization",
                            "Plug-and-play usability—no complex setup needed",
                        ],
                        subtitle194: "TrignoLite System Includes:",
                        bulletPoints194: [

                            "Trigno Avanti –: Compact EMG + motion sensor",
                            "Trigno Mini –: Ideal for small or pediatric muscle groups",
                            "Trigno Quattro –: Multi-channel EMG for detailed studies",

                        ],

                        companyLink1: "https://delsys.com/product/trigno-lite/",
                        videoLinks1: ["https://youtu.be/evNtRJKOXQ0"],
                        buttons1: "VISIT THE COMPANY WEBSITE",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel EMG fet.png"),
                                linkname: "Delsys",
                                link: "https://delsys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/trigro system.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel h2.jpg"),
                            },
                        ],
                    },

                ]
            },



            {
                id: 10,
                subcategory: "Bertec",
                title: "",
                subtitle: "Engineered for the exacting",
                subtitle106: "Solution you can trust",
                subtitle107: "Better Maesures, Better Outcomes",
                subdesc: "Turned to by industry leaders worldwide for three decades and counting, Bertec provides precisely engineered solutions for those seeking accurate measurement. From design to engineering to production, we pay attention to every detail, so the biomechanical engineering industry can advance its understanding of the human body.",
                subdesc106: "Bertec’s technology is world-renowned for accuracy and dependability, and now your solution can leverage our reputation to deliver comprehensive products ahead of and beyond that of your competitors.",
                subdesc107: "Bertec elevates the clinical standard with superior design concepts and innovative technologies built on over thirty years of excellence in biomechanics. Providing reliable tools for the assessment and training of balance and mobility, Bertec’sproduct allow clinicians to customize and target therapy, resulting in greater patient motivation and optimal patient outcome.",
                // companyLink1: "https://www.qualisys.com/cameras/miqus-video/",
                // videoLink: [
                //     "https://youtu.be/4Ntexwf2XQM", "https://youtu.be/_VAOFqVNuRY", "https://youtu.be/2-dmguD-UBQ"
                // ],

                // buttons: "VISIT THE COMPANY WEBSITE",

                description: "",

                cover: require("../../Assets/Products/Biomechanics/bertec.webp"),

                brand: require("../../Assets/Products/Biomechanics/berteclogo.png"),
                backcolor: "grey",

                Products: [
                    {
                        id: 1,
                        title: "Instrumented Treadmill",
                        title2: "Fully Instrumented Treadmill v5 (FIT5)",
                        title201: "The FIT5 Instrumented Treadmill and Software",
                        title203: "Advancing Gait and Biomechanics Research with the FIT5",

                        cover: require("../../Assets/Products/Biomechanics/Products/force-plate.jpg"),
                        description: "The Bertec Fully Instrumented Treadmill v5 (FIT5) allows gait researchers to reduce laboratory space requirements and remove the limitations inherent in a traditional force plate walkway. The unique design features result in superior dynamic characteristics and a high natural frequency making it the preferred research-grade fully instrumented treadmill.The Bertec treadmill enables walking and running research with speeds up to 11.5 m/s and six-component force data output at 1000 Hz.",
                        description2: "",
                        description201s: "The Bertec Fully Instrumented Treadmill v5 (FIT5) combines precision measurement with an intuitive interface, making it an ideal solution for gait researchers and biomechanics labs. Its seamless integration of split-belt treadmill hardware and device-controlling software offers unmatched flexibility for creating custom, repeatable protocols.",
                        description201: "With the FIT5, researchers can precisely control the treadmill, view and capture real-time data on force, moment, and velocity, and design tailored experiments using the Protocol Builder. It’s hardware ensures smooth and consistent acceleration, essential for studies on perturbation and fall prevention.",
                        description202: "The FIT5 also features a Remote control API that integrates effortlessly with Python and motion capture systems, enabling advanced, feedback-based real-time controls. In this blog, we’ll delve into how these features empower researchers to develop customized protocols and achieve breakthrough results in gait and biomechanics studies.",
                        description203: "The FIT5 treadmill and its dedicated software offer researchers a high-quality, low-vibration platform that accurately replicates natural walking and running patterns. Designed with precision, the FIT5 enables live data visualization, customizable treadmill protocols for consistent experiments, and synchronized data capture for highly accurate results.",
                        description204: "The built-in Protocol Builder simplifies perturbation research and training, making it easier to study fall risks and develop effective strategies to reduce them. With its advanced features, the FIT5 supports groundbreaking research in gait analysis and fall prevention.",

                        videoLinks1: [
                            "https://youtu.be/4Ntexwf2XQM",
                            "https://youtu.be/_VAOFqVNuRY",
                            "https://youtu.be/2-dmguD-UBQ"
                        ],
                        companyLink1: "https://www.bertec.com/products/force-plates",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        subtitle201: "The Bertec FIT5: A Fully Instrumented Treadmill for Precise Gait Analysis and Biomechanics Research",

                        bulletPoints201: [
                            "Independent motion control of each belt",
                            "Industry-leading accuracy",
                            "Ease of treadmill control",
                            "Variety of applications and ease of integration",
                            "Unique design features",
                            "Fully redesigned software solution",
                            "Create custom experimental protocols",
                            ,],

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/force-platefet.jpg"),
                                linkname: "Bertec",
                                link: "https://www.bertec.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/forceplateh1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/forceplateh2.webp"),
                            },
                        ],
                    },

                    {
                        id: 2,
                        title: "force plates",
                        title2: "",
                        title207: "Bertec® Fixed Walkway",
                        cover: require("../../Assets/Products/Biomechanics/Products/trademill.jpg"),
                        description: "Bertec force plates are designed for gait, balance, and performance analyses. Our patented strain gauge technology, innovative transducer designs, and quality manufacturing help you capture the highly accurate data needed for your research.",
                        description2: "The Bertec Fixed Walkway allows researchers to mount Bertec’s fixed force plates in a customizable in-series configuration for various biomechanics applications. The Walkway gives users the ability to independently reconfigure their force plates depending on their experimental needs while maintaining the accuracy and quality of their data. Researchers also gain the option to add more force plates to their walkway over time to easily increase their data collection capacity.",
                        videoLinks1: [
                            "https://youtu.be/4Ntexwf2XQM",
                            "https://youtu.be/_VAOFqVNuRY",
                            "https://youtu.be/2-dmguD-UBQ"
                        ],
                        companyLink1: "https://www.bertec.com/products/force-plates",
                        buttons1: "VISIT THE COMPANY WEBSITE ",


                        bulletPoints208: [
                            "Wide range of applications.",
                            "Variety of sizes and load ranges",
                            "Superior electronics",
                            "Negligible cross talk, drift and signal interference",
                            "Ease of data collection ",
                            "Strongest industry warranty ",

                            ,],
                        subtitle210: "Configurable Walkway Design",
                        bulletPoints210: [
                            "Choose the number of force plates for your walkway ",
                            "Application-specific configurations ",
                            "Independent reconfiguration eliminates future installation cost ",
                            "Available for 2 Bertec Fixed Force Plate sizes (40x60 cm and 60x90 cm) ",
                            "Capable of up to 4000 lb load capacity ",
                            "High natural frequency ",
                            "1000 Hz sampling rate",

                            ,],
                        subtitle209: "Package Includes:",

                        bulletPoints209: [
                            "Chosen amount of force plates",
                            "Appropriate number of half-sized filler plates (see table) ",
                            "2x 180 cm-long mounting plates  ",
                            "Guide for repositioning force plates",

                            ,],


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/trademill fet.jpg"),
                                linkname: "Bertec",
                                link: "https://www.bertec.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/trademill h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/trademill h2.webp"),
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "Computerized Dynamic Posturography",
                        title2: "(CDP/IVR)",
                        cover: require("../../Assets/Products/Biomechanics/Products/Posturography.jpg"),
                        description: "Bertec’s Computerized Dynamic Posturography (CDP/IVR) combines immersive virtual environments with dual-balance force plate technology. The advancements in Bertec’s technology increase the clinical value of CDP in both assessment and targeted therapy interventions, especially for patients suffering from dizziness, balance problems and/or motion sensitivity. Training with immersive, virtual stimuli can increase patient motivation, adaptability and variability—all factors that positively affect patient outcomes.",
                        description2: "",
                        videoLinks1: [
                            "https://youtu.be/c5fSXtVrMdw"
                        ],
                        companyLink1: "https://www.bertec.com/products/cdp-ivr",
                        buttons1: "VISIT THE COMPANY WEBSITE",

                        bulletPoints208: [
                            "Wide range of applications.",
                            "Variety of sizes and load ranges",
                            "Superior electronics",
                            "Negligible cross talk, drift and signal interference",
                            "Ease of data collection ",
                            "Strongest industry warranty ",

                            ,],
                        subtitle210: "Featured Training",
                        bulletPoints210: [
                            "Quick Training",
                            "Mobility",
                            "Closed Chain",
                            "Weight Shifting",
                            "Vision ",


                            ,],

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/Posturography fet.jpg"),
                                linkname: "Bertec",
                                link: "https://www.bertec.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/Posturography h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/Posturography h2.jpg"),
                            },
                        ],
                    },
                ]
            },

        ],
    },
    {
        id: 4,
        Category: "Physiology",
        cover: require("../../Assets/Products/Physiology/moxymonitor.jpg"),
        link: "pukhya/physiology",
        subcategories: [

            {
                id: 11,
                subcategory: "Muscle Oxygen Monitor",
                title: "",
                subtitle: "Why Moxy Monitor:",
                subdesc: "PRECISION INTENSITY CONTROL FOR EFFECTIVE TRAINING",
                bulletPoints12: [
                    "Sports Training and Performance",
                    "Rehabilitation and Recovery Monitoring",
                    "Physiological Research",
                    "Endurance and High-Intensity Workouts",
                    ,],
                description: "The Moxy Monitor is a portable, non-invasive device designed to measure muscle oxygen saturation (SmO2), empowering athletes to optimize their training. Trusted by Olympic and World Champions, it provides real-time insights to enhance performance in various fields, including :",
                description06: "With our muscle oxygen monitor you can gather data to precisely control your training intensity.",
                description07: "Start Optimizing Your Performance Through Precision Intensity Control.",
                cover: require("../../Assets/Products/Physiology/moxymonitor.jpg"),
                // cover: require("../../Assets/Products/Physiology/moxymonitor.jpg"),
                brand: require("../../Assets/Products/Physiology/moxy-logo.webp"),
                backcolor: "#AEAAA0",
                Products: [
                    {
                        id: 1,
                        title: "Moxy Monitor",
                        title2: "Moxy 1-Sensor Bundle: Versatile Performance and Research Tool",
                        title03: "Moxy Monitor is Made for Athletes",
                        cover: require("../../Assets/Products/Physiology/Products/Moxymonitor.png"),
                        description: "The Moxy 1-Sensor Bundle is ideal for athletes seeking a daily training companion or researchers focused on monitoring a single site. It measures SmO2 and THb on any superficial muscle, offering precise insights for performance optimization or scientific analysis.",
                        description2: "This bundle provides everything needed for precise muscle oxygen monitoring in training or research settings.",
                        description3: "Whether you are using Moxy Monitor for endurance, strength and conditioning, or physical therapy, you will gain personal insights needed to elevate your performance to new levels.",



                        subtitle102: "Bundle Includes:",
                        bulletPoints12: [
                            "Moxy Sensor with Light Shield: Accurate, reliable monitoring.",
                            "Wireless Charger with USB Cable and Wall Plug: Convenient charging solution.",
                            "Light Shield Adhesive Attachments (2 Packs): Ensures secure placement.",
                            "Small Adhesive Attachments (2 Packs): For added flexibility and ease of use.",
                            "Storage Case: Durable and portable for safe storage and transport.",
                        ],

                        companyLink1: "https://www.moxymonitor.com",
                        videoLinks1: [
                            "https://youtu.be/5Jp5Jz61mUM"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        subtitle102: "Moxy Monitor is Made for Athletes",
                        bulletPoints102: [
                            "Endurance Sports.",
                            "Strength & Conditioning.",
                            "Physical Therapy.",
                            "Moxy Training Centers.",
                            "Storage Case: Durable and portable for safe storage and transport.",
                        ],

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Physiology/Products/Moxymonitorfet.webp"),
                                linkname: "Moxy Monitor",
                                link: "https://www.moxymonitor.com/",
                            }
                        ],
                        highlights: [
                            // {
                            //     id: 1,
                            //     cover: require("../../Assets/Products/Physiology/Products/Moxymonitor h1.jpg"),
                            // },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Physiology/banner-4-change.jpg"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 12,
                subcategory: "Ergospirometer",
                title: "",
                subtitle: "",
                subtitle001: "What is VO2 Max?",
                subtitle01: "MES VO2max Ergospirometer Machine",
                subdesc: "",
                description: "The SVO2 max is a key indicator of your body’s ability to utilize oxygen during exercise. It measures the maximum amount of oxygen you can consume, reflecting your aerobic capacity and overall fitness level. A higher VO2 max signifies more efficient oxygen use, enabling better energy production and improved physical performance.wedish motion capture company.",
                description01: "The VO2max Ergospirometer is a versatile and portable device designed for comprehensive exercise testing of the respiratory and circulatory systems. It excels in evaluating performance under natural conditions, such as running, cycling, rowing, sailing, or canoeing, during real-world training, competitions, or rehabilitation sessions—without requiring additional loading equipment like treadmills or bicycle ergometers.",
                description02: "This advanced device is equally effective in laboratory settings, where it integrates seamlessly with connected treadmills or bicycle ergometers to provide controlled load testing. The VO2max Tracker meets and exceeds the rigorous accuracy standards set by the American Thoracic Society and the European Respiratory Society, ensuring reliable and precise results.",
                description03: "A VO2 max test measures how much oxygen you breathe in during exercise. The more oxygen you can breathe in, the harder your muscles can work.",
                subtitle12: "Application Areas:",
                bulletPoints12: [
                    "Cardiopulmonary Exercise Testing",
                    "Pulmonology and Exercise Physiology",
                    "Sports Medicine and Cardiac Rehabilitation",
                    "Occupational Medicine and Intensive Supervision",
                    "Natural Medicine, Nutrition, and Environmental Medicine"
                    ,],


                cover: require("../../Assets/Products/Physiology/mes banner.jpg"),
                brand: require("../../Assets/Products/Physiology/meslogo.gif"),
                backcolor: "#5fc1d2",
                Products: [
                    {
                        id: 1,
                        title: "VO2max Tracker",
                        title0: "Ergospirometer: Advanced Portable Cardiopulmonary Testing",
                        title01: "In a field and In a Laboratory making metabolic measurement easy and accurate.",
                        title2: "",
                        cover: require("../../Assets/Products/Physiology/Products/mes vo2max.jpg"),
                        description: "VO2maxTracker ergospirometer is a powerful portable system for cardiopulmonary exercise tests performed in a natural fieldRunning,Biking,Rowing,Sailing.",
                        description2: "The VO2max Tracker Ergospirometer is a powerful and portable system designed for cardiopulmonary exercise testing in natural environments, including running, cycling, rowing, and sailing. It enables real-time assessment during training, competition, or rehabilitation, eliminating the need for stress devices like stationary treadmills or bicycles.This versatile system can also be used in laboratory settings, seamlessly integrating with equipment such as treadmills or cycle ergometers for controlled testing. Meeting and exceeding the accuracy standards set by the American Thoracic Society and the European Respiratory Society, the VO2max Tracker delivers precise and reliable results.Developed by top-class engineers with years of expertise, this system combines advanced functionality with ease of use, making it a trusted tool for both field and lab-based cardiopulmonary testing.",

                        subtitle2: "VO2maxTracker ergospirometer Features and Advantages:",
                        bulletPoints2: [
                            "lightweight, portable measuring system suitable for field and laboratory operation.",
                            "breath-by-breath analysis method.",
                            "lightweight, low-resistant pneumotach headpiece MES DV40 without movable elements.",
                            "measuring air flow system with digital converter placed inside a coupler of the MES DV40 pneumotachograph close to headpiece.",
                            "air tubes for flow measurement eliminated and digital signal is sent by a cable to the main unit.",
                            "sensors for automatic ambient conditions measuring system built."
                        ],

                        companyLink1: "https://pdf.medicalexpo.com/pdf/mes/vo2maxtracker/69379-256187.html",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=EoTjdLVlO1Y"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Physiology/Products/vo2fet.webp"),
                                linkname: "MES",
                                link: "https://www.medicalexpo.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Physiology/Products/vo2max_trackers.jpg"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "Vo2 Max Finder",
                        title2: "",
                        cover: require("../../Assets/Products/Physiology/Products/vo2maxfinder.webp"),
                        description: "The VO2maxFinder Ergospirometer is an advanced, stationary medical device developed by MES, leveraging cutting-edge technology for comprehensive cardiopulmonary exercise testing (CPET) in laboratory settings. Designed specifically for CPET labs, the system integrates the MES DV40 pneumotachograph, a new digital converter, and ultra-fast gas analyzers to enable precise breath-by-breath analysis. This modular device offers unmatched accuracy and efficiency, making it an ideal solution for evaluating respiratory and circulatory system performance during exercise.",
                        description2: "Stress test system based on 12-lead ECG Powerful evaluation software with report generator The software developed and manufactured by MES gives you virtually unlimited programming possibilities of measurement, its visualization, to define their own parameters and new predicted values. The user has a full set of standard reports and algorithms research. The software also gives you the ability to archive and complete courses of study results of multiple studies.",


                        subtitle2: "Key Features and Benefits of the VO2max Finder Ergospirometer:",
                        bulletPoints2: [
                            "Advanced Testing Methodology - Utilizes a breath-by-breath approach for precise and detailed analysis.",
                            "Innovative Hardware - Lightweight, low-resistance pneumotach headpiece with no moving parts ensures durability and accuracy.",
                            "High-Tech Gas Sensors - Long-lasting sensors with automated two-point calibration for reliable gas analysis.",
                            "Environmental Adaptability - Automatic measurement of ambient conditions for accurate data capture.",
                            "Dynamic Data Display - Real-time visualization of O2, CO2, flow, and volume waveforms in pre-defined or user-customized formats.",
                            "Exercise Analysis - Includes real-time exercise flow-volume loops and thresholds (aerobic, anaerobic, RCP) determination, either automatic or manual."
                            , "Custom Protocols - Supports standard and user-defined exercise protocols with tailored parameters and equations.",
                            "Comprehensive Reporting - Displays measured values alongside standard benchmarks and offers ready-to-print pre-defined and customizable reports, including a 9-plot Wasserman analysis.",
                            "Cardiac Insights - Features the Wassermann Algorithm for indirect cardiac output and wireless or 12-ECG lead pulse measurements.",
                            "Enhanced O2 Kinetics - Automatically calculates O2 debt, deficit, and tau values for in-depth performance evaluation.",
                        ],

                        companyLink1: "https://pdf.medicalexpo.com/pdf/mes/ergospirometer-vo2max-finder/69379-144294.html",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=EoTjdLVlO1Y"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",



                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Physiology/Products/vo2fet.webp"),
                                linkname: "MES",
                                link: "https://www.medicalexpo.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Physiology/Products/finder.jpg"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "OmniSense™ Analysis Software",
                        title2: "",
                        cover: require("../../Assets/Products/Physiology/Products/section-image.jpg"),
                        description: "OmniSense™ Analysis software processes data from OmniSense™ Live sessions or BioModule™ memory logs, enabling detailed evaluation of fitness and performance trends over time.",
                        description2: "",

                        subtitle2: "Key features include:",
                        bulletPoints2: [
                            "Data Filtering - Organize by individuals, teams, and specific dates.",
                            "Session Selection - Choose sessions for focused analysis.",
                            "Visualization Options - Export or print data as time waveforms, histograms, spreadsheets, or polar plots.",
                            "Custom Reporting - Generate reports to enhance fitness strategies and training optimization.",
                        ],
                        subtitle05: "OmniSense™ Software Product Features",
                        bulletPoints05: [
                            "Automatic Fitness Test- Get a snapshot of 1 to 100 people simultaneously. Live or logged in the database.",
                            "Heart Rate Variability Analysis - Use the free Zephyr™ tool or a compatible open-source tool to calculate six stats, live or logged.",
                            "Readiness Metric- Calculate a readiness score of 0 to 10 so you can identify times of peak performance based on each individual’s mechanical load in training or in action.",
                            "Impact Processor Reports- Obtain instant feedback on each individual’s performance, along with associated graphs and reports that enable you to develop individual and team training strategies.",
                            "OmniSense™ Deployment Tool - OmniSense™ software is easy to deploy and use. It has to be. In the field, you can’t always count on having technical support. That’s why organizations like NASA and the U.S. Army Special Forces choose OmniSense™ software.",
                            "Custom Reporting - Generate reports to enhance fitness strategies and training optimization.",


                        ],

                        subtitle03: "Other function updates include:",
                        bulletPoints03: [
                            "GPS visualization.",
                            "Improved HRV algorithm.",
                            "Readiness app for iOS and Android devices.",
                            "Workout files with supporting audio text to speech",
                            "Analysis data filters",
                            "Control of markers in OmniSense™ Analysis software.",
                            "Change time of session",


                        ],




                        companyLink1: "https://www.zephyranywhere.com/resources/omnisense-software#:~:text=OmniSense%E2%84%A2%20Analysis%20software%20takes,Filter%20people%2C%20teams%20and%20dates",
                        videoLinks1: [
                            ""
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",








                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Physiology/Products/Omnisence fet.jpg"),
                                linkname: "MES",
                                link: "https://www.medicalexpo.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Physiology/Products/omnise banners.jpg"),
                            },
                        ],
                    },
                ]
            },

        ],
    },
    {
        id: 5,
        Category: "Ergonomics",
        cover: require("../../Assets/CategoryPage/Exercise & Sports Physiology.jpg"),
        link: "pukhya/ergonomics",
        subcategories: [
            {
                id: 6,
                subcategory: "Ergoneers",
                title: "Observe. Simulate. Analyse. Design. Controle. Automate. Improve",
                subtitle: "",


                description: "Ergoneers serves a diverse array of industries, including automotive, consumer goods, healthcare, and academia, by delivering advanced solutions for understanding human behavior. Their expertise supports innovation, safety, and product development, from refining vehicle interfaces to enhancing workplace ergonomics.",

                subdesc: "Driven by a commitment to research excellence, Ergoneers empowers clients worldwide with cutting-edge tools and tailored solutions that uncover actionable insights, improve product usability, and optimize ergonomic designs. Their dedicated team ensures seamless integration of these tools, making them a trusted partner in human-centered innovation.",

                thirdParagraph: "By focusing on quality, innovation, and user needs, Ergoneers leads the field of human factors research, driving advancements that benefit industries, enhance safety, and elevate everyday experiences.",
                bulletPoints: [
                    "Comprehensive Platform: Porphea.X offers a 360-degree solution for data collection and analysis in user and behavior studies.",
                    "Multimodal Data Measurement: Supports the measurement of eye-tracking, video, audio, physiology, and CAN-bus data.",
                    "Integrated Software Modules: Features specialized modules for seamless data collection and analysis across multiple domains.",
                    "Versatile Applications: Ideal for a wide range of research and user behavior studies, providing actionable insights."
                ],


                brand: require("../../Assets/Brands/Ergoneerslogo.png"),
                cover: require("../../Assets/Products/Psychology/ergoneers.jpg"),
                backcolor: "#b57347",
                Products: [

                    {
                        id: 1,
                        title: "Ergoneers Dikablis Glasses X Eye Tracker",
                        title2: "Advanced Eye-Tracking Technology with d-lab",
                        cover: require("../../Assets/Products/Psychology/Products/eyetracker-section-image.jpg"),
                        description: "The DikablisGlassesX deliver highly accurate binocular eye tracking with standardized metric calculations. Designed for comfort, they provide a snug fit, even for users wearing prescription glasses. Ideal for studying human behavior in dynamic environments, they offer unparalleled versatility and precision.",
                        description2: "Powered by the D-Lab measurement and analysis platform, the DikablisGlassesX enable synchronous collection and analysis of gaze data from multiple sources.",

                        description3: "",
                        description4: "",
                        description5: "It enables three input channels for synchronous recording: One sensor, specific for your analysis module, one USB- or webcam, and one microphone.",
                        description6: "",


                        subtitle2: "Key features include:",
                        bulletPoints2: [
                            "Futuristic Design: Sleek, modern aesthetics paired with ergonomic comfort.",
                            "Wide Customization Options: Adjustable settings to meet diverse research needs.",
                            "Raw Data Access: Full transmission of raw eye-tracking data for in-depth analysis.",
                            "High Precision: Exceptional accuracy in eye tracking for reliable insights."
                        ],
                        title3: "",
                        description31: "The Dikablis Glasses 3 are an indispensable tool for eye-tracking studies in research and development, offering comprehensive solutions for behavioral analysis.",
                        description32: "",


                        videoLinks1: [
                            "https://www.youtube.com/watch?v=WdXSZEitrug"
                        ],

                        title5: "Dikablis Glasses 3: Flexible Eye-Tracking Solutions with Wired and Wireless Options",
                        description51: "Each Dikablis Glasses 3 package includes essential components: a head unit with a standard lens, four interchangeable nose pieces, an eBox, USB and HDMI cables, power supplies, a USB stick with manuals and documentation, and a microfiber cleaning cloth.",
                        description52: "For tailored research needs, two variants are available:",
                        subtitle5: "Dikablis Glasses 3 Cable",
                        bulletPoints5: [
                            "Connect directly to the recording computer for uninterrupted data collection.",
                            "Enables live observation of data during the study.",
                            "Ideal for controlled environments requiring a stable setup.",
                        ],


                        subtitle6: "Dikablis Glasses 3 Wireless",
                        bulletPoints6: [
                            "Features a wBox for data storage and real-time WLAN transmission to a computer.",
                            "Includes a battery-powered wireless router for unrestricted mobility during studies. ",
                            "Suitable for dynamic environments, allowing research to be conducted freely without power supply constraints.",
                            "Live observation remains possible for real-time insights.",
                        ],



                        title7: "",
                        description71: "Both options provide advanced eye-tracking solutions, ensuring flexibility and reliability for various research settings.",
                        description72: "",
                        subtitle7: "Write as a note different and bold font:",

                        title8: "Note:",
                        description81: "Dikablis Glasses 3 come with a free copy of our comprehensive software package D-LAB Eye Tracking Head Mounted lite and D-LAB Audio lite. This software makes our high-end eye tracker a plug & play solution and enables researchers to plan, measure and analyze their studies in an effective and easy way. D-LAB can easily be upgraded for automatic eye tracking analysis or to record and analyze other sensors like physio devices, car data or external cameras synchronously with the eye tracking data.",



                        description86: "",






                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/eye_tracking_dlab fet.jpg"),
                                linkname: "Ergoneers",
                                link: "https://ergoneers.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/eyetracker-banner-1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/Products/eye-yracker-bannerimage-2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "Prophea.X",
                        title2: "The most versatile software ecosphere for holistic, human-centered situation analysis.",
                        cover: require("../../Assets/Products/Psychology/Products/propheax-lower-section-image.jpg"),
                        description: "At the heart of Ergoneers’ offerings is Prophea.X, a robust, modular software platform designed for the comprehensive analysis of behavioral data. Prophea.X supports multi-sensor synchronization, allowing users to integrate data from eye tracking, EEG, motion tracking, and other sensors to get a complete picture of human interactions, responses, and physical activity in various environments.",


                        description3: "",
                        description4: "",
                        description5: "It enables three input channels for synchronous recording: One sensor, specific for your analysis module, one USB- or webcam, and one microphone.",
                        description6: "",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=WdXSZEitrug"
                        ],
                        companyLink1: "https://ergoneers.com/wp-content/uploads/2023/12/ergoneers_Imagefilm_2023_Web_Version_101123_v010_MPEG4_1280x720_1_comp.mp4",
                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        title2: "",
                        description21: "",
                        description22: "",
                        bulletPoints2: [
                            "Comprehensive Platform: Porphea.X offers a 360-degree solution for data collection and analysis in user and behavior studies.",
                            "Multimodal Data Measurement: Supports the measurement of eye-tracking, video, audio, physiology, and CAN-bus data.",
                            "Integrated Software Modules: Features specialized modules for seamless data collection and analysis across multiple domains.",
                            "Versatile Applications: Ideal for a wide range of research and user behavior studies, providing actionable insights."
                        ],
                        title3: "",
                        description31: "",
                        description32: "",

                        title4: "Propheadata engine Lite",
                        description41: "",
                        description42: "",


                        title5: " ",
                        subtitle5: "All analysis modules within the Prophea.X ecosphere are delivered with Propheadata engine Lite.",
                        description51: "It enables three input channels for synchronous recording: One sensor, specific for your analysis module, one USB- or webcam, and one microphone.",
                        description52: "The Propheadata engine includes, by default, seven analysis-specific sensor inputs. Unlocking the full power of Prophea.X, Advanced Multi Sensor Packages are available in two options:",


                        title6: "Propheadata engine extended",
                        description61: "It is connectable with up to 20 sensor inputs.",
                        description62: "",

                        title7: "Propheadata engine unlimited",
                        description71: "For larger sensor-input requirements, is individually licensed up to an unlimited amount of input streams. ",
                        description72: "",
                        subtitle7: "Application Area:",
                        bulletPoints7: [
                            "Behavioral Research",
                            "Human Interaction Analysis",
                            "Multisensory Data Integration",
                            "Environmental Response Studies"
                        ],
                        title8: "",
                        description81: "",
                        description82: "",






                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/Prophea_X_fet.png"),
                                linkname: "Ergoneers",
                                link: "https://ergoneers.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/Products/banner-propheax.jpg"),
                            },

                        ],
                    },


                ]
            },
            {
                id: 1,
                subcategory: "Thought Technology",
                title: "Thought Technology in Ergonomics: BioGraph Infiniti Ergonomics Suite",

                description: "Powerful SEMG Recording and Analysis for Clinical & Research Applications, The BioGraph Infiniti Ergonomics Suite provides a robust platform for recording and analyzing surface electromyography (SEMG) data across 2 to 10 channels. Compatible with a range of Thought Technology encoders—FlexComp Infiniti, ProComp Infiniti, ProComp+, and ProComp5—this suite is ideal for both clinical biofeedback and ergonomic research.",

                subtitle6: "Key Features",
                sixthParagraph: "",
                bulletPoints6: [
                    "Flexible Channel Support: Record from 2 to 10 SEMG channels, tailored to your study or therapy needs.",
                    "High-Fidelity Data Acquisition- Record raw SEMG at 2048 samples/second for detailed analysis.",
                    "High-Fidelity Data Acquisition- Record RMS SEMG at 256 samples/second for real-time feedback applications.",
                    "Multisensor Integration: Supports force sensors and goniometry adapters for in-depth biomechanical analysis.",

                ],

                subtitle7: "Ideal For",
                seventhParagraph: "",
                bulletPoints7: [
                    "Ergonomics & Human Factors Research",
                    "Clinical Biofeedback Practitioners",
                    "Rehabilitation & Movement Specialists",
                    "Occupational Therapists",
                    "Sports Scientists & Trainers",
                ],







                cover: require("../../Assets/Products/Ergonomics/Products/ttl banners.jpg"),
                brand: require("../../Assets/Products/Psychology/thoughttec-brand.png"),
                backcolor: "#2E8E91",
                Products: [
                    {
                        id: 1,
                        title: "Ergonomics Suite",
                        title2: "",
                        cover: require("../../Assets/Products/procomp-5-sec-image.jpg"),
                        description: "",

                        subtitle21: "ProComp Infiniti™ — Advanced 8-Channel Biofeedback & Data Acquisition System",

                        description2: "The ProComp Infiniti™ is an advanced eight-channel, multi-modality physiological monitoring system that plays a vital role in ergonomics research and applied human factors studies. With its high-resolution data acquisition capabilities—2048 samples per second on the first two channels for raw EEG, EMG, or EKG, and 256 samples per second on the remaining six channels for slower signals such as respiration, temperature, and skin conductance—it allows for precise measurement of muscle activity, postural dynamics, and physiological responses to physical tasks. This makes it an ideal tool for assessing workplace ergonomics, identifying sources of repetitive strain, evaluating muscle fatigue, and optimizing workstation designs. The system’s compatibility with sensors for goniometry and force measurement enables detailed biomechanical analysis of joint movement and applied pressure, supporting injury prevention and rehabilitation strategies. Housed in an ergonomically designed case and requiring only a USB connection, the ProComp Infiniti™ is well-suited for both lab-based and field-based ergonomic evaluations. Its ability to record in real time via fiber-optic USB or store data on a Compact Flash memory card for later review provides flexibility for diverse research environments, from occupational health assessments to product usability testing.",

                        title2: "Thought Technology ProComp5 Infiniti™",
                        description21: "Advanced Multi-Channel Biofeedback & Physiological Data Acquisition System",
                        description22: "The ProComp5 Infiniti™ is a compact and powerful device designed for real-time physiological data acquisition in clinical, laboratory, and field environments. Its ergonomic design, portability, and USB connectivity make it an ideal solution for professionals seeking accuracy and flexibility.",
                        subtitle2: "Ergonomics Application with ProComp5 Infiniti™",

                        title3: "",
                        description31: "The ProComp5 Infiniti™ is a powerful tool in ergonomics research and assessment. It offers comprehensive data visualization and feedback for movement and muscle activity analysis.",
                        description32: "",
                        subtitle3: "Key Features",
                        bulletPoints3: [
                            "Five-Channel System: Includes the same inputs as the ProComp Infiniti™, minus the last three channels.",
                            "High Sampling Rate - Channels 1 & 2: 2048 samples/second for high-fidelity signals like EEG, SEMG, EKG, HR/BVP.",
                            "High Sampling Rate - Channels 3 to 5: 256 samples/second for slower signals like respiration and temperature.",
                            "Versatile Data Capture - Real-time via USB and fiber-optic connection.",
                            "Versatile Data Capture - Offline using Compact Flash memory or optional long-range telemetry."
                        ],


                        title4: "Ergonomics for the FlexComp Infiniti",
                        description41: "The FlexComp Infiniti™ is a high-performance physiological monitoring and data acquisition system ideally suited for advanced ergonomic research and biomechanical analysis. With its 10 high-speed channels sampling at 2048 samples per second and high-resolution 14-bit data acquisition, it allows ergonomists to capture precise measurements of muscle activity, joint movement, and physical strain during task performance. Its ability to monitor surface electromyography (SEMG) and display data in various formats—such as raw, RMS, median frequency, peak-to-peak, and 2D/3D spectral views—provides detailed insights into muscle activation patterns, fatigue analysis, and postural load. This makes it an invaluable tool for evaluating workstation design, assessing repetitive motion injuries, and developing injury prevention strategies. The system also supports synchronized recording of force and goniometry data along with video capture, allowing real-time correlation of movement and muscle activity with observed behavior. With the capability to connect to four encoders simultaneously, ergonomists can analyze full-body responses during complex tasks. Its internal user-activated calibration ensures consistently high-quality signals without the need for factory recalibration, while its dual-mode operation (real-time fiber optic or offline Compact Flash) makes it ideal for both lab-based and field-based ergonomic studies.",
                        description42: "",
                        subtitle4: "",

                        videoLinks1: [
                            "https://youtu.be/keMbk7uPPA0"
                        ],
                        companyLink1: "http://www.nexgenergo.com/ergonomics/thoughtergo.html",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/biofeedbackfet.jpg"),
                                linkname: "Thought tec",
                                link: "https://thoughttechnology.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/banner-image-22.jpg"),
                            },

                        ],
                    },


                    {
                        id: 4,
                        title: "Physiological Data Recorder",
                        title2: "Physiological Monitoring Solutions by Thought Technology",
                        cover: require("../../Assets/Products/Ergonomics/Products/er sectionsss.jpg"),
                        description: "Thought Technology’s advanced EMG and physiological monitoring solutions are essential tools for modern ergonomic assessment and intervention.These systems enable detailed worksite evaluations by quantifying job-related musculoskeletal stress and identifying high-stress task components with precision. Ergonomists can validate the effectiveness of interventions by comparing stress levels before and after changes, backed by comprehensive data and printable reports. In tool and product design, the systems support the creation of detailed Musculoskeletal Exertion Profiles (MEPs) that highlight both beneficial and problematic design features, helping to guide iterative improvements. ",

                        videoLinks1: [
                            "https://youtu.be/c7k6VQga_oA"
                        ],
                        companyLink1: "http://www.nexgenergo.com/ergonomics/emg.html",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        description2: "The technology utilizes active, gel-free sensors for capturing high-fidelity signals—covering EMG, EEG, temperature, skin conductance (SCR), respiration, heart rate (HR), blood volume pulse (BVP), and EKG—while pre-amplification ensures minimal signal noise and distortion. These systems allow ergonomic professionals to break down complex tasks into discrete elements and analyze them using EMG for muscular exertion, electrogoniometry for joint motion, thin-film sensors for contact force measurement, and heart rate monitoring for metabolic load, delivering a complete picture of physical demand and risk across job roles.",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/bodyandmindrealaxsys fet.jpg"),
                                linkname: "Thought tec",
                                link: "https://thoughttechnology.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Ergonomics/Products/er h1 (1).jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Ergonomics/Products/er h1 (2).jpg"),
                            },

                        ],
                    },

                ]
            },
            {
                id: 7,
                subcategory: "NexGen Ergonomics",
                title: "",
                subtitle: "",

                description: "NexGen Ergonomics provides an extensive range of tools and technologies for ergonomic and biomechanical measurement, analysis, research, and product design. Whether you're looking for basic equipment like force gauges and dynamometers or advanced solutions such as physiological measurement systems, pressure mapping devices, or sophisticated motion analysis platforms, we have tailored options to meet your needs.",

                subdesc: "Our offerings also include specialized tools for sound level monitoring, temperature measurement, and vibration analysis. With a selection of magnetic, optical, and inertial motion-tracking devices paired with optional software, we deliver comprehensive solutions for motion capture and movement analysis.",

                thirdParagraph: "From equipping ergonomics teams to fully outfitting research laboratories, NexGen Ergonomics offers a complete product lineup to support your endeavors in ergonomics and biomechanics.",

                subtitle4: "SOFTWARE:",
                fourthParagraph: "NexGen Ergonomics offers an extensive line of software solutions for ergonomic and biomechanical job-analysis, design and research. Whether your requirement is for simple ergonomic job analysis software, solutions to synchronize various sensors, human vibration analysis, or for sophisticated digital human modelling, we have the solutions for you.",



                fifthParagraph: "Most of our software solutions have been developed by NexGen Ergonomics' engineering group while others are distributed by NexGen Ergonomics. We have also developed customized solutions for various organizations.",

                subtitle56: "Applications of Ergonomics",
                bulletPoints: [
                    "Workstation Design: Tailoring workstations, tools, and job setups to support safer and more comfortable workflows.",
                    "Posture Optimization: Encouraging proper posture to minimize fatigue and discomfort during tasks.",

                ],


                // sixthParagraph: "Through the application of ergonomic principles, workplaces can foster healthier, safer, and more productive environments for employees.",


                cover: require("../../Assets/Products/banner-image-nexgen.jpg"),
                brand: require("../../Assets/Products/Ergonomics/nexgenlogo.png"),
                backcolor: "#00002d",
                Products: [
                    {
                        id: 1,
                        title: "ERGOMASTER ",
                        title2: "VATS™ (Vibration Analysis ToolSet) Software",
                        cover: require("../../Assets/Products/section-image-master.jpg"),
                        description: "ErgoMaster® is an ergonomic analysis software suite designed for easy usability and effective results. It includes specialized modules such as Lift Analyst, Task Analyst, Posture Analyst, and Workstation Analyst to evaluate ergonomic risks, assess postures, and redesign work environments. Features like real-time analysis, image digitization, and customizable reports ensure accurate and impactful evaluations. The software supports a wide range of applications, including ergonomic risk assessments, workstation redesign, and discomfort analysis, making it ideal for improving workplace safety and efficiency.",

                        subtitle21: "",
                        description2: "",

                        title2: "Mastering ergonomic analysis just became easy with ErgoMaster.",
                        description21: "ErgoMaster is a suite of attractively priced ergonomic analysis software modules containing a broad range of features and capabilities. The system is easy to use and produces easy to understand reports incorporating pictures or images of the job task being analyzed or redesigned. ErgoMaster enables users with minimal computer expertise to easily utilize the system. The user can customize various reports and analysis. The system also includes detailed on-line help and instructions.",
                        description22: "",
                        subtitle2: "",




                        title3: "",
                        description31: "",
                        description32: "",
                        subtitle3: "Ergonomic Analysis Modules Overview:",
                        bulletPoints3: [
                            "Lift Analyst",
                            "Task Analyst",
                            "Posture Analyst",
                            "Workstation Analyst",
                            "Ergo Product Database",
                            "Getting Started"

                        ],
                        title4: "Features:",
                        description41: "",
                        description42: "",
                        subtitle4: "",
                        bulletPoints4: [
                            "real-time analysis",
                            "image digitization",
                            "discomfort analysis",
                            "risk assessments"
                        ],


                        companyLink1: "http://www.nexgenergo.com/ergonomics/ergomast.html",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Ergonomics/Products/ergo fet.jpg"),
                                linkname: "Nexgenergo",
                                link: "http://www.nexgenergo.com/index.html",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/banner-345.jpg"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "ERGOINTELLIGENCE ",
                        title2: "MMH Modules include:",
                        cover: require("../../Assets/Products/MMH-section-image.gif"),
                        description: "ErgoIntelligence™ is a series of easy to use software products for a variety of ergonomic analysis and design applications. ",
                        description2: "",

                        title2: "There is two products of ErgoIntelligence™",
                        description21: "1. Manual Materials Handling (MMH)",
                        description22: "2. Upper Extremity Assessment (UEA)",
                        subtitle2: "--ErgoIntelligence™ Manual Materials Handling (MMH)",

                        title3: "MMH Modules include:",
                        description31: "",
                        description32: "",
                        subtitle3: "",
                        bulletPoints3: [
                            "EI-MMH-N: NIOSH Lifting Equation with multi-task analysis",
                            "EI-MMH-NPRO: MMH-N with 2D biomechanics and 2D manikin facility",
                            "EI-MMH-SCM: Snook & Ciriello and Mital Table analysis",
                            "EI-MMH-SCMPRO: MMH-SCM with biomechanics",
                            "EI-MMH-EE: Energy Expenditure"

                        ],


                        title4: "",
                        description41: "After assessing a manual material handling task (i.e. lifting, lowering, pulling, pushing, carrying), the programs also indicate numerous generic recommendations to prevent risk of work-related Low Back Injury.",
                        description42: "",
                        subtitle4: "NIOSH Lifting Equation Module",




                        title5: " ",
                        description51: "",
                        description52: "",
                        subtitle5: "Snook & Ciriello / Mital Tables Module",




                        title6: "",
                        description61: "",
                        description62: "",
                        subtitle6: "Energy Expenditure Module",



                        title7: "--ErgoIntelligence™ Upper Extremity Assessment (UEA)",
                        description71: "The ErgoIntelligence™ Upper Extremity Assessment (UEA) suite of tools incorporates a variety of tools including RULA, REBA, Strain Index, Occupational Repetitive Actions Index (OCRA) and the Cumulative Trauma Disorders Risk Index.",
                        description72: "RULA provides a rapid assessment of the musculoskeletal loads on workers due to posture, repetition and force. It aids in evaluating jobs or tasks that may expose workers to upper limb disorders (neck, shoulder, upper and lower arms, and hand). ",
                        subtitle7: "",


                        companyLink1: "http://www.nexgenergo.com/ergonomics/ergointelmmh.html",
                        buttons1: "VISIT THE COMPANY WEBSITE ",




                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Ergonomics/Products/ergointel fet.jpg"),
                                linkname: "Nexgenergo",
                                link: "http://www.nexgenergo.com/index.html",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Ergonomics/Products/ergoi h1 (1).jpg"),
                            },
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Ergonomics/Products/ergoi h1 (2).jpg"),
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "HM-Analyzer  ",
                        cover: require("../../Assets/Products/section-image-hm.jpg"),
                        description: "NexGen Ergonomics is an official Xsens system integrator, offering a complete motion capture and analysis solution with its advanced HM-Analyzer software. This powerful tool supports up to 15 inertial sensors for mapping body segments and calculating joint angles based on ISB or AAOS standards.",


                        title2: "",
                        description21: "",
                        description22: "",
                        subtitle2: "",
                        bulletPoints2: [
                            "Flexible Sensor Mapping – Use 1 to 15 sensors for customizable body segment tracking.",
                            "Scalable & Anthropometry-Based Skeleton – Visualization adapts to subject size for accurate representation.",
                            "Automated Calibration – Easy T-pose/I-pose setup or auto-calibration for quick use.",
                            "Real-Time & Offline Data Analysis – Analyze live or stored data with built-in processing.",
                            "DATS Module – Perform in-depth signal processing, filtering (Butterworth, Chebyshev, Bessel), and joint analysis via a visual interface.",
                            "Ergo-Analyzer Module – Optional ergonomic assessments using RULA and OWAS methods for workplace posture evaluation."
                        ],
                        title3: "",
                        description31: "",
                        description32: "",
                        subtitle3: "Key Features:",
                        bulletPoints3: [
                            "Scalable sensor mapping (1–15 sensors)",
                            "Adjustable skeleton based on user anthropometry",
                            "Easy T-pose/I-pose or auto-calibration",
                            "Real-time & offline data analysis",
                            "DATS module for filtering & joint analysis",
                            "Ergo-Analyzer module with RULA and OWAS ergonomic assessments",
                            ""
                        ],






                        companyLink1: "http://www.nexgenergo.com/ergonomics/HM-Analyzer-X.html",
                        buttons1: "VISIT THE COMPANY WEBSITE ",




                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Ergonomics/Products/MVTA fet.gif"),
                                linkname: "Nexgenergo",
                                link: "http://www.nexgenergo.com/index.html",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Ergonomics/Products/hm banner (1).jpg"),
                            },
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Ergonomics/Products/hm banner (2).jpg"),
                            },
                        ],
                    },
                    {
                        id: 4,
                        title: "HumanCAD®Human Modeling Solution",
                        cover: require("../../Assets/Products/section-image-cad.jpg"),
                        description: "NexGen Ergonomics’ HumanCAD creates digital human models in 3D for ergonomic and human factors analysis. It helps design products and workspaces by evaluating reach, vision, and lifting abilities of humans of different sizes.",
                        description2: "This fifth-generation platform builds on the original ManneQuin from 1990, with thousands of users worldwide.",
                        description3: "HumanCAD features modular architecture, offering tools for kinematics, custom postures, vision, and reach analysis. It includes ergonomic tools for injury risk, posture analysis, and comfort/fit evaluation.",


                        title2: "",
                        description21: "",
                        description22: "",
                        subtitle2: "Product Features                                     ",
                        bulletPoints2: [
                            "Flexible Anthropometry",
                            "Easy Mannequin Positioning",
                            "Ergonomics and Space Analysis",
                            "Versatile Environment and 3D Navigation",
                            "Extensive Import-Export Files Support",
                            "Ergonomic Design and Testing"

                        ],
                        title3: "",
                        description31: "",
                        description32: "",
                        subtitle3: "HumanCAD® Modules",



                        title4: "",
                        description41: "Advanced Functions Set",
                        description42: "CADExchange",
                        subtitle4: "",


                        title5: " ",
                        description51: "ErgoTools",
                        description52: "Child Module",
                        subtitle5: "",



                        title6: "",
                        description61: "Elderly Module",
                        description62: "",
                        subtitle6: "",



                        companyLink1: "http://www.nexgenergo.com/ergonomics/humancad.html",
                        buttons1: "VISIT THE COMPANY WEBSITE ",





                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Ergonomics/Products/VATS-fet.jpg"),
                                linkname: "Nexgenergo",
                                link: "http://www.nexgenergo.com/index.html",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Ergonomics/Products/humancard (1).jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Ergonomics/Products/humancard (2).jpg"),
                            },
                        ],
                    },
                    {
                        id: 5,
                        title: "ErgoImager Pro",
                        cover: require("../../Assets/Products/section-image-pro.jpg"),
                        description: "ErgoImager Pro is a powerful software solution designed for in-depth **ergonomic assessments and biomechanical analysis. ",
                        description2: "Integrated with 3D mannequin technology from our HumanCAD® platform, ErgoImager Pro enables professionals to simulate, visualize, and evaluate human postures and movements within digital environments. It supports a wide range of ergonomic methods and tools, making it ideal for workplace design, risk assessment, and human performance studies.",
                        companyLink1: "http://www.nexgenergo.com/ergonomics/ergoimager.html",
                        buttons1: "VISIT THE COMPANY WEBSITE ",



                        title2: "Key Features",
                        description21: "3D Mannequin Technology: Modify mannequin anthropometry and visualize Center of Gravity with accurate human modeling.",
                        description22: "",
                        subtitle2: "Posture Analysis Tools:",
                        bulletPoints2: [
                            "RULA (Rapid Upper Limb Assessment)",
                            "REBA (Rapid Entire Body Assessment)",
                            "OWAS (Ovako Working Posture Analysis System)",
                            "NIOSH Lifting Equation (Revised)",
                            "Liberty Mutual MMH Tables (2021 Update)"
                        ],
                        title3: "",
                        description31: "",
                        description32: "",
                        subtitle3: "Biomechanical Modeling:",
                        bulletPoints3: [
                            "MQ 3D model and 2D biomechanical model",
                            "Interface with 3DSSPP biomechanical model",
                            "Forward and Inverse Kinematics"
                        ],


                        title4: "",
                        description41: "",
                        description42: "",
                        subtitle4: "Manual Handling & Strength Prediction:",
                        bulletPoints4: [
                            "Snook & Ciriello Tables",
                            "Mital, Nicholson & Ayoub Tables",
                            "Hand Strength MAE (Maximum Acceptable Efforts)",
                            "AFF (Arm Force Field) Method using Neural Networks"
                        ],



                        title5: " ",
                        description51: "",
                        description52: "",
                        subtitle5: "Energy & Strain Index Tools:",
                        bulletPoints5: [
                            "Energy Expenditure Estimation",
                            "RSI, COSI & CUSI (Revised/Composite/Cumulative Strain Index)",
                            "Posture Library: Includes both predefined and customizable postures",
                            "Visual Reporting: Generate detailed reports with imported background images and results overlay"
                        ],



                        companyLink1: "http://www.nexgenergo.com/ergonomics/ergoimager.html",
                        buttons1: "VISIT THE COMPANY WEBSITE ",



                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Ergonomics/Products/VATS-fet.jpg"),
                                linkname: "Nexgenergo",
                                link: "http://www.nexgenergo.com/index.html",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Ergonomics/Products/ergo probanner.jpg"),
                            },
                        ],
                    },
                    {
                        id: 6,
                        title: "VATS™ (Vibration Analysis Toolset) ",
                        cover: require("../../Assets/Products/section-image-vat.jpg"),
                        description: "Exposure to vibrations from power tools, vehicles, and machinery poses significant health risks and increases compensation costs. VATS simplifies vibration analysis, enabling organizations to evaluate data against global standards like ISO 5349, ISO 2631, ACGIH, and BS 6841.",



                        title2: "Key Features:",
                        description21: "",
                        description22: "",
                        subtitle2: "",
                        bulletPoints2: [
                            "Supports hand-arm and whole-body vibration analysis.",
                            "Compatible with accelerometer data in text format (up to two accelerometers).",
                            "Trusted by leading manufacturers, government bodies, universities, and consultants worldwide."

                        ],
                        title3: "",
                        description31: "VATS ensures accurate, efficient vibration hazard assessment, reducing risks and aiding compliance.",
                        description32: "",
                        subtitle3: "Software Features",


                        title4: "",
                        description41: "",
                        description42: "",
                        subtitle4: "Data Analysis Capabilities:",
                        bulletPoints4: [
                            "Fast Fourier Transform (FFT)",
                            "1/3 Octave Band Analysis",
                            "Weighted and Unweighted RMS",
                            "Band-Pass Butterworth Filter",
                            "Filtering Window",
                            "Spectrum Plot",
                            "1/3 Octave Band Plot",
                            "Crest Factor",
                            "Vibration Dose Value (VDV)",
                            "TLV/Caution Zone Values (ISO & ACGIH Standards)",
                            "RMS History and Summaries"

                        ],



                        title5: " ",
                        description51: "",
                        description52: "",
                        subtitle5: "Interactive Data Selection:",
                        bulletPoints5: [
                            "Use the mouse to select data ranges by left-clicking and dragging.",
                            "Combine multiple data selections for comprehensive analysis.",
                            "Selected points are displayed on the RMS graph for clarity and precision."
                        ],



                        companyLink1: "http://www.nexgenergo.com/ergonomics/vats-soft.html",
                        buttons1: "VISIT THE COMPANY WEBSITE ",


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Ergonomics/Products/VATS-fet.jpg"),
                                linkname: "Nexgenergo",
                                link: "http://www.nexgenergo.com/index.html",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Ergonomics/Products/vti banner.jpg"),
                            },
                        ],
                    },


                ]
            },
            {
                id: 8,
                subcategory: "Qualisys",
                title: "The Motion capture system",
                subtitle: "",
                subdesc: "The Arqus camera family includes models with protected housing that’s specifically built to withstand any type of weather it may encounter. Designed to be natively waterproof and dustproof, and with an extended temperature range, the camera will operate where you need it to.",
                description: "",
                sixthParagraph: "Synchronized videos make it possible to do:",
                bulletPoints6: [
                    "Data quality check",
                    "Multi-day evaluations",
                    "Multi-vet evaluations",
                    "Communication/documentation of cases – in addition to 3D data"
                ],
                brand: require("../../Assets/Brands/Qualisys-Logo.jpg"),

                seventhParagraph: "Motion Capture advantages compared with IMU systems:",

                bulletPoints7: [
                    " Highest precision/accuracy",
                    "Unlimited number of markers can be added",
                    "No charging of the system needed",
                    "Synchronized videos"
                ],


                subject01: "Clinical - QHorse, lameness analysis",
                subjectdescriptions: "The system provides the best accuracy and precision on the market. It enables you to capture movement that might be close to impossible to detect with the naked eye.",
                subjectdescriptions01: "The interface is designed to show asymmetries in various ways, ranging from an accessible overview to in-depth stride-by-stride information. It is a complete state-of-the-art tool for objective lameness assessment with quick and easy comparisons of measurements, video recordings, and a report function."
                ,
                subject02: "Gait Analysis for Research and Clinical Applications",
                subjectdescriptions02: "Qualisys provides motion capture solutions designed for both research and clinical gait analysis. Selecting the right system depends on the specific needs of your application, whether it’s clinical diagnostics or advanced research studies.",


                subject03: "Qualisys Clinical System (QCS): ",
                subjectdescriptions03: "Ideal for clinical tasks such as diagnosis, treatment evaluation, and patient monitoring.",


                subject04: "Gait Analysis Module:",


                subjectdescriptions04: "Best suited for researchers conducting in-depth gait studies.Each Gait Analysis module is equipped with everything needed for a seamless gait analysis experience, including customizable marker sets, event modes, hardware integrations, and capture options. Our software is adaptable to your unique protocols and comes with detailed documentation and guides to help you get started quickly.",


                cover: require("../../Assets/Products/Biomechanics/q banner.jpg"),

                backcolor: "#a73b2c",
                Products: [
                    {
                        id: 1,
                        title: "Miqus Mocap Camera—Capture More with Less",
                        title2: "",
                        cover: require("../../Assets/Products/Ergonomics/Products/meques 1.jpg"),
                        description: "Motion capture cameras for small and large projects",
                        subtitle21: "",
                        subtitle021: "Compact and Budget-Friendly Motion Capture Cameras ",
                        description2: "The Miqus motion capture camera is our most compact and polished design to date. Its lightweight and streamlined body packs all the essential features needed to power your next motion capture project efficiently and affordably.",

                        description3: "Just like all Qualisys mocap cameras, the Miqus cameras are designed to capture accurate mocap data with very low latency. This makes the Miqus suitable for a wide range of applications. From small 3-camera educational systems up to large projects with +100 cameras.",

                        title2: "",
                        description21: "The Miqus is available in three models: Miqus M1 (1 MP), Miqus M3 (2 MP) and Miqus M5 (4 MP).",
                        description22: "",
                        subtitle2: "Key features",
                        bulletPoints2: [
                            " High-speed motion capture",
                            "Resolution: 1, 2 & 4 megapixels",
                            "Wide field of view",
                            "Low latency for real-time applications",
                            "Fast setup with combined Power & Ethernet",
                            "Daisy-chaining (no switches required)",
                            "Silent operation",
                            "In-camera marker masking",

                        ],
                        title3: "",
                        description31: "",
                        description32: "",
                        subtitle3: "Applications",
                        bulletPoints3: [
                            "Human Biomechanics",
                            "Sports Research",
                            "Equine Lameness",
                            "Sound & Motion",
                            "Animal Biomechanics",
                            "MRI",
                            "Swimming",
                            "Automotive",
                            "OEM",
                            "Robotics & UAV",
                            "Marine Vessels & Structures",
                            "Wind Power",
                            "Virtual Reality (VR)",
                            "Animation & VFX",

                        ],

                        companyLink1: "https://www.qualisys.com/cameras/miqus/",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=vJpjEqXyec0&list=PLayfN54QgJo0nJxVEtkrEItdRvcRou61I&index=5"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        title4: "",
                        description41: "",
                        description42: "",





                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/miqusfet.jpg"),
                                linkname: "Qualisys",
                                link: "https://www.qualisys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/m-head banners.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/my clips.jpg"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "Arqus",
                        title2A: "The industry’s highest Extreme performance.",
                        cover: require("../../Assets/Products/Biomechanics/Products/arque section.jpg"),
                        description: "",

                        bulletPointsA: ["Arqus motion capture camera is driven by 24 high power LEDs and is 50% more powerful than previous models.", "With it, the Arqus can detect passive markers as far as 50 m (165 ft)2.", "With great power comes great distances.", "Our most powerful strobe yet."],
                        description: "The World's Motion Capture Technology Partner",

                        companyLink1: "https://www.qualisys.com/cameras/arqus/",
                        videoLinks1: [
                            "https://youtu.be/FA3WWZV8h4U", "https://youtu.be/sw_EQ8l6vME?list=PLayfN54QgJo0nJxVEtkrEItdRvcRou61I", "https://youtu.be/lE1auuqQpZA?list=PLayfN54QgJo0nJxVEtkrEItdRvcRou61I"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        description3: "",


                        description4: "",

                        subtitle51: "--Our most powerful strobe yet.",
                        description5: "",


                        subtitle61: "",
                        description6: "",


                        title2: "",
                        description21: "The platform provides superior resolution, maxed out frame rates and anything in-between. More importantly, Arqus advanced marker detection algorithms provide exceptional accuracy.",
                        description22: "",
                        subtitle2: "Motion Capture advantages compared with IMU systems:",
                        bulletPoints2: [
                            "Highest precision/accuracy",
                            "Unlimited number of markers can be added",
                            "No charging of the system needed",
                            "Synchronized videos"
                        ],
                        title3: "",
                        description31: "",
                        description32: "",
                        subtitle3: "Applications",
                        bulletPoints3: [
                            "Online Reporting",
                            "Baseball Analysis",
                            "Cycling Analysis",
                            "Functional Assessment",
                            "Gait Analysis",
                            "Golf Analysis",
                            "Running Analysis"
                        ],


                        title4: "",
                        description41: "",
                        description42: "",











                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/Arqus fet.jpg"),
                                linkname: "Qualisys",
                                link: "https://www.qualisys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/Arque  (1).jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/Arque  (2).jpg"),
                            },

                        ],
                    },
                    {
                        id: 3,
                        title: "Miqus Hybrid",

                        cover: require("../../Assets/Products/Ergonomics/Products/mq hibride.jpg"),
                        description: "This dual-mode camera streams full HD color video at 85 frames per second or marker data at 340 frames per second. Transitioning between marker-based capture and markerlesscolor video capture is effortless—just a single click in Qualisys Track Manager (QTM).",
                        description2: "",

                        title2: "The Miqus Hybrid offers seamless switching between marker-based and markerless motioncapture.",
                        description21: "The Miqus Hybrid system is ideal for researchers exploring markerless motion capture algorithms. It serves as both a ground truth system and a research accelerator with synchronized and calibrated cameras ready for immediate use.",
                        description22: "Capture marker-based motion data in one session, then seamlessly switch to markerless motion capture using the same software, cameras, and coordinate system for effortless comparisons. For added flexibility, you can opt for dedicated marker-based cameras alongside Miqus Video cameras. These integrate seamlessly within the same system, enabling simultaneous capture of both marker-based and markerless data.",
                        subtitle2: "Key Features of Miqus Hybrid System",
                        title2m: "A Versatile Solution for Markerless Research.",
                        bulletPoints2: [
                            "Dual Mode Operation: Supports both marker-based and markerless motion capture using the same camera system",
                            "High-Speed Performance: Streams full HD color video at 85 fps or marker data at 340 fps.",
                            "Future-Proof Investment: Combines proven marker-based technology with the flexibility of markerless motion capture.",
                            "Seamless Integration: Easily switch between tracking modes with Qualisys Track Manager (QTM).",



                            "Markerless tracking",

                        ],
                        companyLink1: "https://www.qualisys.com/features/markerless-motion-capture/",
                        videoLinks1: [
                            "https://youtu.be/3i9Ju2gjavE",
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        subtitle2m: "Advanced Video Capabilities",
                        bulletPointsm: ["Miqus Video offers HD color video streaming up to 480 fps and a resolution of 2.8MP, ideal for markerless capture.", "Development and testing of markerless motion capture algorithms for natural interface design."],
                        subtitle3m: "Animation and Game Development",
                        bulletPoints1m: ["Dual-purpose motion capture for creating realistic character movements and visual effects."],

                        title3: "",
                        description31: "",
                        description32: "",





                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/Miqus_hybrid fet.png"),
                                linkname: "Qualisys",
                                link: "https://www.qualisys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/marq hybride.jpg"),
                            },

                        ],
                    },
                    {
                        id: 4,
                        title: "Miqus Video ",
                        title2C: "Designed for professionals.",
                        cover: require("../../Assets/Products/Ergonomics/Products/m videos.jpg"),
                        description: "The Miqus Video Plus is equipped with an advanced image sensor that delivers exceptional color video quality and high-resolution captures. With built-in strobe lighting featuring white high-power LEDs, automatic synchronization with other Miqus and Arqus cameras, and onboard compression using MJPEG, the Miqus Video Plus simplifies the capture process while maximizing performance.",
                        subtitle21: "",
                        description2: "",

                        title2: "",
                        description21: "",
                        description22: "",
                        subtitle2: "Speed and performance redefined, Unmatched quality and resolution.",

                        title3: "",
                        description31: "Equipped with the latest image sensor technology, the Miqus Video Plus delivers exceptional image quality even under low-light conditions. It boasts a 30% higher resolution than standard Full HD cameras, providing full resolution at 2.8 megapixels (MP), for crystal-clear clarity with every captured motion.",
                        description32: "",
                        subtitle3: "Key Features",
                        bulletPoints3: [
                            "High-quality color video",
                            "Full resolution at 2.8 MP, 1920 x 1440",
                            "Streams full HD at 120 fps",
                            "Streams 720p at 480 fps",
                            "Synchronized 3D data overlay",
                            "Daisy chained connection",
                            "Standalone operation or seamlessly integrate with any Qualisys mocap system"

                        ],

                        companyLink1: "https://www.qualisys.com/cameras/miqus-video/",
                        videoLinks1: [
                            "https://youtu.be/vJpjEqXyec0?list=PLayfN54QgJo0nJxVEtkrEItdRvcRou61I", "https://www.qualisys.com/my/qacademy/#!/tutorials/how-to-use-qualisys-video-cameras-with-qtm"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        title4: "",
                        description41: "",
                        description42: "",




                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/miqus-video fet.jpg"),
                                linkname: "Qualisys",
                                link: "https://www.qualisys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/m video (1).jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/m video (2).jpg"),
                            },

                        ],
                    },
                ]
            },

            {
                id: 9,
                subcategory: "Delsys",
                title: "We help people measure and analyze motion",
                subtitle: "Applications for motion capture technology",
                subdesc: "Our technology is used by researchers, biomechanists, physicians and engineers from all over the world. However, anyone that is interested in getting objective information about how things move can benefit from our technology. For example, our motion capture systems can be used to find and prevent injuries, improve performance in biomechanics and help engineers build better products and increase production efficiency.",
                description: "World leader in human measurement in complex and real environments for over 30 years, TEA innovates for the well-being of humans with agile solutions and services.",
                cover: require("../../Assets/Products/Biomechanics/Delsys-banner.png"),
                brand: require("../../Assets/Products/Biomechanics/Delsyslogo.png"),
                backcolor: "#0a0a0a",
                Products: [
                    {
                        id: 1,
                        title: "Trigno Mobile System",

                        title2: "KIT FOR RESEACH TRAINING AND CLINICAL SYSTEM",
                        title04: "On-the-go tools for clinical and teaching applications.",
                        cover: require("../../Assets/Products/Biomechanics/Products/Section Image.jpg"),
                        description: "Unlock comprehensive insights into muscle activity and movement with Delsys Mobile EMG Systems. Designed for research, clinical, and educational use, these kits provide synchronized EMG and motion capture data for rehabilitation, performance analysis, and teaching",
                        description2: "",


                        subtitle182: "Each kit features advanced Delsys sensors, including:",
                        bulletPoints182: [
                            "Trigno Avanti Sensors :– wireless EMG sensors with integrated inertial measurement (IMU) for motion tracking.",
                            "Trigno Galileo Sensors :– high-fidelity EMG sensors for deep muscle analysis.",
                            "Trigno Quattro Sensors :– multi-channel EMG sensors for detailed muscle mapping.",
                            "Trigno Mini Sensors :– compact EMG units ideal for small muscle groups or pediatric applications.",
                        ],
                        subtitle1802: "Trigno Mobile System Features:",
                        bulletPoints1802: [
                            "Compatible with various Trigno sensors",
                            "Bluetooth Connectivity",
                            "Data collection with Mobile EMG Suite",
                            ,
                        ],
                        subtitle1803: "Application areas: ",
                        bulletPoints1803: [
                            "Trigno Mobile for Grip Strength",
                            "For education",
                            "For balance training",
                            "For muscular Imbalance",
                            "For physical therepy",
                            "For sports"
                            ,
                        ],

                        companyLink1: "https://delsys.com/products/#system",
                        videoLinks1: ["https://www.youtube.com/watch?v=ojLik28e_kE", "https://www.youtube.com/watch?v=m63UtuoZwYQ", "https://www.youtube.com/watch?v=JA5sjNgcumU", "https://www.youtube.com/watch?v=F7PM5C-M6OA"],
                        buttons1: "VISIT THE COMPANY WEBSITE",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel EMG fet.png"),
                                linkname: "Delsys",
                                link: "https://delsys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 1,
                        title: "Trigno Centro EMG System:",
                        title2: "Complete Solutions for Human Movement",
                        title05: "Built on the past, informed by the present, designed for the future.",
                        cover: require("../../Assets/Products/Biomechanics/Products/Trigno-Centro.jpg"),
                        description: "Human movement is complex. Trigno Centro dynamically unravels this complexity.Discover the intricacies and co-ordination of motor control.Designed for unrivaled research quality in human movement, engineering, and neurophysiology applications.Crafted to deliver unmatched precision for research in human movement, engineering, and neurophysiology, the only boundary for your discoveries is your imagination.",
                        description2: "",
                        companyLink1: "https://delsys.com/product/trigno-centro/",
                        videoLinks1: ["https://www.youtube.com/watch?v=coe-QmJ4dqk", "https://www.youtube.com/watch?v=VpyQrVVdIÈ"],
                        buttons1: "VISIT THE COMPANY WEBSITE",

                        subtitle182t: "Trigno System Features:",
                        bulletPoints182t: [
                            "Compatible with all Trigno sensors and PC software",
                            "Support 2- 32 sensors",
                            "Communicate via RF protocol",
                            "Integrate with Trigger Module, analog outputs, API,  SDK, and third-party software plugins",
                        ],
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel EMG fet.png"),
                                linkname: "Delsys",
                                link: "https://delsys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/trigo centero h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/trigo centero h2.jpg"),
                            },
                        ],

                    },
                    {
                        id: 1,
                        title: "Trigno Lite System",
                        title2: "EMG + Movement Made Simple",
                        cover: require("../../Assets/Products/Biomechanics/Products/4-channel-emg-system.jpg"),
                        description: "TheTrigno Lite System combines research-grade EMG and movement sensors with the simplicity of a laptop or tablet, offering point-of-care results with minimal setup. Ideal for clinical, educational, and field-based research, it delivers high-quality physiological and biomechanical data in real time.",

                        description2: "",



                        subtitle172: "Key Applications:",
                        bulletPoints172: [
                            "Human Movement Analysis",
                            "Physical Rehabilitation & Therapy",
                            "Sports Performance & Ergonomics",
                            "Classroom Demonstrations & Student Projects",

                        ],

                        subtitle193: "Featured Products:",
                        bulletPoints193: [

                            "Wireless Trigno Sensors for EMG + IMU data",
                            "Easy data acquisition via USB receiver",
                            "Real-time visualization and storage with Trigno Discover software",
                            "Proprietary RF protocol ensures precise synchronization",
                            "Plug-and-play usability—no complex setup needed",
                        ],
                        subtitle194: "TrignoLite System Includes:",
                        bulletPoints194: [

                            "Trigno Avanti –: Compact EMG + motion sensor",
                            "Trigno Mini –: Ideal for small or pediatric muscle groups",
                            "Trigno Quattro –: Multi-channel EMG for detailed studies",

                        ],

                        companyLink1: "https://delsys.com/product/trigno-lite/",
                        videoLinks1: ["https://youtu.be/evNtRJKOXQ0"],
                        buttons1: "VISIT THE COMPANY WEBSITE",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel EMG fet.png"),
                                linkname: "Delsys",
                                link: "https://delsys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/trigro system.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel h2.jpg"),
                            },
                        ],
                    },

                ]
            },

        ],
    },
    {
        id: 6,
        Category: "Sports Science",
        cover: require("../../Assets/CategoryPage/Exercise & Sports Physiology.jpg"),
        link: "pukhya/sports-science",
        subcategories: [
            {
                id: 10,
                subcategory: "Bertec",
                title: "",
                subtitle: "Engineered for the exacting",
                subtitle106: "Solution you can trust",
                subtitle107: "Better Maesures, Better Outcomes",
                subdesc: "Turned to by industry leaders worldwide for three decades and counting, Bertec provides precisely engineered solutions for those seeking accurate measurement. From design to engineering to production, we pay attention to every detail, so the biomechanical engineering industry can advance its understanding of the human body.",
                subdesc106: "Bertec’s technology is world-renowned for accuracy and dependability, and now your solution can leverage our reputation to deliver comprehensive products ahead of and beyond that of your competitors.",
                subdesc107: "Bertec elevates the clinical standard with superior design concepts and innovative technologies built on over thirty years of excellence in biomechanics. Providing reliable tools for the assessment and training of balance and mobility, Bertec’sproduct allow clinicians to customize and target therapy, resulting in greater patient motivation and optimal patient outcome.",
                // companyLink1: "https://www.qualisys.com/cameras/miqus-video/",
                // videoLink: [
                //     "https://youtu.be/4Ntexwf2XQM", "https://youtu.be/_VAOFqVNuRY", "https://youtu.be/2-dmguD-UBQ"
                // ],

                // buttons: "VISIT THE COMPANY WEBSITE",

                description: "",

                cover: require("../../Assets/Products/Biomechanics/bertec.webp"),

                brand: require("../../Assets/Products/Biomechanics/berteclogo.png"),
                backcolor: "grey",

                Products: [
                    {
                        id: 1,
                        title: "Instrumented Treadmill",
                        title2: "Fully Instrumented Treadmill v5 (FIT5)",
                        title201: "The FIT5 Instrumented Treadmill and Software",
                        title203: "Advancing Gait and Biomechanics Research with the FIT5",

                        cover: require("../../Assets/Products/Biomechanics/Products/force-plate.jpg"),
                        description: "The Bertec Fully Instrumented Treadmill v5 (FIT5) allows gait researchers to reduce laboratory space requirements and remove the limitations inherent in a traditional force plate walkway. The unique design features result in superior dynamic characteristics and a high natural frequency making it the preferred research-grade fully instrumented treadmill.The Bertec treadmill enables walking and running research with speeds up to 11.5 m/s and six-component force data output at 1000 Hz.",
                        description2: "",
                        description201s: "The Bertec Fully Instrumented Treadmill v5 (FIT5) combines precision measurement with an intuitive interface, making it an ideal solution for gait researchers and biomechanics labs. Its seamless integration of split-belt treadmill hardware and device-controlling software offers unmatched flexibility for creating custom, repeatable protocols.",
                        description201: "With the FIT5, researchers can precisely control the treadmill, view and capture real-time data on force, moment, and velocity, and design tailored experiments using the Protocol Builder. It’s hardware ensures smooth and consistent acceleration, essential for studies on perturbation and fall prevention.",
                        description202: "The FIT5 also features a Remote control API that integrates effortlessly with Python and motion capture systems, enabling advanced, feedback-based real-time controls. In this blog, we’ll delve into how these features empower researchers to develop customized protocols and achieve breakthrough results in gait and biomechanics studies.",
                        description203: "The FIT5 treadmill and its dedicated software offer researchers a high-quality, low-vibration platform that accurately replicates natural walking and running patterns. Designed with precision, the FIT5 enables live data visualization, customizable treadmill protocols for consistent experiments, and synchronized data capture for highly accurate results.",
                        description204: "The built-in Protocol Builder simplifies perturbation research and training, making it easier to study fall risks and develop effective strategies to reduce them. With its advanced features, the FIT5 supports groundbreaking research in gait analysis and fall prevention.",

                        videoLinks1: [
                            "https://youtu.be/4Ntexwf2XQM",
                            "https://youtu.be/_VAOFqVNuRY",
                            "https://youtu.be/2-dmguD-UBQ"
                        ],
                        companyLink1: "https://www.bertec.com/products/force-plates",
                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        subtitle201: "The Bertec FIT5: A Fully Instrumented Treadmill for Precise Gait Analysis and Biomechanics Research",

                        bulletPoints201: [
                            "Independent motion control of each belt",
                            "Industry-leading accuracy",
                            "Ease of treadmill control",
                            "Variety of applications and ease of integration",
                            "Unique design features",
                            "Fully redesigned software solution",
                            "Create custom experimental protocols",
                            ,],

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/force-platefet.jpg"),
                                linkname: "Bertec",
                                link: "https://www.bertec.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/forceplateh1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/forceplateh2.webp"),
                            },
                        ],
                    },

                    {
                        id: 2,
                        title: "force plates",
                        title2: "",
                        title207: "Bertec® Fixed Walkway",
                        cover: require("../../Assets/Products/Biomechanics/Products/trademill.jpg"),
                        description: "Bertec force plates are designed for gait, balance, and performance analyses. Our patented strain gauge technology, innovative transducer designs, and quality manufacturing help you capture the highly accurate data needed for your research.",
                        description2: "The Bertec Fixed Walkway allows researchers to mount Bertec’s fixed force plates in a customizable in-series configuration for various biomechanics applications. The Walkway gives users the ability to independently reconfigure their force plates depending on their experimental needs while maintaining the accuracy and quality of their data. Researchers also gain the option to add more force plates to their walkway over time to easily increase their data collection capacity.",
                        videoLinks1: [
                            "https://youtu.be/4Ntexwf2XQM",
                            "https://youtu.be/_VAOFqVNuRY",
                            "https://youtu.be/2-dmguD-UBQ"
                        ],
                        companyLink1: "https://www.bertec.com/products/force-plates",
                        buttons1: "VISIT THE COMPANY WEBSITE ",


                        bulletPoints208: [
                            "Wide range of applications.",
                            "Variety of sizes and load ranges",
                            "Superior electronics",
                            "Negligible cross talk, drift and signal interference",
                            "Ease of data collection ",
                            "Strongest industry warranty ",

                            ,],
                        subtitle210: "Configurable Walkway Design",
                        bulletPoints210: [
                            "Choose the number of force plates for your walkway ",
                            "Application-specific configurations ",
                            "Independent reconfiguration eliminates future installation cost ",
                            "Available for 2 Bertec Fixed Force Plate sizes (40x60 cm and 60x90 cm) ",
                            "Capable of up to 4000 lb load capacity ",
                            "High natural frequency ",
                            "1000 Hz sampling rate",

                            ,],
                        subtitle209: "Package Includes:",

                        bulletPoints209: [
                            "Chosen amount of force plates",
                            "Appropriate number of half-sized filler plates (see table) ",
                            "2x 180 cm-long mounting plates  ",
                            "Guide for repositioning force plates",

                            ,],


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/trademill fet.jpg"),
                                linkname: "Bertec",
                                link: "https://www.bertec.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/trademill h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/trademill h2.webp"),
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "Computerized Dynamic Posturography",
                        title2: "(CDP/IVR)",
                        cover: require("../../Assets/Products/Biomechanics/Products/Posturography.jpg"),
                        description: "Bertec’s Computerized Dynamic Posturography (CDP/IVR) combines immersive virtual environments with dual-balance force plate technology. The advancements in Bertec’s technology increase the clinical value of CDP in both assessment and targeted therapy interventions, especially for patients suffering from dizziness, balance problems and/or motion sensitivity. Training with immersive, virtual stimuli can increase patient motivation, adaptability and variability—all factors that positively affect patient outcomes.",
                        description2: "",
                        videoLinks1: [
                            "https://youtu.be/c5fSXtVrMdw"
                        ],
                        companyLink1: "https://www.bertec.com/products/cdp-ivr",
                        buttons1: "VISIT THE COMPANY WEBSITE",

                        bulletPoints208: [
                            "Wide range of applications.",
                            "Variety of sizes and load ranges",
                            "Superior electronics",
                            "Negligible cross talk, drift and signal interference",
                            "Ease of data collection ",
                            "Strongest industry warranty ",

                            ,],
                        subtitle210: "Featured Training",
                        bulletPoints210: [
                            "Quick Training",
                            "Mobility",
                            "Closed Chain",
                            "Weight Shifting",
                            "Vision ",


                            ,],

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/Posturography fet.jpg"),
                                linkname: "Bertec",
                                link: "https://www.bertec.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/Posturography h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/Posturography h2.jpg"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 16,
                subcategory: "CATAPULT",
                title: "",
                subtitle: "",
                subdesc1: "Catapult began by developing wearable technologies to tackle core challenges in sportsperformance, a mission that continues to drive its innovation. Evolving from an Australian startup to a global leader in sports technology, Catapult now offers comprehensive solutions across the performance ecosystem, including wearable tracking, athlete management, and video analysis.",
                description12: "Dedicated to making performance technology accessible to all athletes, Catapult collaborates with top teams and organizations worldwide. Additionally, it has introduced Catapult One, a consumer-level athlete tracking device that empowers amateur football and soccer players to track their performance just like professionals.",
                cover: require("../../Assets/Products/SportsScience/catapult1.jpg"),
                brand: require("../../Assets/Products/SportsScience/catapult-logo.jpeg"),
                backcolor: "#00002d",

                subtitle17c: "CATAPAULT SOLUTION",
                bulletPoints17c: [
                    "ATHLETE MONITORING",
                    "VIDEO ANALYSIS",
                    "SCOUTING & RECRUITMENT",
                    "MOTORSPORT",
                ],


                Products: [
                    {
                        id: 1,
                        title: "CATAPULT VECTOR S7",
                        cover: require("../../Assets/Products/SportsScience/Products/catapult-S7-w-Vest.webp"),
                        description: "The Catapult Vector S7device is a professional-grade GNSS system designed to measure the performance of elite athletes within individual and team sports. This document introduces the Vector S7 hardware components and provides an explanation of functionality and general operation. The OpenField software system Data is collected live and downloaded to the OpenField console and can then be uploaded to the OpenField cloud post session. To store the collected data on the OpenField cloud, data must be synced from the console to the cloud over a solid internet connection. Users have the option to use the OpenField+ mobile/iPad app to view live data through a mobile or an iPad over a local Catapult Wi-Fi. This improves accessibility as it enables users to be more mobile around the pitch and to share live data more easily with coaches and players. The hardware components of the Vector system include the Vector devices, a wireless UWB receiver(s) for GPS/GNSS and RTLS tracking.",
                        description2: "",
                        heading1: "Vector Pro",
                        pragraph1: "Catapult Vector sets the standard for accuracy, usability, and efficiency in the industry. It empowers informed decisions on performance, risk management, and return-to-play strategies.",
                        heading2: "Live Insights",
                        pragraph2: "Vector's live snapshots feature allows you to view group session data live on your smartphone or smartwatch, eliminating the need for a receiver or laptop.",
                        heading3: "Vector Clearsky Lps",
                        pragraph3: "Indoors or outdoors, Vector combines advanced GNSS capability with Catapult's ClearSky LPS to set new standards for accuracy and reliability in even the most challenging environments.",
                        companyLink1: "https://www.catapult.com/solutions/vector-pro",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=cUQ6rOIJzeA"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/catapult fet.webp"),
                                linkname: "Catapult",
                                link: "https://www.catapult.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/catapult h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/catapult h2.jpeg"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 17,
                subcategory: "Hawkins Dynmics",
                title: "",
                subtitle: "",
                subdesc: "",
                description: "The Swedish motion capture company.",
                cover: require("../../Assets/Products/SportsScience/Hawkins Dynmics.webp"),
                brand: require("../../Assets/Products/SportsScience/Hawkinslogo.png"),
                backcolor: "#b66c6c",
                subdesch1: "From idea to implementation, Hawkin Dynamics stands as your reliable partner in sports science and rehabilitation. Backed by a team of seasoned industry professionals, we are dedicated to helping you unlock the full potential of our technology for optimal results.",
                heading1: "Precision and Accuracy",
                pragraph1: "Measurement precision and accuracy are often overlooked in the human-performance industry. It is assumed that the product is accurate and objectively validated against an industry gold-standard. At HD, we are dedicated to ensuring lab-grade measurements at a fraction of the price. And we have the data to back it up.",
                heading2: "Personalized Pre-Purchase Guidance",
                pragraph2: "We begin by understanding your unique requirements, ensuring our solutions align perfectly with your needs. Simple, straightforward, and tailored for you.",
                heading3: "Essential Equipment Only",
                pragraph3: "Our commitment is to provide exactly what you need—no unnecessary add-ons or upselling, just the tools required to achieve your goals.",
                heading4: "Comprehensive Warranty",
                pragraph4: "Enjoy peace of mind with our 5-year, no-questions-asked warranty. If your product doesn’t perform as expected, we’ll take care of it—guaranteed.",
                heading5: "Unmatched Customer Support",
                pragraph5: "Our team is dedicated to delivering industry-leading response times and solutions to ensure your success every step of the way.",
                heading6: "Continuous Product Improvements",
                pragraph6: "Partnering with Hawkin Dynamics means you’ll always stay ahead. Expect ongoing updates and enhancements to meet evolving needs—we’re never done innovating.",
                heading7: "Event Expertise",
                pragraph7: "From combines to camps and everything in between, we’re here to support your events with our experience and expertise.",


                Products: [
                    {
                        id: 1,
                        title: "Portable Force Plates",
                        cover: require("../../Assets/Products/SportsScience/Products/plates.webp"),
                        description: "An HD Force Plate System consisting of two portable adjacent force plates was placed directly on top of and within the dimensions of two adjacent Advanced Mechanical Technology, Inc. (AMTI; Model Biomechanics Measurement Series 400600; Watertown, MA, USA) in-ground force plates to collect the ground reaction force (GRF) produced through each leg independently and simultaneously at 1000 Hz (Figures 1 and 2). The GRF data were sampled for five (CMand six (DJ) seconds using HD proprietary software and Qualisys Track Manager software (Qualisys Ltd., Gothenburg, Sweden) for the HD and AMTI systems, respectively. Both systems were zeroed before each trial so that the weight of the HD system was remove from the AMTI system before data acquisition. The raw (i.e., unfiltered) vertical component of the GRF (vGRF) data series was exported from each force plate system’s software to Microsoft Excel, which was used to analyse the bilateral forces (summed left and right leg forces) using a custom spreadsheet. The vGRF data exported from both force plate systems were analysed identically using the custom spreadsheet.",
                        description2: "",
                        Headingp: "MEASURE PHYSICAL PERFORMANCE AND FATIGUE OBJECTIVELY",
                        pragraphp: "Empowering operators and first responders with objective data to measure fatigue, optimal performance capabilities, and return to work standard operating procedures. ",


                        subtitle17p1: "SCALABLE",
                        bulletPoints17p1: [
                            "Whether you are testing one or one thousand, Hawkin Tactical delivers an accurate and reliable system proven by the world's best.",
                        ],
                        subtitle17p2: "ADAPTABLE",
                        bulletPoints17p2: [
                            "Portable and wireless our solution is built specifically for users of any knowledge base. No gimmicks just tried and tested simple processes to get what you need fast. ",
                        ],
                        subtitle17p3: "EFFICIENT",
                        bulletPoints17p3: [
                            "Time is everything. We built a system dedicated to real-time data reporting and custom templates designed to help you make quick informed decisions. ",
                        ],
                        Headingp1: "PORTABLE",
                        pragraphp1: "Whether a coach or a personal trainer, the HD Force Plates enable quick collection of real-time and objective data anywhere in the world",

                        Headingp2: "Continuous Product Improvements",
                        pragraphp2: "Partnering with Hawkin Dynamics means you’ll always stay ahead. Expect ongoing updates and enhancements to meet evolving needs—we’re never done innovating.",
                        Headingp3: "Event Expertise",
                        pragraphp3: "From combines to camps and everything in between, we’re here to support your events with our experience and expertise.",
                        subtitle17p: "Solutions:",
                        bulletPoints17p: [
                            "PERFORMANCE",
                            "CLINICAL",
                            "TECTICAL",
                            "TRUSTRENGTH",
                        ],

                        companyLink1: "https://www.hawkindynamics.com/tactical",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=kWxu2AhYoZo"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/plates fet.jpg"),
                                linkname: "hawkindynamics",
                                link: "https://www.hawkindynamics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/plates h1.webp"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/plates h2.jpg"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 18,
                subcategory: "SVT™ Hardware",
                title: "",
                subtitle: "",
                subdesc: "",
                subdescsvt: "Sports Vision has pioneered the creation and worldwide adoption of the Sports Vision Trainer (SVT™), a cutting-edge scientific tool designed to evaluate and enhance critical athletic abilities. The SVT™ focuses on improving eye-hand coordination and decision-making skills, essential for peak performance in sports. By combining advanced technology with targeted training protocols, it serves as both an assessment and development tool, empowering athletes to react faster, make precise decisions, and optimize their overall visual-motor performance.",
                description: "",
                cover: require("../../Assets/Products/Psychology/svt.gif"),
                brand: require("../../Assets/Products/Psychology/svtlogo.png"),
                backcolor: "#6393be",
                descriptionsvt: "SVT™ Is a truly portable system developed for teams and practitioners who want to use the SVT™ in different field locations without the need for AC mains power.",
                heading01: "Sports Vision - Innovation through R&D",
                pragraphp01: "Sports Vision has seen the development and global commercialization of the Sports Vision Trainer (SVT™).This scientific instrument is used to assess and train eye hand coordination and decision-making skills.",

                subtitle17svt: "SVT™ Professional software features:",
                bulletPoints17st: [
                    "Run two SVT panels simultaneously linked side by side on the same PC.",
                    "Spatial Heat Map of reaction times.",
                    "Reaction Time vs. Time Chart.",
                    "Reaction Time Distribution (consistency) curve.",
                    "Test Result Progression (multiple test results pooled).",
                    "Reaction Time Distribution 3D waterfall plot (multiple test results pooled).", "Progress summary of all selected test results.", "Printing of graphical analysis and reports."
                ],

                Products: [
                    {
                        id: 1,
                        title: "32 light Sports Vision Trainer ",
                        cover: require("../../Assets/Products/Psychology/Products/svt32.jpg"),
                        description: "The 32 sensor pad SVT™ Is a truly portable system developed for teams and practitioners who want to use the SVT™ in different field locations without the need for AC mains power. Depending on the application, It can be used in landscape or portrait orientations. The unit has stabilising feet for easy setup and use, so there is no need for brackets. The dimensions are 135 cm in width by 60 cm in height, thickness with feet attached is 19 cm.",
                        description2: "After several years or research on how to analyse SVT data and get meaningful information at a single glance, we came up with the SVT Professional software. Compatible with existing SVT datasets, the Professional series of software allows you to graphically visualise, track and compare test results with ease. Leveraging the power of DSP (Digital Signal Processing), SVT Professional can visually show trends in data by pooling information from test results in spatial, frequency and time domains. SVT Professional has all of the features of the standard software and can unlock a wealth of information contained in your existing SVT database.",
                        bulletPoints32stv: [
                            "Purpose of Vision Training: Involves targeted exercises designed to improve neural pathways in the brainstem and cortex.",
                            "Neural Restructuring: Repeated practice reshapes neural networks, enhancing the brain's efficiency in processing visual tasks.",
                            "Visual Perceptual Efficiency: Focuses on maximizing the accuracy and speed of visual perception during tasks.",
                            "Improved Visual-Motor Integration: Enhances coordination between visual input and motor output for better performance in sports.",
                            "Progressive Development: Achieved through consistent and structured training over time.",
                        ],
                        subtitle32svts: "Application of 32 Light Sports Vision Training:",
                        bulletPoints32stvs: [
                            "Reaction Time: Improves speed in responding to visual stimuli.",
                            "Hand-Eye Coordination: Enhances precision in movement synchronization.",
                            "Peripheral Awareness: Boosts the ability to detect objects in the surrounding field of vision.",

                            "Focus and Accuracy: Sharpens visual attention and target precision.",

                        ],

                        companyLink1: "https://www.sportsvision.com.au/products.html",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=kWxu2AhYoZo"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/svtfet.png"),
                                linkname: "SVT",
                                link: "https://www.sportsvision.com.au/index.html",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/svt.gif"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/svt.gif"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "SVT™ 64 Lights ",
                        cover: require("../../Assets/Products/Psychology/Products/svt64.png"),
                        description: "Sports Vision has pioneered the creation and worldwide adoption of the Sports Vision Trainer (SVT™), a cutting-edge scientific tool designed to evaluate and enhance critical athletic abilities. The SVT™ focuses on improving eye-hand coordination and decision-making skills, essential for peak performance in sports. By combining advanced technology with targeted training protocols, it serves as both an assessment and development tool, empowering athletes to react faster, make precise decisions, and optimize their overall visual-motor performance.",
                        description2: "",
                        subtitles64s: "64 light Sports Vision Trainer Application",
                        bulletPoints64s: [
                            "Sports Performance Enhancement: Improves reaction time, hand-eye coordination, peripheral vision, and decision-making for athletes across various sports.",
                            "Rehabilitation and Therapy: Aids in recovery from visual or neurological impairments by training visual-motor integration and cognitive response.",

                            "Military and Tactical Training: Enhances situational awareness, reaction speed, and precision under high-pressure scenarios.",
                            "Research and Development: Supports studies in vision science, cognitive performance, and neuromotor functions for innovation in sports and medical fields.",
                        ],
                        subtitle64svts: "SVT™ professional software",
                        bulletPoints64stvs: [
                            "Advanced Analysis: SVT™ Professional software is designed after years of research to provide meaningful insights at a glance.",
                            "Seamless Compatibility: Fully compatible with existing SVT datasets for effortless integration.",
                            "Graphical Visualization: Easily track, compare, and analyze test results with intuitive graphical tools.",
                            "DSP-Powered Insights: Utilizes Digital Signal Processing to reveal trends across spatial, frequency, and time domains.",
                            , "Enhanced Features: Includes all standard software capabilities while unlocking deeper insights from your SVT database."
                        ],

                        companyLink1: "https://www.sportsvision.com.au/products.html",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=kWxu2AhYoZo"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE",


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Psychology/Products/svtfet.png"),
                                linkname: "SVT",
                                link: "https://www.sportsvision.com.au/index.html",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Psychology/svt.gif"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Psychology/svt.gif"),
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "80 light Sports Vision Trainer ",
                        cover: require("../../Assets/Products/Psychology/Products/svt80.jpg"),
                        description: "The 80-sensor pad SVT™ is a wall mounted non-portable system, dimensions are 1.25 metres by 1.25 metres and weight is 15 kg.",
                        subtitle84features: "Key Features of SVT™ System",
                        bulletPoints84features: [
                            "Dual Panel Functionality: Operate two SVT panels side by side on a single PC for enhanced analysis.",
                            "Spatial Heat Mapping: Visualize reaction times with heat maps for detailed spatial performance insights.",
                            "Reaction Time Analytics: Access charts showing reaction time trends over a session.",
                            "Consistency Analysis: Evaluate performance stability using reaction time distribution curves.",
                            "Test Progression Tracking: Pool multiple test results to monitor improvement over time.",
                            "3D Waterfall Visualization: Analyze reaction time distribution across multiple tests with a 3D plot.",
                            "Comprehensive Progress Reports: Summarize and compare results across selected tests for overall performance evaluation.",
                            "Printable Reports: Generate graphical analyses and detailed reports for review and documentation."
                        ],
                        subtitle84applicationAreas: "Application Areas of 64 light Sports Vision Trainer",
                        bulletPoints84applicationAreas: [
                            "Sports Performance Enhancement",
                            "Rehabilitation and Therapy",
                            "Military and Tactical Training",
                            "Research and Development"
                        ],

                        companyLink1: "https://www.sportsvision.com.au/products.html",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=kWxu2AhYoZo"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE",


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/biofeedbackfet.jpg"),
                                linkname: "Thought tec",
                                link: "https://thoughttechnology.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/miqus.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/miqus.jpg"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 19,
                subcategory: "Fast Twitch Isokinetic",
                title: "Designed By Elite Athletes for Elite Athletes",
                subtitle: "Experience the Next Level of High-Speed Training with Fast Twitch!",
                subdesc: "A new era in high-speed training has arrived. Traditional methods to enhance speed, strength, and explosive power—like plyometric and eccentrically loaded programs—are now a thing of the past.",
                description: "",


                cover: require("../../Assets/Products/SportsScience/fft.jpg"),
                brand: require("../../Assets/Products/SportsScience/FTT-Logo.png"),
                backcolor: "#6C584A",

                subtitles1sm: "Achieve Results—Fast!",
                discription1sm: "Users report significant improvements, including a vertical leap increase of 5 to 10 cm and a reduction in 40-yard sprint times by 0.1 to 0.4 seconds—within just six weeks!",
                discription2sm: "Professional athletes and teams like Emmitt Smith, Mike Modano, Darryl Johnston, Larry Allen, Charles Haley, Brett Hull, Desmond Mason, Dat Nguyen, and elite teams like the Chicago Bulls, Sacramento Kings, Dallas Mavericks, and Iowa University have embraced Fast Twitch for its exceptional performance.",
                bulletPoints0smm: [
                    {
                        title: "Introducing Fast Twitch",
                        description: "The revolutionary approach to training for speed, strength, and explosive power. Unlike conventional techniques, Fast Twitch provides high-speed, high-intensity resistance training that:",
                        points: [
                            "Simulates competition speed without injury risks.",
                            "Prevents delayed muscle soreness (DOMS) by eliminating joint loading and muscle tension.",
                            "Enhances neuromuscular activation by increasing fast-twitch fiber recruitment, boosting speed and power.",
                            "Improves cardiovascular endurance while burning fat.",
                            "Elevates lactic acid thresholds through dual concentric loading, essential for dynamic sports.",
                            "Promotes faster rehabilitation due to its low-impact nature and adjustable resistance."
                        ]
                    }
                ],

                discription3sm: "Fast Twitch is equipped with a Computer Managed Training System (CMTS), featuring preloaded templates that monitor and analyze performance in real time. Training data can be instantly shared via the web, keeping you connected and informed.",

                discription4sm: "Fast Twitch’s unique approach prevents muscle soreness and supports aerobic conditioning, making it ideal for general fitness and recovery programs.",
                subtitles2sm: "Proven by the Best:",
                subtitles3sm: "Advanced Technology for Precision Training:",
                subtitles4sm: "Perfect for Fitness and Rehabilitation:",
                subtitles5sm: "Fast Twitch—Achieve Unmatched Speed, Power, and Endurance!",
                Products: [
                    {
                        id: 1,
                        title: "IsoMed ",
                        title2: "One Stop, Multi-Joint, Rehabilitation Machine Hip | Shoulder | Elbow | Back | Ankle | Wrist",
                        cover: require("../../Assets/Products/SportsScience/Products/med.jpg"),
                        description: "This Multi joint machine is for unilateral knee function with Range limiter device.Right Motor Rotates 180degree.",
                        description2: "",

                        bulletPoints0smp: [
                            {
                                "title": "FEATURES",
                                "points": [
                                    "Computer Managed Training System.",
                                    "Touch Screen Control and Smart System PC.",
                                    "Display 80 Individual Field of data.",
                                    "Rotatory and Linear Motion Hydraulic Resistance System.",
                                    "Heavy Duty Frame and Handlebar.",
                                    "Multi-bench Position and Establishing Straps.",
                                    "Adjustable Angle Bench (30-90 degree).",
                                    "Eccentric Options.",
                                    "Variable Speed Control (2deg/sec – 600deg/sec).",
                                    "Counter Thrust Platform.",
                                    "Unilateral and Bilateral Exercise System.",
                                    "Adjustable Height, Position and Support."
                                ]
                            }
                        ]
                        ,

                        companyLink1: "https://www.fasttwitch.com/",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=QU2JO79aY4o"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/med fet.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/med h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/med h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "Isokinetic Knee",
                        title2: "Ultimate Speed Leg Extension Flexion",
                        cover: require("../../Assets/Products/SportsScience/Products/knee.jpg"),
                        description: "This high speed isokinetic knee machine is perfect for rehabilitation, sports performance, and training at speeds that are simply not achievable with other forms of training. Data displays both limbs simultaneously and shows imbalance at high speeds.",
                        description2: "",
                        companyLink1: "https://www.fasttwitch.com/",
                        videoLinks1: [
                            "https://www.youtube.com/embed/uhghy9pFIPY"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        bulletPoints0smm: [
                            {
                                "title": "Features",
                                "points": [
                                    "Rotatory and Liner Motion Hydraulic Resistence System.",
                                    "Touch Screen Display and Smart System PC.",
                                    "Computer Managed Training System.",
                                    "Adjustable Leg Position.",
                                    "Stabilising Straps.",
                                    "Unilateral and Bilateral Exercising system.",
                                    "Variable Speed Control (10 deg per/sec - 8 deg/sec)."
                                ]
                            }
                        ],


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/knee.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/knee h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "Squat ",
                        title2: "FOOTPRINT",
                        companyLink1: "https://www.fasttwitch.com/performance-program",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=b0k4NOlRTY4"
                        ],
                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        cover: require("../../Assets/Products/SportsScience/Products/SQUAt.jpg"),
                        description: "The Squat machine is the flagship Isokinetic machine. The importance of squats in athletic performance is well documented. Now you can achieve more power, more speed and more strength safer and faster than any other form of squatting. Imagine being able to fire the nervous system and achieve triple extension against resistance and use data reporting to show improvements over time.",
                        description2: "Width 1.2m Length 2.2m Height 1.6m Weight 200 kg The Squat machine is the flagship Isokinetic machine. The importance of squats in athletic performance is well documented. Now you can achieve more power, more speed and more strength safer and faster than any other form of squatting. Imagine being able to fire the nervous system and achieve triple extension against resistance and use data reporting to show improvements over time.  Select two-way resistance settings to neurologically activate Flexion and Extension contractions. Perfect for rehabilitation, sports performance and training at speeds that are simply not achievable on other forms of training.",
                        bulletPoints0sms: [
                            {
                                "title": "FEATURES",
                                "points": [
                                    "Linear motion hydraulic resistance system.",
                                    "Computer Managed Training System.",
                                    "Touch Screen Display and Smart PC System.",
                                    "Heavy Duty Frame.",
                                    "Counter Balance Lever Arm."
                                ]
                            }
                        ],


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/squat ft.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/squat h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/squat h2.jpeg"),
                            },
                        ],
                    },
                    {
                        id: 4,
                        title: "Isokinetic HIP",
                        title2: "FOOTPRINT",
                        cover: require("../../Assets/Products/SportsScience/Products/hip.jpg"),
                        description: "The Hip machine is ideal for increasing running speed. It is capable of achieving in excess of 600 – 800 degrees per second in the running flexion/extension position. Replicates high knee lift component of expolsive movements Instantaneously switching resistance between glute and hip flexor, to engage high speed muscle contraction for speed/power development. ",
                        description2: "Length 1.5m Width 1.2m Height 1.4m Weight 150kg The Hip machine is one of the most robust machines on the market. It is capable of achieving in excess of 600 – 800 degrees per second in the running flexion/extension position. Ideal for increasing running speed Glute, hip flexor activation is the ideal way to safely move at these speeds under resistance. Instantaneously switching resistance between glute and hip flexor, to engage high speed muscle contraction for speed/power development. Imagine being able to fire the nervous system against resistance in the running mechanical position at the same speeds you play sports. ",
                        bulletPoints0ship: [
                            {
                                "title": "FEATURES",
                                "points": [
                                    "Rotary Motion Hydraulic Resistance System",
                                    "Computer Managed Training System",
                                    "Touch Screen Display and Smart System PC",
                                    "Heavy Duty Frame and Handlebar",
                                    "Height Adjustable Motor",
                                    "Measures Speed"
                                ]
                            }
                        ],
                        companyLink1: "https://www.fasttwitch.com/performance-program",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=D_G6UnCJ7aM",
                            "https://www.youtube.com/watch?v=uM0Ili9Dl4c",
                            "https://www.youtube.com/watch?v=aCSPaXCaERI"
                        ],


                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/hip fet.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/hip h1.jpg"),
                            },
                        ],
                    },
                    {
                        id: 5,
                        title: "Jump Squat",
                        title2: "With Digital Led Minicomputer - Hip | Knee | Ankle",
                        cover: require("../../Assets/Products/SportsScience/Products/JUMP-Squat.jpg"),
                        description: "This is a simpler form of technology incorporating the same features of the squat machine, still achieving triple extension with 1 to 8 against resistance scale, and performing dual concentric and concentric/eccentric.",
                        description2: "",

                        companyLink1: "https://www.fasttwitch.com/",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=uM0Ili9Dl4c", "https://www.youtube.com/watch?v=uhghy9pFIPY&list=TLPQMDMwNDIwMjXA6u5KQexigQ&index=3"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        bulletPoints0sj: [
                            {
                                "title": "Features",
                                "points": [
                                    "Rotatory Motion Hydraulic Resistance System.",
                                    "Eccentric Load Spigot.",
                                    "Heavy Duty Frame.",
                                    "Variable Speed Control (10deg/sec – 600deg/sec)."
                                ]
                            }
                        ],

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/biofeedbackfet.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/miqus.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/miqus.jpg"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 27,
                subcategory: "Punch Sensor",
                // title: "We help people measure and analyze motion",
                // subtitle: "Applications for motion capture technology",
                // subdesc: "Our technology is used by researchers, biomechanists, physicians and engineers from all over the world. However, anyone that is interested in getting objective information about how things move can benefit from our technology. For example, our motion capture systems can be used to find and prevent injuries, improve performance in biomechanics and help engineers build better products and increase production efficiency.",
                // description: "World leader in human measurement in complex and real environments for over 30 years, TEA innovates for the well-being of humans with agile solutions and services.",
                cover: require("../../Assets/Products/SportsScience/Products/punchsensor-image-banner.png"),
                brand: require("../../Assets/Products/SportsScience/Products/punchsensor brand.png"),

                backcolor: "#010000",
                headingbulets: "Digital Force Sensor",
                bulletPoints0spunch: [
                    `High-Precision Measurement: Measures forces 1000 times per second with a 15" x 20" padded surface.`,
                    "Real-Time Data Tracking: Displays peak force, average force, and number of impacts in real-time.",
                    "Software Integration: Works with Windows PC or Tablet to calculate and display force data during sessions.",
                    "Data Analysis: Saves session data for progress tracking and technique comparison.",
                    "Mounting Options: Includes aluminum plates with through-holes for mounting to walls or exercise frames (mounting kit not included)."

                ],

                Products: [
                    {
                        id: 2,
                        title: "PUNCHSENSOR",
                        title2: "--Digital Force Sensor",
                        cover: require("../../Assets/Products/SportsScience/Products/punchsensor-image2.jpg"),
                        description: `The Digital Force Sensor is a cutting-edge tool for measuring and analyzing impact forces from punches and kicks. It features a built-in force sensor within a 15" x 20" padded surface that measures forces at a rate of 1000 times per second, accurately detecting peak forces and tracking the number of strikes in real-time.`,
                        description2: "The Punch Sensor communicates with our software running on Windows PC or Tablet. The software continuously measures the forces exerted by a kick or a punch, detects and computes the peak force and the number of punches in a given time duration.This data is then displayed in real-time as well as saved to a file for further analysis.",
                        headingbulets1: "Application Areas",
                        bulletPoints0spunch1: [
                            "Martial Arts Training: Monitor and improve punching and kicking techniques for athletes.",
                            "Sports Performance Analysis: Track progress and analyze force metrics for high-performance athletes.",
                            "Rehabilitation Therapy: Measure and adjust rehabilitation exercises based on force exertion.",
                            "Research & Development: Use in biomechanics or sports research to study force dynamics in combat sports.",

                        ],

                        headingbulets2: "Key Features",
                        bulletPoints0spunch2: [
                            "High-Precision Sensor: Measures forces at 1000 Hz, detecting peak forces over a large padded surface.",
                            "Real-Time Tracking: Displays peak force, average force, and impact count per minute in real-time.",
                            "Data Saving & Comparison: Save session data for later analysis to track progress and compare different techniques.",
                            "User-Friendly Software: Runs on Windows PC or Tablet, continuously analyzing and recording force data.",
                            "Versatile Mounting: Includes through-holes for mounting on exercise frames or walls (mounting kit not included).",

                        ],

                        companyLink1: "https://www.punchsensor.com/",
                        videoLinks1: ["https://youtu.be/2owp6-8D9oU", "https://youtu.be/OT1x8qP7dgU", "https://youtu.be/2owp6-8D9oU"]
                        ,
                        buttons1: "VISIT THE COMPANY WEBSITE",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/punchsensor-image1.jpg"),
                                linkname: "punchsensor",
                                link: "https://www.punchsensor.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/punchsensor-image-banner.png"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/punchsensor-image3.png"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 28,
                subcategory: "E-THERAPY BODYSTYLER",
                subdesc: "Lower Body Negative Pressure (LBNP) redistributes blood from the upper body to the lower body. LBNP may prove to be a countermeasure for the multifaceted physiological changes endured by astronauts during spaceflight related to cephalad fluid shift. Over more than five decades, beginning with the era of Skylab, advancements in LBNP technology have expanded our understanding of neurological, ophthalmological, cardiovascular, and musculoskeletal adaptations in space, with particular emphasis on mitigating issues such as bone loss. To date however, no comprehensive review has been conducted that chronicles the evolution of this technology or elucidates the broadspectrum potential of LBNP in managing the diverse physiological challenges encountered in the microgravity environment. Our study takes a chronological perspective.",

                cover: require("../../Assets/Products/SportsScience/Products/LNBimges.jpg"),
                brand: require("../../Assets/Products/Psychology/transparent-logo.png"),

                backcolor: "#A6B8DE",

                Products: [
                    {
                        id: 2,
                        title: "Lower Body Negative Pressure",
                        title2: "",
                        cover: require("../../Assets/Products/SportsScience/Products/650x350section-image-2.jpg"),
                        description: "A medical device combination, BODYSTYLER is a device for massaging a lower body by using a negative pressure. BODYSTYLER is used to help to relieve pain and promote blood circulation by performing the deep thermotherapy on a human body with physical energy and laser. Additionally, since a retractable cover is provided, a handicapped user can also use the device easily.",
                        description2: "",

                        Headingplb1: "WHAT IS LOWER BODY NEGATIVE PRESSURE? ",
                        pragraphplb1: "Spaceflight Associated Neuro-ocular Syndrome, bone decalcification, and muscle atrophy are among the most prevalent risks associated with long-duration spaceflight. Implementing the lower body negative pressure (LBNP) method is a potential countermeasure for these risks. LBNP counteracts head-ward fluid shifts and generates ground-reaction forces (GRFs). GRFs are beneficial for maintaining bones and muscles by producing gravity-like loads experienced on Earth. Currently, LBNP devices are large/bulky, and usually require the subject to maintain a stationary position.",

                        Headingplb2: "CAN LBNP REDUCE MUSCULOSKELETAL HEAD WARD FLUID SHIFT ISSUES?",
                        pragraphplb2: "However, remaining stationary in exercise devices for 1–2 h per day sacrifices critical crew time for operational and science-related tasks. A common technique to potentially alleviate musculoskeletal and head-ward fluid shift issues is applying lower body negative pressure (LBNP). LBNP induces a blood shift from upper body to lower body compartments to partially reverse cephalic fluid shifts that occur during weightlessness. Additionally, LBNP produces reflexive hemodynamic and cardiovascular control responses similar to when experiencing an increased gravitational load.",
                        Headingplb3: "WHAT IS THE ROLE OF NEGATIVE PRESSURE? ",
                        pragraphplb3: "Constant negative pressure throughout the respiratory cycle increases the patient's functional residual capacity (FRC) and is equivalent to a positive end expiratory pressure produced inside the airway.",
                        companyLink1: "http://goodpl.kr/kor/detail.php?id=72",
                        videoLinks1: ["../../Assets/Products/SportsScience/Products/Goodpl_Video_EnglishAudio.mp4"]
                        ,
                        buttons1: "VISIT THE COMPANY WEBSITE",
                        Headingplb4: "WHAT DOES NEGATIVE PRESSURE DO TO YOUR BODY?",
                        pragraphplb4: "Application of negative pressures ranging between −25 and −80 mm. Hg to the lower half of the supine body produces cardiovascular changes similar to venesection and upright tilting. The heart rate increases between 13 and 67 per cent; central venous pressure decreases by 3 to 6 mm.",

                        headingbuletslb: "Features:",
                        bulletPoints0spunchlb: [
                            `Excellent massaging effect obtained by using a negative pressure method`,
                            "Deep themotherepy effect obtained by using a laser function",
                            "Chamber type with a retractable cover for convenient use.",
                            "Pressure control according to the user and various massage modes provided",
                            "Height adjustment according to characteristics of the user(56 to 68cm)"
                            , "Inclination adjustment for promoting blood circulation(25*)"

                        ],



                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/LBNP-Bodystyler_image.png"),
                                linkname: "goodpl",
                                link: "https://www.goodpl.kr",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/LBNP-Bodystyler_image.png"),
                            },
                        ],
                    },
                ]
            },

        ],
    },
    {
        id: 3,
        Category: "Strength and conditioning",
        cover: require("../../Assets/CategoryPage/Sports Strength.webp"),
        link: "pukhya/strength-and-conditioning",
        subcategories: [
            {
                id: 21,
                subcategory: "Medilogics Germany",
                title: "Welcome to Medilogic",
                subtitle: "",
                subdesc: "",
                description: "your expert partner in biomechanics measurement, from foot pressure analysis to posture assessment tools.",
                subtitle0s: "Scheme of application",
                bulletPoints0s: ["Gait Analysis", "Foot analysis", "Analysis of balance and foot", "Integrated Care Planning", "Visual registration", "Representation", "Pressure distribution in wheelchair", "Saddle position"],
                cover: require("../../Assets/Products/Strength/medilogic.jpg"),
                brand: require("../../Assets/Products/Strength/medilogic_logo.png"),
                backcolor: "#926b3e",

                Products: [
                    {
                        id: 1,
                        title: "Pressure Measuring Platform NX (WLAN) ",
                        title2: "A functional measurement system on highest technical level",
                        cover: require("../../Assets/Products/Strength/Products/pressuremessuring.png"),
                        description: "The Medilogic Foot Pressure Measuring Platform NX offers unmatched flexibility with its modular design, allowing you to connect up to 25 platforms in various configurations—single row, double row, or rectangle—to suit your needs.",
                        description2: "Each platform supports dynamic and static foot pressure measurement, featuring a measuring field of 384 x 384 mm with 4,096 sensors (2.8 sensors per cm²) for precise data. The Medilogic software also provides accurate evaluation by averaging multiple steps.",
                        subtitle0s: "Medilogic Measuring Platform NX",
                        bulletPoints0s: ["up to 25 single platforms as an interlocking system", "individual to configure", "more flexibility", "data transmission via WLAN", "batter-operated, completely wireless", "100 Hz sample rate", "capcitive pressure sensors", "measuring range 0,5 – 100 N/cm²", "medical device class I"],

                        companyLink1: "https://medilogic.com/en/home/",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=bFPdzDkguoY"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Strength/Products/pressuremessuring fet.png"),
                                linkname: "medilogic",
                                link: "https://medilogic.com/en/home/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Strength/Products/pressuremessuring h1.png"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "MedilogicWLAN Insole ",
                        title2: "",
                        cover: require("../../Assets/Products/Strength/Products/WLAN.jpg"),
                        description: "The medilogic WLAN insole is a cable-free, battery-operated foot pressure measuring system that supports improved diagnosis and quality control for orthopaedic shoemakers, facilitating well-adapted patient care through its intuitive software and high-resolution pressure load distribution analysis. It allows for stress analysis during walking, recording the status of the foot, and ensuring the quality of orthopaedic aids with mobile use and CE certification. The system offers real-time picture display, data storage, playback, comparison of measurements, and versatile views, making it a functional measurement system at the highest technical level.",
                        description2: "",
                        subtitle0f: "Key points",
                        bulletPoints0f: ["The medilogic WLAN insole system enhances diagnostic precision and quality control for orthopaedic shoemakers.", "It facilitates improved patient care with insoles and other orthopaedic aids through detailed pressure distribution analysis.", "The insole operates wirelessly with a WLAN interface, providing maximum movement range and online data transmission.", "It features battery-powered data transmission and storage capabilities, even outside of transmission range.", "The system's intuitive software offers real-time imaging, customer database integration, and versatile playback options.", "It supports gait analysis with features like gait line/cyklogram views and real-time/slow-motion playback.", "The insoles are available in various sizes and can be customized, with high sensor density for accurate measurements."],
                        companyLink1: "https://medilogic.com/en/home/",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=W_prsZVxQhU"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Strength/Products/WLAN fet.jpg"),
                                linkname: "medilogic",
                                link: "https://medilogic.com/en/home/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Strength/Products/WLAN h1.jpg"),
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "Foot Scanner ",
                        title2: "",
                        cover: require("../../Assets/Products/Strength/Products/footscanner.jpg"),
                        description: "The Medilogic Foot Scanner kit offers an affordable entry point, starting with the optical FootScanner and allowing for future upgrades with pressure measurement or balance analysis.Its user-friendly graphical interface ensures quick, detailed analysis of measurement results.",
                        description2: "The Medilogic Foot Scanner is an ideal tool for efficient diagnostics, customization, and documentation—leveraging innovative integration of proven methods for optimal patient care.",

                        subtitle0f: "Features:",
                        bulletPoints0f: ["Dimension:LxBxH: 63,5cm x 43,4cm x 11cm ,Scan Area: 43cm x 30 cm Weight approx. 15 kg", "load limit : 180 Kg Bodyweigt.", "Default time for Scan: 10 Seconds", "Highspeed time for Scan: 3 Seconds", "x86 compatible processor, min. 2 GB RAM", "1 free USB Port", "Windows® 7 / 8 / 10"],
                        companyLink1: "https://medilogic.com/en/home/",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=W_prsZVxQhU"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Strength/Products/footscanner fet.jpg"),
                                linkname: "medilogic",
                                link: "https://medilogic.com/en/home/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Strength/Products/footscanner fet.jpg"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 19,
                subcategory: "Fast Twitch Isokinetic",
                title: "Designed By Elite Athletes for Elite Athletes",
                subtitle: "Experience the Next Level of High-Speed Training with Fast Twitch!",
                subdesc: "A new era in high-speed training has arrived. Traditional methods to enhance speed, strength, and explosive power—like plyometric and eccentrically loaded programs—are now a thing of the past.",
                description: "",


                cover: require("../../Assets/Products/SportsScience/fft.jpg"),
                brand: require("../../Assets/Products/SportsScience/FTT-Logo.png"),
                backcolor: "#6C584A",

                subtitles1sm: "Achieve Results—Fast!",
                discription1sm: "Users report significant improvements, including a vertical leap increase of 5 to 10 cm and a reduction in 40-yard sprint times by 0.1 to 0.4 seconds—within just six weeks!",
                discription2sm: "Professional athletes and teams like Emmitt Smith, Mike Modano, Darryl Johnston, Larry Allen, Charles Haley, Brett Hull, Desmond Mason, Dat Nguyen, and elite teams like the Chicago Bulls, Sacramento Kings, Dallas Mavericks, and Iowa University have embraced Fast Twitch for its exceptional performance.",
                bulletPoints0smm: [
                    {
                        title: "Introducing Fast Twitch",
                        description: "The revolutionary approach to training for speed, strength, and explosive power. Unlike conventional techniques, Fast Twitch provides high-speed, high-intensity resistance training that:",
                        points: [
                            "Simulates competition speed without injury risks.",
                            "Prevents delayed muscle soreness (DOMS) by eliminating joint loading and muscle tension.",
                            "Enhances neuromuscular activation by increasing fast-twitch fiber recruitment, boosting speed and power.",
                            "Improves cardiovascular endurance while burning fat.",
                            "Elevates lactic acid thresholds through dual concentric loading, essential for dynamic sports.",
                            "Promotes faster rehabilitation due to its low-impact nature and adjustable resistance."
                        ]
                    }
                ],

                discription3sm: "Fast Twitch is equipped with a Computer Managed Training System (CMTS), featuring preloaded templates that monitor and analyze performance in real time. Training data can be instantly shared via the web, keeping you connected and informed.",

                discription4sm: "Fast Twitch’s unique approach prevents muscle soreness and supports aerobic conditioning, making it ideal for general fitness and recovery programs.",
                subtitles2sm: "Proven by the Best:",
                subtitles3sm: "Advanced Technology for Precision Training:",
                subtitles4sm: "Perfect for Fitness and Rehabilitation:",
                subtitles5sm: "Fast Twitch—Achieve Unmatched Speed, Power, and Endurance!",
                Products: [
                    {
                        id: 1,
                        title: "IsoMed ",
                        title2: "One Stop, Multi-Joint, Rehabilitation Machine Hip | Shoulder | Elbow | Back | Ankle | Wrist",
                        cover: require("../../Assets/Products/SportsScience/Products/med.jpg"),
                        description: "This Multi joint machine is for unilateral knee function with Range limiter device.Right Motor Rotates 180degree.",
                        description2: "",

                        bulletPoints0smp: [
                            {
                                "title": "FEATURES",
                                "points": [
                                    "Computer Managed Training System.",
                                    "Touch Screen Control and Smart System PC.",
                                    "Display 80 Individual Field of data.",
                                    "Rotatory and Linear Motion Hydraulic Resistance System.",
                                    "Heavy Duty Frame and Handlebar.",
                                    "Multi-bench Position and Establishing Straps.",
                                    "Adjustable Angle Bench (30-90 degree).",
                                    "Eccentric Options.",
                                    "Variable Speed Control (2deg/sec – 600deg/sec).",
                                    "Counter Thrust Platform.",
                                    "Unilateral and Bilateral Exercise System.",
                                    "Adjustable Height, Position and Support."
                                ]
                            }
                        ]
                        ,

                        companyLink1: "https://www.fasttwitch.com/",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=QU2JO79aY4o"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/med fet.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/med h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/med h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "Isokinetic Knee",
                        title2: "Ultimate Speed Leg Extension Flexion",
                        cover: require("../../Assets/Products/SportsScience/Products/knee.jpg"),
                        description: "This high speed isokinetic knee machine is perfect for rehabilitation, sports performance, and training at speeds that are simply not achievable with other forms of training. Data displays both limbs simultaneously and shows imbalance at high speeds.",
                        description2: "",
                        companyLink1: "https://www.fasttwitch.com/",
                        videoLinks1: [
                            "https://www.youtube.com/embed/uhghy9pFIPY"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        bulletPoints0smm: [
                            {
                                "title": "Features",
                                "points": [
                                    "Rotatory and Liner Motion Hydraulic Resistence System.",
                                    "Touch Screen Display and Smart System PC.",
                                    "Computer Managed Training System.",
                                    "Adjustable Leg Position.",
                                    "Stabilising Straps.",
                                    "Unilateral and Bilateral Exercising system.",
                                    "Variable Speed Control (10 deg per/sec - 8 deg/sec)."
                                ]
                            }
                        ],


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/knee.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/knee h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "Squat ",
                        title2: "FOOTPRINT",
                        companyLink1: "https://www.fasttwitch.com/performance-program",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=b0k4NOlRTY4"
                        ],
                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        cover: require("../../Assets/Products/SportsScience/Products/SQUAt.jpg"),
                        description: "The Squat machine is the flagship Isokinetic machine. The importance of squats in athletic performance is well documented. Now you can achieve more power, more speed and more strength safer and faster than any other form of squatting. Imagine being able to fire the nervous system and achieve triple extension against resistance and use data reporting to show improvements over time.",
                        description2: "Width 1.2m Length 2.2m Height 1.6m Weight 200 kg The Squat machine is the flagship Isokinetic machine. The importance of squats in athletic performance is well documented. Now you can achieve more power, more speed and more strength safer and faster than any other form of squatting. Imagine being able to fire the nervous system and achieve triple extension against resistance and use data reporting to show improvements over time.  Select two-way resistance settings to neurologically activate Flexion and Extension contractions. Perfect for rehabilitation, sports performance and training at speeds that are simply not achievable on other forms of training.",
                        bulletPoints0sms: [
                            {
                                "title": "FEATURES",
                                "points": [
                                    "Linear motion hydraulic resistance system.",
                                    "Computer Managed Training System.",
                                    "Touch Screen Display and Smart PC System.",
                                    "Heavy Duty Frame.",
                                    "Counter Balance Lever Arm."
                                ]
                            }
                        ],


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/squat ft.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/squat h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/squat h2.jpeg"),
                            },
                        ],
                    },
                    {
                        id: 4,
                        title: "Isokinetic HIP",
                        title2: "FOOTPRINT",
                        cover: require("../../Assets/Products/SportsScience/Products/hip.jpg"),
                        description: "The Hip machine is ideal for increasing running speed. It is capable of achieving in excess of 600 – 800 degrees per second in the running flexion/extension position. Replicates high knee lift component of expolsive movements Instantaneously switching resistance between glute and hip flexor, to engage high speed muscle contraction for speed/power development. ",
                        description2: "Length 1.5m Width 1.2m Height 1.4m Weight 150kg The Hip machine is one of the most robust machines on the market. It is capable of achieving in excess of 600 – 800 degrees per second in the running flexion/extension position. Ideal for increasing running speed Glute, hip flexor activation is the ideal way to safely move at these speeds under resistance. Instantaneously switching resistance between glute and hip flexor, to engage high speed muscle contraction for speed/power development. Imagine being able to fire the nervous system against resistance in the running mechanical position at the same speeds you play sports. ",
                        bulletPoints0ship: [
                            {
                                "title": "FEATURES",
                                "points": [
                                    "Rotary Motion Hydraulic Resistance System",
                                    "Computer Managed Training System",
                                    "Touch Screen Display and Smart System PC",
                                    "Heavy Duty Frame and Handlebar",
                                    "Height Adjustable Motor",
                                    "Measures Speed"
                                ]
                            }
                        ],
                        companyLink1: "https://www.fasttwitch.com/performance-program",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=D_G6UnCJ7aM",
                            "https://www.youtube.com/watch?v=uM0Ili9Dl4c",
                            "https://www.youtube.com/watch?v=aCSPaXCaERI"
                        ],


                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/hip fet.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/hip h1.jpg"),
                            },
                        ],
                    },
                    {
                        id: 5,
                        title: "Jump Squat",
                        title2: "With Digital Led Minicomputer - Hip | Knee | Ankle",
                        cover: require("../../Assets/Products/SportsScience/Products/JUMP-Squat.jpg"),
                        description: "This is a simpler form of technology incorporating the same features of the squat machine, still achieving triple extension with 1 to 8 against resistance scale, and performing dual concentric and concentric/eccentric.",
                        description2: "",

                        companyLink1: "https://www.fasttwitch.com/",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=uM0Ili9Dl4c", "https://www.youtube.com/watch?v=uhghy9pFIPY&list=TLPQMDMwNDIwMjXA6u5KQexigQ&index=3"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        bulletPoints0sj: [
                            {
                                "title": "Features",
                                "points": [
                                    "Rotatory Motion Hydraulic Resistance System.",
                                    "Eccentric Load Spigot.",
                                    "Heavy Duty Frame.",
                                    "Variable Speed Control (10deg/sec – 600deg/sec)."
                                ]
                            }
                        ],

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/biofeedbackfet.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/miqus.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/miqus.jpg"),
                            },
                        ],
                    },
                ]
            },
        ],
    },
    {
        id: 7,
        Category: "Rehabilitation",
        cover: require("../../Assets/CategoryPage/Exercise & Sports Physiology.jpg"),
        link: "pukhya/rehabilitation",
        subcategories: [
            {
                id: 9,
                subcategory: "Delsys",
                title: "We help people measure and analyze motion",
                subtitle: "Applications for motion capture technology",
                subdesc: "Our technology is used by researchers, biomechanists, physicians and engineers from all over the world. However, anyone that is interested in getting objective information about how things move can benefit from our technology. For example, our motion capture systems can be used to find and prevent injuries, improve performance in biomechanics and help engineers build better products and increase production efficiency.",
                description: "World leader in human measurement in complex and real environments for over 30 years, TEA innovates for the well-being of humans with agile solutions and services.",
                cover: require("../../Assets/Products/Biomechanics/Delsys-banner.png"),
                brand: require("../../Assets/Products/Biomechanics/Delsyslogo.png"),
                backcolor: "#0a0a0a",
                Products: [
                    {
                        id: 1,
                        title: "Trigno Mobile System",

                        title2: "KIT FOR RESEACH TRAINING AND CLINICAL SYSTEM",
                        title04: "On-the-go tools for clinical and teaching applications.",
                        cover: require("../../Assets/Products/Biomechanics/Products/Section Image.jpg"),
                        description: "Unlock comprehensive insights into muscle activity and movement with Delsys Mobile EMG Systems. Designed for research, clinical, and educational use, these kits provide synchronized EMG and motion capture data for rehabilitation, performance analysis, and teaching",
                        description2: "",


                        subtitle182: "Each kit features advanced Delsys sensors, including:",
                        bulletPoints182: [
                            "Trigno Avanti Sensors :– wireless EMG sensors with integrated inertial measurement (IMU) for motion tracking.",
                            "Trigno Galileo Sensors :– high-fidelity EMG sensors for deep muscle analysis.",
                            "Trigno Quattro Sensors :– multi-channel EMG sensors for detailed muscle mapping.",
                            "Trigno Mini Sensors :– compact EMG units ideal for small muscle groups or pediatric applications.",
                        ],
                        subtitle1802: "Trigno Mobile System Features:",
                        bulletPoints1802: [
                            "Compatible with various Trigno sensors",
                            "Bluetooth Connectivity",
                            "Data collection with Mobile EMG Suite",
                            ,
                        ],
                        subtitle1803: "Application areas: ",
                        bulletPoints1803: [
                            "Trigno Mobile for Grip Strength",
                            "For education",
                            "For balance training",
                            "For muscular Imbalance",
                            "For physical therepy",
                            "For sports"
                            ,
                        ],

                        companyLink1: "https://delsys.com/products/#system",
                        videoLinks1: ["https://www.youtube.com/watch?v=ojLik28e_kE", "https://www.youtube.com/watch?v=m63UtuoZwYQ", "https://www.youtube.com/watch?v=JA5sjNgcumU", "https://www.youtube.com/watch?v=F7PM5C-M6OA"],
                        buttons1: "VISIT THE COMPANY WEBSITE",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel EMG fet.png"),
                                linkname: "Delsys",
                                link: "https://delsys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 1,
                        title: "Trigno Centro EMG System:",
                        title2: "Complete Solutions for Human Movement",
                        title05: "Built on the past, informed by the present, designed for the future.",
                        cover: require("../../Assets/Products/Biomechanics/Products/Trigno-Centro.jpg"),
                        description: "Human movement is complex. Trigno Centro dynamically unravels this complexity.Discover the intricacies and co-ordination of motor control.Designed for unrivaled research quality in human movement, engineering, and neurophysiology applications.Crafted to deliver unmatched precision for research in human movement, engineering, and neurophysiology, the only boundary for your discoveries is your imagination.",
                        description2: "",
                        companyLink1: "https://delsys.com/product/trigno-centro/",
                        videoLinks1: ["https://www.youtube.com/watch?v=coe-QmJ4dqk", "https://www.youtube.com/watch?v=VpyQrVVdIÈ"],
                        buttons1: "VISIT THE COMPANY WEBSITE",

                        subtitle182t: "Trigno System Features:",
                        bulletPoints182t: [
                            "Compatible with all Trigno sensors and PC software",
                            "Support 2- 32 sensors",
                            "Communicate via RF protocol",
                            "Integrate with Trigger Module, analog outputs, API,  SDK, and third-party software plugins",
                        ],
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel EMG fet.png"),
                                linkname: "Delsys",
                                link: "https://delsys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/trigo centero h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/trigo centero h2.jpg"),
                            },
                        ],

                    },
                    {
                        id: 1,
                        title: "Trigno Lite System",
                        title2: "EMG + Movement Made Simple",
                        cover: require("../../Assets/Products/Biomechanics/Products/4-channel-emg-system.jpg"),
                        description: "TheTrigno Lite System combines research-grade EMG and movement sensors with the simplicity of a laptop or tablet, offering point-of-care results with minimal setup. Ideal for clinical, educational, and field-based research, it delivers high-quality physiological and biomechanical data in real time.",

                        description2: "",



                        subtitle172: "Key Applications:",
                        bulletPoints172: [
                            "Human Movement Analysis",
                            "Physical Rehabilitation & Therapy",
                            "Sports Performance & Ergonomics",
                            "Classroom Demonstrations & Student Projects",

                        ],

                        subtitle193: "Featured Products:",
                        bulletPoints193: [

                            "Wireless Trigno Sensors for EMG + IMU data",
                            "Easy data acquisition via USB receiver",
                            "Real-time visualization and storage with Trigno Discover software",
                            "Proprietary RF protocol ensures precise synchronization",
                            "Plug-and-play usability—no complex setup needed",
                        ],
                        subtitle194: "TrignoLite System Includes:",
                        bulletPoints194: [

                            "Trigno Avanti –: Compact EMG + motion sensor",
                            "Trigno Mini –: Ideal for small or pediatric muscle groups",
                            "Trigno Quattro –: Multi-channel EMG for detailed studies",

                        ],

                        companyLink1: "https://delsys.com/product/trigno-lite/",
                        videoLinks1: ["https://youtu.be/evNtRJKOXQ0"],
                        buttons1: "VISIT THE COMPANY WEBSITE",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel EMG fet.png"),
                                linkname: "Delsys",
                                link: "https://delsys.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/Biomechanics/Products/trigro system.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/Biomechanics/Products/4-channel h2.jpg"),
                            },
                        ],
                    },

                ]
            },
            {
                id: 19,
                subcategory: "Fast Twitch Isokinetic",
                title: "Designed By Elite Athletes for Elite Athletes",
                subtitle: "Experience the Next Level of High-Speed Training with Fast Twitch!",
                subdesc: "A new era in high-speed training has arrived. Traditional methods to enhance speed, strength, and explosive power—like plyometric and eccentrically loaded programs—are now a thing of the past.",
                description: "",


                cover: require("../../Assets/Products/SportsScience/fft.jpg"),
                brand: require("../../Assets/Products/SportsScience/FTT-Logo.png"),
                backcolor: "#6C584A",

                subtitles1sm: "Achieve Results—Fast!",
                discription1sm: "Users report significant improvements, including a vertical leap increase of 5 to 10 cm and a reduction in 40-yard sprint times by 0.1 to 0.4 seconds—within just six weeks!",
                discription2sm: "Professional athletes and teams like Emmitt Smith, Mike Modano, Darryl Johnston, Larry Allen, Charles Haley, Brett Hull, Desmond Mason, Dat Nguyen, and elite teams like the Chicago Bulls, Sacramento Kings, Dallas Mavericks, and Iowa University have embraced Fast Twitch for its exceptional performance.",
                bulletPoints0smm: [
                    {
                        title: "Introducing Fast Twitch",
                        description: "The revolutionary approach to training for speed, strength, and explosive power. Unlike conventional techniques, Fast Twitch provides high-speed, high-intensity resistance training that:",
                        points: [
                            "Simulates competition speed without injury risks.",
                            "Prevents delayed muscle soreness (DOMS) by eliminating joint loading and muscle tension.",
                            "Enhances neuromuscular activation by increasing fast-twitch fiber recruitment, boosting speed and power.",
                            "Improves cardiovascular endurance while burning fat.",
                            "Elevates lactic acid thresholds through dual concentric loading, essential for dynamic sports.",
                            "Promotes faster rehabilitation due to its low-impact nature and adjustable resistance."
                        ]
                    }
                ],

                discription3sm: "Fast Twitch is equipped with a Computer Managed Training System (CMTS), featuring preloaded templates that monitor and analyze performance in real time. Training data can be instantly shared via the web, keeping you connected and informed.",

                discription4sm: "Fast Twitch’s unique approach prevents muscle soreness and supports aerobic conditioning, making it ideal for general fitness and recovery programs.",
                subtitles2sm: "Proven by the Best:",
                subtitles3sm: "Advanced Technology for Precision Training:",
                subtitles4sm: "Perfect for Fitness and Rehabilitation:",
                subtitles5sm: "Fast Twitch—Achieve Unmatched Speed, Power, and Endurance!",
                Products: [
                    {
                        id: 1,
                        title: "IsoMed ",
                        title2: "One Stop, Multi-Joint, Rehabilitation Machine Hip | Shoulder | Elbow | Back | Ankle | Wrist",
                        cover: require("../../Assets/Products/SportsScience/Products/med.jpg"),
                        description: "This Multi joint machine is for unilateral knee function with Range limiter device.Right Motor Rotates 180degree.",
                        description2: "",

                        bulletPoints0smp: [
                            {
                                "title": "FEATURES",
                                "points": [
                                    "Computer Managed Training System.",
                                    "Touch Screen Control and Smart System PC.",
                                    "Display 80 Individual Field of data.",
                                    "Rotatory and Linear Motion Hydraulic Resistance System.",
                                    "Heavy Duty Frame and Handlebar.",
                                    "Multi-bench Position and Establishing Straps.",
                                    "Adjustable Angle Bench (30-90 degree).",
                                    "Eccentric Options.",
                                    "Variable Speed Control (2deg/sec – 600deg/sec).",
                                    "Counter Thrust Platform.",
                                    "Unilateral and Bilateral Exercise System.",
                                    "Adjustable Height, Position and Support."
                                ]
                            }
                        ]
                        ,

                        companyLink1: "https://www.fasttwitch.com/",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=QU2JO79aY4o"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/med fet.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/med h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/med h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 2,
                        title: "Isokinetic Knee",
                        title2: "Ultimate Speed Leg Extension Flexion",
                        cover: require("../../Assets/Products/SportsScience/Products/knee.jpg"),
                        description: "This high speed isokinetic knee machine is perfect for rehabilitation, sports performance, and training at speeds that are simply not achievable with other forms of training. Data displays both limbs simultaneously and shows imbalance at high speeds.",
                        description2: "",
                        companyLink1: "https://www.fasttwitch.com/",
                        videoLinks1: [
                            "https://www.youtube.com/embed/uhghy9pFIPY"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        bulletPoints0smm: [
                            {
                                "title": "Features",
                                "points": [
                                    "Rotatory and Liner Motion Hydraulic Resistence System.",
                                    "Touch Screen Display and Smart System PC.",
                                    "Computer Managed Training System.",
                                    "Adjustable Leg Position.",
                                    "Stabilising Straps.",
                                    "Unilateral and Bilateral Exercising system.",
                                    "Variable Speed Control (10 deg per/sec - 8 deg/sec)."
                                ]
                            }
                        ],


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/knee.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/knee h2.jpg"),
                            },
                        ],
                    },
                    {
                        id: 3,
                        title: "Squat ",
                        title2: "FOOTPRINT",
                        companyLink1: "https://www.fasttwitch.com/performance-program",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=b0k4NOlRTY4"
                        ],
                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        cover: require("../../Assets/Products/SportsScience/Products/SQUAt.jpg"),
                        description: "The Squat machine is the flagship Isokinetic machine. The importance of squats in athletic performance is well documented. Now you can achieve more power, more speed and more strength safer and faster than any other form of squatting. Imagine being able to fire the nervous system and achieve triple extension against resistance and use data reporting to show improvements over time.",
                        description2: "Width 1.2m Length 2.2m Height 1.6m Weight 200 kg The Squat machine is the flagship Isokinetic machine. The importance of squats in athletic performance is well documented. Now you can achieve more power, more speed and more strength safer and faster than any other form of squatting. Imagine being able to fire the nervous system and achieve triple extension against resistance and use data reporting to show improvements over time.  Select two-way resistance settings to neurologically activate Flexion and Extension contractions. Perfect for rehabilitation, sports performance and training at speeds that are simply not achievable on other forms of training.",
                        bulletPoints0sms: [
                            {
                                "title": "FEATURES",
                                "points": [
                                    "Linear motion hydraulic resistance system.",
                                    "Computer Managed Training System.",
                                    "Touch Screen Display and Smart PC System.",
                                    "Heavy Duty Frame.",
                                    "Counter Balance Lever Arm."
                                ]
                            }
                        ],


                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/squat ft.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/squat h1.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/SportsScience/Products/squat h2.jpeg"),
                            },
                        ],
                    },
                    {
                        id: 4,
                        title: "Isokinetic HIP",
                        title2: "FOOTPRINT",
                        cover: require("../../Assets/Products/SportsScience/Products/hip.jpg"),
                        description: "The Hip machine is ideal for increasing running speed. It is capable of achieving in excess of 600 – 800 degrees per second in the running flexion/extension position. Replicates high knee lift component of expolsive movements Instantaneously switching resistance between glute and hip flexor, to engage high speed muscle contraction for speed/power development. ",
                        description2: "Length 1.5m Width 1.2m Height 1.4m Weight 150kg The Hip machine is one of the most robust machines on the market. It is capable of achieving in excess of 600 – 800 degrees per second in the running flexion/extension position. Ideal for increasing running speed Glute, hip flexor activation is the ideal way to safely move at these speeds under resistance. Instantaneously switching resistance between glute and hip flexor, to engage high speed muscle contraction for speed/power development. Imagine being able to fire the nervous system against resistance in the running mechanical position at the same speeds you play sports. ",
                        bulletPoints0ship: [
                            {
                                "title": "FEATURES",
                                "points": [
                                    "Rotary Motion Hydraulic Resistance System",
                                    "Computer Managed Training System",
                                    "Touch Screen Display and Smart System PC",
                                    "Heavy Duty Frame and Handlebar",
                                    "Height Adjustable Motor",
                                    "Measures Speed"
                                ]
                            }
                        ],
                        companyLink1: "https://www.fasttwitch.com/performance-program",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=D_G6UnCJ7aM",
                            "https://www.youtube.com/watch?v=uM0Ili9Dl4c",
                            "https://www.youtube.com/watch?v=aCSPaXCaERI"
                        ],


                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/hip fet.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/hip h1.jpg"),
                            },
                        ],
                    },
                    {
                        id: 5,
                        title: "Jump Squat",
                        title2: "With Digital Led Minicomputer - Hip | Knee | Ankle",
                        cover: require("../../Assets/Products/SportsScience/Products/JUMP-Squat.jpg"),
                        description: "This is a simpler form of technology incorporating the same features of the squat machine, still achieving triple extension with 1 to 8 against resistance scale, and performing dual concentric and concentric/eccentric.",
                        description2: "",

                        companyLink1: "https://www.fasttwitch.com/",
                        videoLinks1: [
                            "https://www.youtube.com/watch?v=uM0Ili9Dl4c", "https://www.youtube.com/watch?v=uhghy9pFIPY&list=TLPQMDMwNDIwMjXA6u5KQexigQ&index=3"
                        ],

                        buttons1: "VISIT THE COMPANY WEBSITE ",
                        bulletPoints0sj: [
                            {
                                "title": "Features",
                                "points": [
                                    "Rotatory Motion Hydraulic Resistance System.",
                                    "Eccentric Load Spigot.",
                                    "Heavy Duty Frame.",
                                    "Variable Speed Control (10deg/sec – 600deg/sec)."
                                ]
                            }
                        ],

                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/Biomechanics/Products/biofeedbackfet.jpg"),
                                linkname: "fasttwitch",
                                link: "https://fasttwitchisokinetics.com/",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/miqus.jpg"),
                            },
                            {
                                id: 2,
                                cover: require("../../Assets/Products/miqus.jpg"),
                            },
                        ],
                    },
                ]
            },
            {
                id: 28,
                subcategory: "E-THERAPY BODYSTYLER",
                subdesc: "Lower Body Negative Pressure (LBNP) redistributes blood from the upper body to the lower body. LBNP may prove to be a countermeasure for the multifaceted physiological changes endured by astronauts during spaceflight related to cephalad fluid shift. Over more than five decades, beginning with the era of Skylab, advancements in LBNP technology have expanded our understanding of neurological, ophthalmological, cardiovascular, and musculoskeletal adaptations in space, with particular emphasis on mitigating issues such as bone loss. To date however, no comprehensive review has been conducted that chronicles the evolution of this technology or elucidates the broadspectrum potential of LBNP in managing the diverse physiological challenges encountered in the microgravity environment. Our study takes a chronological perspective.",

                cover: require("../../Assets/Products/SportsScience/Products/LNBimges.jpg"),
                brand: require("../../Assets/Products/Psychology/transparent-logo.png"),

                backcolor: "#A6B8DE",

                Products: [
                    {
                        id: 2,
                        title: "Lower Body Negative Pressure",
                        title2: "",
                        cover: require("../../Assets/Products/SportsScience/Products/650x350section-image-2.jpg"),
                        description: "A medical device combination, BODYSTYLER is a device for massaging a lower body by using a negative pressure. BODYSTYLER is used to help to relieve pain and promote blood circulation by performing the deep thermotherapy on a human body with physical energy and laser. Additionally, since a retractable cover is provided, a handicapped user can also use the device easily.",
                        description2: "",

                        Headingplb1: "WHAT IS LOWER BODY NEGATIVE PRESSURE? ",
                        pragraphplb1: "Spaceflight Associated Neuro-ocular Syndrome, bone decalcification, and muscle atrophy are among the most prevalent risks associated with long-duration spaceflight. Implementing the lower body negative pressure (LBNP) method is a potential countermeasure for these risks. LBNP counteracts head-ward fluid shifts and generates ground-reaction forces (GRFs). GRFs are beneficial for maintaining bones and muscles by producing gravity-like loads experienced on Earth. Currently, LBNP devices are large/bulky, and usually require the subject to maintain a stationary position.",

                        Headingplb2: "CAN LBNP REDUCE MUSCULOSKELETAL HEAD WARD FLUID SHIFT ISSUES?",
                        pragraphplb2: "However, remaining stationary in exercise devices for 1–2 h per day sacrifices critical crew time for operational and science-related tasks. A common technique to potentially alleviate musculoskeletal and head-ward fluid shift issues is applying lower body negative pressure (LBNP). LBNP induces a blood shift from upper body to lower body compartments to partially reverse cephalic fluid shifts that occur during weightlessness. Additionally, LBNP produces reflexive hemodynamic and cardiovascular control responses similar to when experiencing an increased gravitational load.",
                        Headingplb3: "WHAT IS THE ROLE OF NEGATIVE PRESSURE? ",
                        pragraphplb3: "Constant negative pressure throughout the respiratory cycle increases the patient's functional residual capacity (FRC) and is equivalent to a positive end expiratory pressure produced inside the airway.",
                        companyLink1: "http://goodpl.kr/kor/detail.php?id=72",
                        videoLinks1: ["/videos/Goodpl_Video_EnglishAudio.mp4"],
                        buttons1: "VISIT THE COMPANY WEBSITE",
                        Headingplb4: "WHAT DOES NEGATIVE PRESSURE DO TO YOUR BODY?",
                        pragraphplb4: "Application of negative pressures ranging between −25 and −80 mm. Hg to the lower half of the supine body produces cardiovascular changes similar to venesection and upright tilting. The heart rate increases between 13 and 67 per cent; central venous pressure decreases by 3 to 6 mm.",

                        headingbuletslb: "Features:",
                        bulletPoints0spunchlb: [
                            `Excellent massaging effect obtained by using a negative pressure method`,
                            "Deep themotherepy effect obtained by using a laser function",
                            "Chamber type with a retractable cover for convenient use.",
                            "Pressure control according to the user and various massage modes provided",
                            "Height adjustment according to characteristics of the user(56 to 68cm)"
                            , "Inclination adjustment for promoting blood circulation(25*)"

                        ],



                        mainhigh: [
                            {
                                id: 1,
                                logo: <CiMedicalCross />,
                                title: "heading first"
                            },
                            {
                                id: 2,
                                logo: <LuSunMedium />,
                                title: "heading second",
                            },
                            {
                                id: 3,
                                logo: <CiMedicalMask />,
                                title: "heading third",
                            },
                            {
                                id: 4,
                                logo: <FaBacteria />,
                                title: "heading fourth",
                            },
                        ],
                        mainfet: [
                            {
                                id: 1,
                                desc: "this is first features"
                            },
                            {
                                id: 2,
                                desc: "this is second features"
                            },
                            {
                                id: 3,
                                desc: "this is third features"
                            },
                            {
                                id: 4,
                                desc: "this is fourth features"
                            },
                            {
                                id: 4,
                                desc: "this is fifth features"
                            },
                            {
                                id: 4,
                                desc: "this is sixth features"
                            },
                        ],
                        feature: [
                            {
                                id: 1,
                                title: "this is title",
                                desc: "this is description",
                                cover: require("../../Assets/Products/SportsScience/Products/LBNP-Bodystyler_image.png"),
                                linkname: "goodpl",
                                link: "https://www.goodpl.kr",
                            }
                        ],
                        highlights: [
                            {
                                id: 1,
                                cover: require("../../Assets/Products/SportsScience/Products/LBNP-Bodystyler_image.png"),
                            },
                        ],
                    },
                ]
            },
            // {
            //     id: 29,
            //     subcategory: "HeadApp",
            //     title: "Headapp- Cognitive Rehabilitaion Training A Product by Neurozip",
            //     subtitle: "",
            //     title20h: "Preferred Solution for Clinical Professionals",
            //     subdesc: "Whether you specialize in speech-language pathology, neuropsychology, psychology, or occupational therapy, HeadApp by NeuroZip equips you with a modern digital therapeutic intervention.",
            //     description: "This versatile software is designed to screen, treat, and monitor neurocognitive, neuropsychiatric, and geriatric brain disorders, providing valuable support in your clinical practice.",
            //     cover: require("../../Assets/Products/Rehabilitation/headapp.webp"),
            //     brand: require("../../Assets/Products/Rehabilitation/headapp brand.png"),
            //     backcolor: "#F2A91F",
            //     Products: [
            //         {
            //             id: 2,
            //             title: "HEADAPP In",
            //             title2: "Computer-Aided Cognitive Rehabilitation",
            //             cover: require("../../Assets/Products/Rehabilitation/section-image-2.jpg"),
            //             description: "Cognitive rehabilitation is a therapy aimed at restoring impaired cognitive functions, such as memory, attention, perception, and judgment, to improve individuals’ ability to resume daily activities. It focuses on enhancing information processing and interpretation, which can positively impact relationships, employment, and community participation. HeadApp offers a personalized, computer-aided approach to cognitive screening and training, specifically designed to assist patients with brain injuries, neurodevelopmental disorders, and psychiatric conditions, emphasizing integrated mental and cognitive health solutions.",
            //             description2: "",
            //             companyLink1: "https://neurozip.com/",
            //             videoLinks1: ["https://www.youtube.com/watch?v=nt6ednRLMlU", "https://www.youtube.com/watch?v=onWy43_ruQA", "https://www.youtube.com/watch?v=2TNIw8a1W1U"],
            //             buttons1: "VISIT THE COMPANY WEBSITE",
            //             headingbuletslb: "Key Points:",
            //             bulletPoints0spunchlb: [
            //                 `Cognitive rehabilitation aims to rebuild impaired cognitive functions to enable better daily functioning.`,
            //                 "The therapy focuses on correcting deficits in memory, concentration, perception, and judgment.",
            //                 "Cognitive rehabilitation enhances a person’s capacity to process and interpret information effectively.",
            //                 "Improving cognitive functions can help individuals maintain relationships, work, and participate in their community.",
            //                 "HeadApp provides a tailored, computer-assisted solution for cognitive screening and training."
            //                 , "The platform specifically targets patients with acquired brain injuries and neurodevelopmental or psychiatric disorders.",
            //                 "Personalized treatment plans are central to the integrated approach offered by HeadApp for mental and cognitive health."

            //             ],
            //             Headingheap: "Telerehabilitation with HeadApp",
            //             Headingheap1: "Would you like to assign cognitive homework, expand your patient reach, and strengthen loyalty to your practice?",
            //             Heappragraph: "This is your solution! Explore the therapy plan feature seamlessly integrated into HeadApp, available to you at no additional cost.",
            //             Headingheap2: "Extended Flexibility",
            //             Heappragraph1: "Applying HeadApp enhances accessibility to patients, reinforcing face-to-face clinic activities with extended flexibility, culminating in a comprehensive approach to personalized and effective cognitive recovery.",
            //             Headingheap3: "Streamline Progress",
            //             Heappragraph2: "The HeadApp“therapy plan” for distance treatment ensures consistent progress by eliminating disruptions from factors such as distance and transportation issues, addressing geographical challenges, and providing flexibility and convenience.",
            //             Headingheap4: "Included at No Extra Fees, Unlimited Patients",
            //             Heappragraph3: "Extend your therapeutic reach to an unlimited number of patients, enhancing accessibility and providing comprehensive care. Provide cognitive rehabilitation without the burden of extra costs – it’s all included in HeadApp.",
            //             Headingheap5: "Just Try It Out",
            //             Heappragraph4: "Experience the ease of use, and take advantage of the variety of the program.",
            //             headingbuletslheap01: "Advantages for Clinicians:",
            //             bulletPoints0spunchlheap: [
            //                 "Optimize Patient Reach: Enhances accessibility and extends flexibility for office activities.",
            //                 "Expand Business Capacity: Manages the rehabilitation of patients from various regions.",
            //                 "Efficient Time Management: Reduces downtime and travel, optimizing therapeutic efforts.",
            //                 "Controlled and Personalized Remote Interventions: Facilitates precise remote therapies with immediate or later access to training results.",
            //                 "Redefine Therapy Based on Progress: Personalizes therapy to individual progress, encouraging continuous improvement."
            //             ],
            //             headingbuletslheap1: "Advantages for Patients:",
            //             bulletPoints0spunchlheap1: [
            //                 "Continuity of Care: Ensures seamless transition in rehabilitation without interruptions.",
            //                 "Convenience and Accessibility: Allows therapy access from home at any time.",
            //                 "Adherence and Progress: Promotes consistent treatment adherence and ensures steady progress.",
            //                 "Mobility Solutions: Helps avoid travel challenges, especially for those with mobility issues.",
            //                 "Enhanced Engagement: Creates a comfortable environment at home that contributes to better outcomes."
            //             ],




            //             mainhigh: [
            //                 {
            //                     id: 1,
            //                     logo: <CiMedicalCross />,
            //                     title: "heading first"
            //                 },
            //                 {
            //                     id: 2,
            //                     logo: <LuSunMedium />,
            //                     title: "heading second",
            //                 },
            //                 {
            //                     id: 3,
            //                     logo: <CiMedicalMask />,
            //                     title: "heading third",
            //                 },
            //                 {
            //                     id: 4,
            //                     logo: <FaBacteria />,
            //                     title: "heading fourth",
            //                 },
            //             ],
            //             mainfet: [
            //                 {
            //                     id: 1,
            //                     desc: "this is first features"
            //                 },
            //                 {
            //                     id: 2,
            //                     desc: "this is second features"
            //                 },
            //                 {
            //                     id: 3,
            //                     desc: "this is third features"
            //                 },
            //                 {
            //                     id: 4,
            //                     desc: "this is fourth features"
            //                 },
            //                 {
            //                     id: 4,
            //                     desc: "this is fifth features"
            //                 },
            //                 {
            //                     id: 4,
            //                     desc: "this is sixth features"
            //                 },
            //             ],
            //             feature: [
            //                 {
            //                     id: 1,
            //                     title: "this is title",
            //                     desc: "this is description",
            //                     cover: require("../../Assets/Products/Rehabilitation/headapp fet.webp"),
            //                     linkname: "headapp",
            //                     link: "https://headapp.in/",
            //                 }
            //             ],
            //             highlights: [
            //                 {
            //                     id: 1,
            //                     cover: require("../../Assets/Products/Rehabilitation/headapp h1.png"),
            //                 },
            //                 {
            //                     id: 2,
            //                     cover: require("../../Assets/Products/Rehabilitation/headapp h2.png"),
            //                 },
            //             ],
            //         },
            //     ]
            // },
        ],
    },
]

export default CategoriesData